import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { useSearchParams, useParams, usePathname, useRouter as useRouter$1 } from 'next/navigation';
import Script from 'next/script';
import require$$0, { useContext, useMemo, useCallback, useRef, useEffect, useState, createContext } from 'react';
import { CasinoGameTypeEnum, MainMarketsMap, SiteVerificationMethod, HomePageSectionsEnum, isJsonString, AffiliateTracker, DAY_IN_MS, ChatServiceNameEnum, CurrencySymbolsMap, CountryISO2Mapping, factorial, sumOfOddsSubsets, AllCountries, TemplateIdsMap, sortByNumberBetweenBrackets, sortByNumberAfterLastSpace, getMarketGroupId, MarketGroupData, sortSports, HOUR_IN_MS as HOUR_IN_MS$1, LETTERS_OR_DIGITS, EMAIL_REGEX, DIGIT_REGEX, NO_DIGIT_REGEX, LETTERS_REGEX, NO_LETTERS_REGEX, WHITESPACE_REGEX, LETTERS_OR_DIGITS_BRAZILIAN_REGEX } from '@finbackoffice/fe-core';
import { ClientBFFClient } from '@finbackoffice/clientbff-client';
import { AxiosLikeErrorMiddleware, StringFilterExpression, FilterKind, ComparisonFilterExpression, FilterCondition, Order, ChoicesFilterExpression } from '@finbackoffice/http-client';
import { MarketOutcomeStatus, MarketStatus, TicketType, SignupInputFieldName, PopupTags, TranslationScopes, Language, UserStatus, WalletType, isCryptoCurrency, FiatCurrencies, BonusType, BonusVertical, DocumentType, Currency, OddsChangeMode, DepositStatus, PaymentProvider, WithdrawalStatus, PixApiProvider, PixAddressType, DepositLimitPeriodInterval } from '@finbackoffice/enums';
import { I18nextProvider as I18nextProvider$1, initReactI18next, useTranslation } from 'react-i18next';
import i18next from 'i18next';
import { useRouter } from 'next/router';
import { HoursRange } from '@finbackoffice/websocket-client';
import { endOfDay } from 'date-fns';
import { useForm } from 'react-hook-form';
import { object, string, bool, ref, number } from 'yup';

function useRuntimeConfig(key) {
    const context = useContext(RuntimeConfigContext);
    return context[key];
}

const useSiteConfig = (name) => {
    const SITE_CONFIG = useRuntimeConfig("SITE_CONFIG");
    return SITE_CONFIG[name];
};

const useAccountConfig = (fields) => {
    const siteAccountFieldsConfig = useSiteConfig("accountFields");
    const accountConfig = useMemo(() => siteAccountFieldsConfig.filter((field) => field.enable) || null, [siteAccountFieldsConfig]);
    const accountConfigObj = useMemo(() => {
        const result = {};
        accountConfig === null || accountConfig === void 0 ? void 0 : accountConfig.forEach((item) => {
            if (item.enable && (fields ? fields.includes(item.name) : true)) {
                result[item.name] = item;
            }
        });
        return result;
    }, [accountConfig, fields]);
    return { accountConfigObj, accountConfig };
};

const useAccountConfigV2 = (fields) => {
    const siteAccountFieldsConfig = useSiteConfig("accountFields");
    const accountConfig = useMemo(() => siteAccountFieldsConfig.filter((field) => field.enable) || null, [siteAccountFieldsConfig]);
    const accountConfigObj = useMemo(() => {
        const result = {};
        accountConfig === null || accountConfig === void 0 ? void 0 : accountConfig.forEach((item) => {
            if (item.enable && (fields ? fields.includes(item.name) : true)) {
                result[item.name] = item;
            }
        });
        return result;
    }, [accountConfig, fields]);
    return { accountConfigObj, accountConfig };
};

var ErrorColors;
(function (ErrorColors) {
    ErrorColors["RED"] = "red";
    ErrorColors["GREEN"] = "green";
    ErrorColors["ORANGE"] = "orange";
})(ErrorColors || (ErrorColors = {}));
const BetSlipErrorKeys = {
    min_bet_error: "min_bet_error",
    max_bet_error: "max_bet_error",
    max_win_error: "max_win_error",
    bet_max_min_bet: "bet_max_min_bet",
    select_another_price: "select_another_price",
    special_requirements: "special_requirements",
    mts_error: "mts_error",
};
const ErrorKeys = {
    SELECT_BET: "betSlip_selectBetError",
    BET_CHANGE: "betSlip_betChangeError",
    MAX_SELECTIONS: "betSlip_maxSelectionsError",
    STAKE_LESS: "betSlip_stakeLessError",
    LOGIN_ERROR: "betSlip_loginError",
    NOT_ENOUGH_BALANCE: "betSlip_notEnoughBalance",
    MULTIPLE_BET_PICK_REACHED_MIN_REQUIREMENT: "betSlip_multipleBetPickReachedMinRequirementError",
    MULTIPLE_BET_MIN: "betSlip_multipleBetMinError",
    MAX_ODDS: "betSlip_maxOddsError",
    POSSIBLE_WIN_MAX: "betSlip_possibleWinMaxError",
    SYSTEM_BET_MIN: "betSlip_systemBetMinError",
};
const ERROR_CODES = {
    mts: {
        match: [401, 402, 440],
        outcomeChanged: [421, 420, 422, 423, 430, 431, 432, 433, 441],
        notActive: [403, 404, 405, 406, 407, 408, 409, 410, 442],
    },
};
const NEED_TO_REMOVE_ERROR_CODES = [...ERROR_CODES.mts.match, ...ERROR_CODES.mts.notActive];
const OUTCOME_CHANGED_ERROR_CODES = ERROR_CODES.mts.outcomeChanged;
const DEFAULT_RESULTS = {
    placeBetButtonEnabled: true,
    showAcceptButton: false,
    error: null,
    betItemErrors: [],
};
const useBetValidation = () => {
    const isErrorNeedToRemove = useCallback((errorCode) => (errorCode && NEED_TO_REMOVE_ERROR_CODES.includes(errorCode)) ||
        (errorCode && errorCode >= 100 && errorCode <= 400) ||
        (errorCode && errorCode >= 500 && errorCode <= 800), []);
    const isMtsError = useCallback((err) => err === BetSlipErrorKeys.mts_error, []);
    const outcomeRemoved = useCallback((outcomeStatus) => outcomeStatus === MarketOutcomeStatus.NotActive, []);
    const needToRemove = useCallback((marketStatus, outcomeStatus) => [MarketStatus.OnHold, MarketStatus.WaitingForResult, MarketStatus.Settled].indexOf(marketStatus) !== -1 || outcomeRemoved(outcomeStatus), [outcomeRemoved]);
    const isErrorOutcomeChanged = useCallback((errorCode) => errorCode && OUTCOME_CHANGED_ERROR_CODES.includes(errorCode), []);
    const isOutcomeChanged = useCallback((item) => item.outcomeInitValue !== item.outcomeValue, []);
    const filterAccepted = useCallback((betItems) => betItems.filter((item) => !item.accepted), []);
    const getChangedBets = useCallback((betItems) => betItems.filter((item) => {
        var _a;
        return !item.accepted &&
            (isOutcomeChanged(item) || isErrorOutcomeChanged((_a = item.error) === null || _a === void 0 ? void 0 : _a.code));
    }), [isErrorOutcomeChanged, isOutcomeChanged]);
    const getRemovableBets = useCallback((betItems) => betItems.filter((item) => {
        var _a, _b;
        return !item.accepted &&
            (needToRemove(item.marketStatus, item.outcomeStatus) ||
                (isMtsError((_a = item.error) === null || _a === void 0 ? void 0 : _a.error) && isErrorNeedToRemove((_b = item.error) === null || _b === void 0 ? void 0 : _b.code)));
    }), [isErrorNeedToRemove, isMtsError, needToRemove]);
    const isBetSlipEmpty = useCallback((betItems) => filterAccepted(betItems).length === 0, [filterAccepted]);
    const getEmptyStakeBets = useCallback((betItems) => betItems.filter((item) => !item.accepted && !item.stake), []);
    const getBetsWithPickReached = useCallback((betItems) => betItems.filter((item) => {
        var _a, _b;
        return !item.accepted &&
            item.limits &&
            parseFloat((_a = item.limits) === null || _a === void 0 ? void 0 : _a.amount) < parseFloat((_b = item.limits) === null || _b === void 0 ? void 0 : _b.min_bet);
    }), []);
    const isStakeLessThanMinBet = useCallback((stake, minBet) => stake < minBet, []);
    const getBetsWithLessStakeThanMinBet = useCallback((betItems) => betItems.filter((item) => !item.accepted &&
        item.limits &&
        isStakeLessThanMinBet(parseFloat(item.stake), parseFloat(item.limits.min_bet))), [isStakeLessThanMinBet]);
    const isBalanceEnough = useCallback((stake, balance) => stake <= balance, []);
    const isExpressItemsAmountMinValid = useCallback((minCount, betItems) => filterAccepted(betItems).length >= minCount, [filterAccepted]);
    const isSystemItemsAmountMinValid = useCallback((minCount, betItems) => filterAccepted(betItems).length >= minCount, [filterAccepted]);
    const isSelectionsAmountMaxValid = useCallback((betItems, max) => filterAccepted(betItems).length <= max, [filterAccepted]);
    const isPossibleWinValid = useCallback((stake, totalOdds, maxWin) => stake * totalOdds <= maxWin, []);
    const isMaxOddsValid = useCallback((totalOdds, maxOdds) => totalOdds <= maxOdds, []);
    const doesAnyBetHaveError = useCallback((betItems, betError) => betItems.some((item) => { var _a, _b; return !item.accepted && Boolean((_a = item.error) === null || _a === void 0 ? void 0 : _a.error) && Boolean((_b = item.error) === null || _b === void 0 ? void 0 : _b.visible); }) ||
        (!!(betError === null || betError === void 0 ? void 0 : betError.error) && betError.visible), []);
    const performSingleBetValidate = useCallback((betItems, configs) => {
        var _a;
        const betsWithPickReached = getBetsWithPickReached(betItems);
        if (betsWithPickReached.length) {
            const betItemErrors = [];
            betsWithPickReached.forEach((item) => {
                if (!item.error) {
                    betItemErrors.push({
                        outcomeId: item.outcomeId,
                        error: {
                            error: "select_another_price",
                            isPositive: false,
                            visible: true,
                        },
                    });
                }
            });
            return Object.assign(Object.assign({}, DEFAULT_RESULTS), { placeBetButtonEnabled: false, betItemErrors });
        }
        const emptyStakeBets = getEmptyStakeBets(betItems);
        const betsWithLessStakeThanMinBet = configs.isBetProcessorEnabled
            ? getBetsWithLessStakeThanMinBet(betItems)
            : [];
        if (Boolean(emptyStakeBets.length) || Boolean(betsWithLessStakeThanMinBet.length)) {
            return Object.assign(Object.assign({}, DEFAULT_RESULTS), { placeBetButtonEnabled: false, error: {
                    errorType: ErrorColors.RED,
                    errorKey: ErrorKeys.STAKE_LESS,
                } });
        }
        const totalStake = betItems.reduce((accumulator, currentValue) => accumulator + (currentValue.stake ? parseFloat(currentValue.stake) : 0), 0);
        if (configs.isLoggedIn &&
            !isBalanceEnough(totalStake, parseFloat(((_a = configs.currentWallet) === null || _a === void 0 ? void 0 : _a.balance) || "0"))) {
            return Object.assign(Object.assign({}, DEFAULT_RESULTS), { placeBetButtonEnabled: false, error: {
                    errorType: ErrorColors.RED,
                    errorKey: ErrorKeys.NOT_ENOUGH_BALANCE,
                } });
        }
        return null;
    }, [
        getBetsWithLessStakeThanMinBet,
        getBetsWithPickReached,
        getEmptyStakeBets,
        isBalanceEnough,
    ]);
    const performExpressBetValidate = useCallback((commonSiteConfigs, betItems, configs) => {
        var _a;
        const betsWithPickReached = getBetsWithPickReached(betItems);
        if (Boolean(betsWithPickReached.length) && betItems.length < 4) {
            const betItemErrors = [];
            betsWithPickReached.forEach((item) => {
                var _a;
                if (((_a = item.error) === null || _a === void 0 ? void 0 : _a.error) !== BetSlipErrorKeys.special_requirements) {
                    betItemErrors.push({
                        outcomeId: item.outcomeId,
                        error: {
                            error: BetSlipErrorKeys.special_requirements,
                            isPositive: false,
                            visible: true,
                        },
                    });
                }
            });
            return Object.assign(Object.assign({}, DEFAULT_RESULTS), { placeBetButtonEnabled: false, error: {
                    errorType: ErrorColors.RED,
                    errorKey: ErrorKeys.MULTIPLE_BET_PICK_REACHED_MIN_REQUIREMENT,
                }, betItemErrors });
        }
        if (Boolean(betsWithPickReached.length) && betItems.length >= 4) {
            const betItemErrors = [];
            betsWithPickReached.forEach((item) => {
                if (item.error && !item.error.isPositive) {
                    betItemErrors.push({
                        outcomeId: item.outcomeId,
                        error: null,
                    });
                }
            });
            return Object.assign(Object.assign({}, DEFAULT_RESULTS), { betItemErrors });
        }
        if (!isExpressItemsAmountMinValid(commonSiteConfigs.betslip.expressMinCount, betItems)) {
            return Object.assign(Object.assign({}, DEFAULT_RESULTS), { placeBetButtonEnabled: false, error: {
                    errorType: ErrorColors.RED,
                    errorKey: ErrorKeys.MULTIPLE_BET_MIN,
                } });
        }
        if (configs.isBetProcessorEnabled &&
            !isMaxOddsValid(configs.totalOdds, configs.maxOdds)) {
            return Object.assign(Object.assign({}, DEFAULT_RESULTS), { placeBetButtonEnabled: false, error: {
                    errorType: ErrorColors.RED,
                    errorKey: ErrorKeys.MAX_ODDS,
                    replace: {
                        value: configs.maxOdds,
                    },
                } });
        }
        const stake = configs.multipleBetStake ? parseFloat(configs.multipleBetStake) : 0;
        if (!stake ||
            (configs.isBetProcessorEnabled && isStakeLessThanMinBet(stake, configs.minBet))) {
            return Object.assign(Object.assign({}, DEFAULT_RESULTS), { placeBetButtonEnabled: false, error: {
                    errorType: ErrorColors.RED,
                    errorKey: ErrorKeys.STAKE_LESS,
                } });
        }
        if (configs.isLoggedIn &&
            !isBalanceEnough(stake, parseFloat(((_a = configs.currentWallet) === null || _a === void 0 ? void 0 : _a.balance) || "0"))) {
            return Object.assign(Object.assign({}, DEFAULT_RESULTS), { placeBetButtonEnabled: false, error: {
                    errorType: ErrorColors.RED,
                    errorKey: ErrorKeys.NOT_ENOUGH_BALANCE,
                } });
        }
        if (configs.isBetProcessorEnabled &&
            !isPossibleWinValid(stake, configs.totalOdds, configs.siteMaxWin)) {
            return Object.assign(Object.assign({}, DEFAULT_RESULTS), { placeBetButtonEnabled: false, error: {
                    errorType: ErrorColors.RED,
                    errorKey: ErrorKeys.POSSIBLE_WIN_MAX,
                } });
        }
        return null;
    }, [
        getBetsWithPickReached,
        isBalanceEnough,
        isExpressItemsAmountMinValid,
        isMaxOddsValid,
        isPossibleWinValid,
        isStakeLessThanMinBet,
    ]);
    const performSystemBetValidate = useCallback((commonSiteConfigs, betItems, configs) => {
        var _a;
        const stake = configs.systemBetStake ? parseFloat(configs.systemBetStake) : 0;
        if (!isSystemItemsAmountMinValid(commonSiteConfigs.betslip.system.min, betItems)) {
            return Object.assign(Object.assign({}, DEFAULT_RESULTS), { placeBetButtonEnabled: false, error: {
                    errorType: ErrorColors.RED,
                    errorKey: ErrorKeys.SYSTEM_BET_MIN,
                } });
        }
        if (!stake ||
            (configs.isBetProcessorEnabled && isStakeLessThanMinBet(stake, configs.minBet))) {
            return Object.assign(Object.assign({}, DEFAULT_RESULTS), { placeBetButtonEnabled: false, error: {
                    errorType: ErrorColors.RED,
                    errorKey: ErrorKeys.STAKE_LESS,
                } });
        }
        if (configs.isLoggedIn &&
            !isBalanceEnough(stake * configs.systemBetVariants, parseFloat(((_a = configs.currentWallet) === null || _a === void 0 ? void 0 : _a.balance) || "0"))) {
            return Object.assign(Object.assign({}, DEFAULT_RESULTS), { placeBetButtonEnabled: false, error: {
                    errorType: ErrorColors.RED,
                    errorKey: ErrorKeys.NOT_ENOUGH_BALANCE,
                } });
        }
        if (configs.isBetProcessorEnabled &&
            !isPossibleWinValid(stake, configs.totalOdds, configs.siteMaxWin)) {
            return Object.assign(Object.assign({}, DEFAULT_RESULTS), { placeBetButtonEnabled: false, error: {
                    errorType: ErrorColors.RED,
                    errorKey: ErrorKeys.POSSIBLE_WIN_MAX,
                } });
        }
        return null;
    }, [isBalanceEnough, isPossibleWinValid, isStakeLessThanMinBet, isSystemItemsAmountMinValid]);
    const performBetValidate = useCallback((commonSiteConfigs, betItems, configs) => {
        const initialResult = DEFAULT_RESULTS;
        if (isBetSlipEmpty(betItems)) {
            return Object.assign(Object.assign({}, initialResult), { placeBetButtonEnabled: false, error: {
                    errorType: ErrorColors.GREEN,
                    errorKey: ErrorKeys.SELECT_BET,
                } });
        }
        const changedBets = getChangedBets(betItems);
        const removableBets = getRemovableBets(betItems);
        if (Boolean(changedBets.length) || Boolean(removableBets.length)) {
            return Object.assign(Object.assign({}, initialResult), { placeBetButtonEnabled: false, showAcceptButton: true, error: {
                    errorType: ErrorColors.ORANGE,
                    errorKey: ErrorKeys.BET_CHANGE,
                } });
        }
        if (configs.isBetProcessorEnabled &&
            !isSelectionsAmountMaxValid(betItems, configs.maxSelections)) {
            return Object.assign(Object.assign({}, initialResult), { placeBetButtonEnabled: false, error: {
                    errorType: ErrorColors.RED,
                    errorKey: ErrorKeys.MAX_SELECTIONS,
                    replace: {
                        value: configs.maxSelections,
                    },
                } });
        }
        let result;
        switch (configs.betType) {
            case TicketType.Single:
                result = performSingleBetValidate(betItems, configs);
                break;
            case TicketType.Express:
                result = performExpressBetValidate(commonSiteConfigs, betItems, configs);
                break;
            case TicketType.System:
                result = performSystemBetValidate(commonSiteConfigs, betItems, configs);
                break;
        }
        if (result) {
            return result;
        }
        if (doesAnyBetHaveError(betItems, configs.betError)) {
            return Object.assign(Object.assign({}, initialResult), { placeBetButtonEnabled: false });
        }
        if (!configs.isLoggedIn) {
            return Object.assign(Object.assign({}, initialResult), { placeBetButtonEnabled: false, error: {
                    errorType: ErrorColors.GREEN,
                    errorKey: ErrorKeys.LOGIN_ERROR,
                } });
        }
        return initialResult;
    }, [
        doesAnyBetHaveError,
        getChangedBets,
        getRemovableBets,
        isBetSlipEmpty,
        isSelectionsAmountMaxValid,
        performExpressBetValidate,
        performSingleBetValidate,
        performSystemBetValidate,
    ]);
    const validateStake = useCallback((stake, error, limits) => {
        let visible = false;
        if (!!(error === null || error === void 0 ? void 0 : error.error)) {
            if (error.error === BetSlipErrorKeys.max_bet_error && error.isPositive) {
                if (limits && parseFloat(stake) > parseFloat(limits.amount)) {
                    visible = true;
                }
                return Object.assign(Object.assign({}, error), { visible });
            }
            if (error.error === BetSlipErrorKeys.min_bet_error && error.isPositive) {
                if (limits && parseFloat(stake) < parseFloat(limits.min_bet)) {
                    visible = true;
                }
                return Object.assign(Object.assign({}, error), { visible });
            }
        }
        return null;
    }, []);
    const performBetItemValidate = useCallback((bet, configs) => {
        var _a, _b;
        if (isOutcomeChanged(bet) ||
            isErrorOutcomeChanged((_a = bet.error) === null || _a === void 0 ? void 0 : _a.code) ||
            needToRemove(bet.marketStatus, bet.outcomeStatus) ||
            isErrorNeedToRemove((_b = bet.error) === null || _b === void 0 ? void 0 : _b.code) ||
            bet.stake === "" ||
            (configs.isBetProcessorEnabled &&
                bet.limits &&
                isStakeLessThanMinBet(parseFloat(bet.stake), parseFloat(bet.limits.min_bet))) ||
            (configs.currentWallet &&
                !isBalanceEnough(parseFloat(bet.stake), parseFloat(configs.currentWallet.balance || "0"))) ||
            !configs.isLoggedIn) {
            return { placeBetDisabled: true };
        }
        return { placeBetDisabled: false };
    }, [
        isBalanceEnough,
        isErrorNeedToRemove,
        isErrorOutcomeChanged,
        isOutcomeChanged,
        isStakeLessThanMinBet,
        needToRemove,
    ]);
    const validationRules = useMemo(() => ({
        getChangedBets,
        getRemovableBets,
        isBetSlipEmpty,
        getEmptyStakeBets,
        getBetsWithPickReached,
        getBetsWithLessStakeThanMinBet,
        isStakeLessThanMinBet,
        isBalanceEnough,
        isExpressItemsAmountMinValid,
        isSystemItemsAmountMinValid,
        isSelectionsAmountMaxValid,
        isPossibleWinValid,
        isMaxOddsValid,
        doesAnyBetHaveError,
    }), [
        getChangedBets,
        getRemovableBets,
        isBetSlipEmpty,
        getEmptyStakeBets,
        getBetsWithPickReached,
        getBetsWithLessStakeThanMinBet,
        isStakeLessThanMinBet,
        isBalanceEnough,
        isExpressItemsAmountMinValid,
        isSystemItemsAmountMinValid,
        isSelectionsAmountMaxValid,
        isPossibleWinValid,
        isMaxOddsValid,
        doesAnyBetHaveError,
    ]);
    return {
        isErrorNeedToRemove,
        isMtsError,
        outcomeRemoved,
        needToRemove,
        isErrorOutcomeChanged,
        isOutcomeChanged,
        validationRules,
        performBetValidate,
        validateStake,
        performBetItemValidate,
    };
};

const useBonusPagesConfig = () => {
    const COMMON_SITE_CONFIGS = useRuntimeConfig("COMMON_SITE_CONFIGS");
    const enabledBonusesConfig = useMemo(() => { var _a; return (_a = COMMON_SITE_CONFIGS === null || COMMON_SITE_CONFIGS === void 0 ? void 0 : COMMON_SITE_CONFIGS._bonuses) === null || _a === void 0 ? void 0 : _a.filter((config) => config.enable); }, [COMMON_SITE_CONFIGS._bonuses]);
    return enabledBonusesConfig;
};

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

const DEFAULT_PAGINATION = {
    items_per_page: 10,
    page: 1,
};

const usePrevious = (value) => {
    const ref = useRef(undefined);
    useEffect(() => {
        ref.current = value;
    }, [value]);
    return ref.current;
};

var CasinoScopeEnum;
(function (CasinoScopeEnum) {
    CasinoScopeEnum["LIVE_CASINO"] = "livecasino";
    CasinoScopeEnum["SLOTS"] = "slots";
})(CasinoScopeEnum || (CasinoScopeEnum = {}));
const CasinoScopesMap = {
    [CasinoScopeEnum.SLOTS]: [
        CasinoGameTypeEnum.VIDEO_SLOTS,
        CasinoGameTypeEnum.TABLE_GAMES,
        CasinoGameTypeEnum.FAST_GAMES,
        CasinoGameTypeEnum.CRASH_GAMES,
        CasinoGameTypeEnum.VIDEO_BINGO,
        CasinoGameTypeEnum.VIDEO_POKER,
        CasinoGameTypeEnum.SCRATCH_CARDS,
        CasinoGameTypeEnum.VIRTUAL_GAMES,
        CasinoGameTypeEnum.VIRTUAL_SPORTS,
        CasinoGameTypeEnum.LIVE_GAMES,
    ],
    [CasinoScopeEnum.LIVE_CASINO]: [
        CasinoGameTypeEnum.LIVE_CASINO,
        CasinoGameTypeEnum.LIVE_CASINO_V2,
        CasinoGameTypeEnum.LIVE_CASINO_TABLE,
    ],
};
const useCasinoGames = (gameTypes, tag, provider, options) => {
    const { megaways, bonusbuy, has_jackpot, gameName, gameId, defaultPagination, mobile, onError, } = options !== null && options !== void 0 ? options : {};
    const client = useContext(ClientBFFContext);
    const [casinoGamesState, setCasinoGamesState] = useState({
        games: [],
        totalCount: 0,
        loading: true,
    });
    const [pagination, setPagination] = useState(Object.assign(Object.assign({}, DEFAULT_PAGINATION), defaultPagination));
    const prevGameName = usePrevious(gameName);
    const timeoutRef = useRef(null);
    useEffect(() => {
        let isMounted = true;
        const loadData = () => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            const params = {
                page: pagination.page,
                items_per_page: pagination.items_per_page,
                mobile: !!mobile,
                megaways: !!megaways,
                bonusbuy: !!bonusbuy,
                has_jackpot: !!has_jackpot,
                types: gameTypes.map((type) => type.toString()),
                tag: tag || undefined,
                category: provider === "All" ? undefined : provider,
                name: gameName,
                id: gameId,
            };
            setCasinoGamesState((state) => (Object.assign(Object.assign({}, state), { loading: true })));
            try {
                const response = yield client.getCasinoGames(params);
                if (isMounted) {
                    if (!response.items.length) {
                        onError === null || onError === void 0 ? void 0 : onError({
                            error: "info",
                            message: "There is no games at this moment!",
                        });
                    }
                    setCasinoGamesState((state) => (Object.assign(Object.assign({}, state), { games: [...state.games, ...response.items], totalCount: response.total_count, loading: false })));
                }
            }
            catch (err) {
                const error = (_a = err.response) === null || _a === void 0 ? void 0 : _a.data;
                if (isMounted) {
                    onError === null || onError === void 0 ? void 0 : onError(error);
                    setCasinoGamesState((state) => (Object.assign(Object.assign({}, state), { loading: false })));
                }
            }
        });
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        if (gameName || gameId || gameTypes.length || tag) {
            timeoutRef.current = setTimeout(() => {
                loadData();
            }, prevGameName !== gameName ? 500 : 0);
        }
        return () => {
            isMounted = false;
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        gameTypes,
        tag,
        gameName,
        gameId,
        provider,
        pagination.page,
        pagination.items_per_page,
        megaways,
        bonusbuy,
        has_jackpot,
    ]);
    useEffect(() => {
        if (pagination.page !== 1) {
            setPagination(DEFAULT_PAGINATION);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tag, gameTypes, provider, megaways, bonusbuy, has_jackpot]);
    useEffect(() => {
        setCasinoGamesState((state) => (Object.assign(Object.assign({}, state), { games: [] })));
    }, [gameTypes, tag, gameName, gameId, provider, megaways, bonusbuy, has_jackpot]);
    return {
        casinoGamesState,
        pagination,
        setPagination,
        hasMore: casinoGamesState.games.length !== casinoGamesState.totalCount,
    };
};

const useClickOutside = (ref, handler) => {
    useEffect(() => {
        const listener = (event) => {
            const el = ref === null || ref === void 0 ? void 0 : ref.current;
            if (!el || el.contains(event.target)) {
                return;
            }
            handler(event);
        };
        document.addEventListener("mousedown", listener);
        document.addEventListener("touchstart", listener);
        return () => {
            document.removeEventListener("mousedown", listener);
            document.removeEventListener("touchstart", listener);
        };
    }, [ref, handler]);
};

const useCollapseHeight = (defaultOpened, defaultTransitionDuration = 600) => {
    const headerRef = useRef(null);
    const containerRef = useRef(null);
    const [opened, setOpened] = useState(defaultOpened);
    const [animating, setAnimating] = useState(false);
    const isMounted = useRef(false);
    const open = () => {
        setAnimating(true);
        setOpened(true);
    };
    const close = () => {
        setAnimating(true);
        setOpened(false);
    };
    useEffect(() => {
        const container = containerRef.current;
        if (container && isMounted.current) {
            let transitionDuration = defaultTransitionDuration;
            if (container.offsetHeight < 150) {
                transitionDuration = 300;
            }
            container.ontransitionend = () => {
                setAnimating(false);
            };
            container.style.transitionDuration = `${transitionDuration}ms`;
            container.style.transitionProperty = "height";
            container.style.transitionTimingFunction = "cubic-bezier(0.19, 0.9, 0.22, 0.9)";
            container.style.overflow = "hidden";
            if (opened) {
                requestAnimationFrame(() => {
                    container.style.height = "0px";
                    requestAnimationFrame(() => {
                        container.style.height = `${container.scrollHeight}px`;
                    });
                });
            }
            else {
                container.style.height = "0px";
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [opened]);
    useEffect(() => {
        const ref = headerRef.current;
        const handleHeaderClick = () => {
            setOpened((open) => !open);
            setAnimating(true);
        };
        if (!isMounted.current) {
            isMounted.current = true;
            if (ref) {
                ref.addEventListener("click", handleHeaderClick);
            }
            const container = containerRef.current;
            if (container && defaultOpened) {
                container.style.height = `${container.scrollHeight}px`;
            }
        }
        return () => {
            if (ref) {
                ref.removeEventListener("click", handleHeaderClick);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return { opened, animating, headerRef, containerRef, open, close };
};

const useCollapseMargin = (defaultOpened, defaultTransitionDuration = 600) => {
    const headerRef = useRef(null);
    const containerRef = useRef(null);
    const [opened, setOpened] = useState(defaultOpened);
    const [animating, setAnimating] = useState(false);
    const isMounted = useRef(false);
    const open = () => {
        setOpened(true);
        setAnimating(true);
    };
    const close = () => {
        setOpened(false);
        setAnimating(true);
    };
    useEffect(() => {
        const container = containerRef.current;
        if (container && isMounted.current) {
            let transitionDuration = defaultTransitionDuration;
            if (container.offsetHeight < 150) {
                transitionDuration = 300;
            }
            container.ontransitionend = () => {
                setAnimating(false);
            };
            container.style.transitionProperty = "margin-top";
            if (opened) {
                requestAnimationFrame(() => {
                    container.style.transitionTimingFunction = "cubic-bezier(0.19, 0.9, 0.22, 0.9)";
                    container.style.display = "block";
                    container.style.marginTop = `-${container.offsetHeight}px`;
                    requestAnimationFrame(() => {
                        container.style.transitionDuration = `${transitionDuration}ms`;
                        container.style.marginTop = "0px";
                    });
                });
            }
            else {
                container.style.transitionTimingFunction = "ease-in-out";
                container.style.transitionDuration = `${transitionDuration}ms`;
                container.style.marginTop = `-${container === null || container === void 0 ? void 0 : container.offsetHeight}px`;
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [opened]);
    useEffect(() => {
        const ref = headerRef.current;
        const handleHeaderClick = (e) => {
            const target = e.target;
            if (!target.closest("button")) {
                setOpened((open) => !open);
                setAnimating(true);
            }
        };
        if (!isMounted.current) {
            isMounted.current = true;
            if (ref) {
                ref.addEventListener("click", handleHeaderClick);
            }
            const container = containerRef.current;
            if (container && defaultOpened) {
                container.style.display = "block";
            }
        }
        return () => {
            if (ref) {
                ref.removeEventListener("click", handleHeaderClick);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return { opened, animating, headerRef, containerRef, open, close };
};

// Source => https://raw.githubusercontent.com/dr5hn/countries-states-cities-database/refs/heads/master/json/countries%2Bstates.json
// Zip codes Source => https://gist.github.com/jamesbar2/1c677c22df8f21e869cca7e439fc3f5b
const useCountryStates = (enable, countryCode) => {
    const COMMON_SITE_CONFIGS = useRuntimeConfig("COMMON_SITE_CONFIGS");
    const supportedCountries = COMMON_SITE_CONFIGS.country.supported;
    const [countryStates, setCountryStates] = useState({
        loading: false,
        states: [],
    });
    useEffect(() => {
        /* const loadStates = async (country: Country) => {
            // console.log(AllStates);

            const headers = new Headers();
            headers.append("X-CSCAPI-KEY", StatesAPIToken);

            const requestOptions = {
                method: "GET",
                headers: headers,
                // redirect: "follow",
            };
            const response = await fetch(
                `https://api.countrystatecity.in/v1/countries/${CountryISO2Mapping[country]}/states`,
                requestOptions,
            );
            console.log(response);
        }; */
        const loadStates = (countryCode) => __awaiter(void 0, void 0, void 0, function* () {
            setCountryStates((state) => (Object.assign(Object.assign({}, state), { loading: true })));
            try {
                const response = yield fetch(`/api/country-states?country=${countryCode}`);
                if (!response.ok) {
                    throw new Error("Failed to fetch states");
                }
                const countryStates = yield response.json();
                setCountryStates({
                    states: countryStates.items,
                    loading: false,
                });
            }
            catch (error) {
                console.error("Error fetching states:", error);
                setCountryStates((state) => (Object.assign(Object.assign({}, state), { loading: false })));
            }
        });
        if (enable && supportedCountries.includes(countryCode)) {
            loadStates(countryCode);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [countryCode]);
    return countryStates;
};

const useDidUpdateEffect = (callback, deps) => {
    const firstUpdate = useRef(false);
    useEffect(() => {
        if (firstUpdate.current)
            callback();
        else
            firstUpdate.current = true;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};

const useDocumentVisible = (enable) => {
    const [documentVisible, setDocumentVisible] = useState("visible");
    useEffect(() => {
        const handleVisibilityChange = () => setDocumentVisible(document.visibilityState);
        if (enable) {
            document.addEventListener("visibilitychange", handleVisibilityChange);
        }
        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, [enable]);
    return documentVisible === "visible";
};

const useWebsocketUpdates = (event, handler, subscribeByDefault = true, ...payload) => {
    const { connected, socketClient, debug } = useContext(WebsocketContext);
    const [isActive, setIsActive] = useState(subscribeByDefault);
    useEffect(() => {
        if (connected && isActive) {
            if (debug)
                console.debug("subscribe", event);
            socketClient.on(event, handler, ...payload);
        }
        return () => {
            if (connected && isActive) {
                if (debug)
                    console.debug("unsubscribe", event);
                socketClient.off(event, handler);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [connected, socketClient, isActive, handler, ...payload]);
    return {
        subscribe: useCallback(() => setIsActive(true), []),
        unsubscribe: useCallback(() => setIsActive(false), []),
    };
};

const useFindReferral = () => {
    const client = useContext(ClientBFFContext);
    const [referralUserSlugState, setReferralUserSlugState] = useState({
        slug: "",
        loading: false,
    });
    const findReferral = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        setReferralUserSlugState((state) => (Object.assign(Object.assign({}, state), { loading: true })));
        let response = {};
        try {
            response = yield client.findReferral();
        }
        catch (error) {
            setReferralUserSlugState((state) => (Object.assign(Object.assign({}, state), { slug: null, loading: false })));
        }
        finally {
            if (response === null || response === void 0 ? void 0 : response.slug) {
                setReferralUserSlugState((state) => (Object.assign(Object.assign({}, state), { slug: response.slug, loading: false })));
            }
        }
    }), [client]);
    return Object.assign(Object.assign({}, referralUserSlugState), { findReferral });
};

var GtagEvents;
(function (GtagEvents) {
    GtagEvents["ReelsModalOpen"] = "reels_modal_open";
    GtagEvents["ReelsShare"] = "reels_share";
    GtagEvents["ReelsModalPlay"] = "reels_modal_play";
    GtagEvents["CpfSignupOpen"] = "cpf_open";
    GtagEvents["CpfSignupSubmitCpf"] = "cpf_submit";
    GtagEvents["CpfSignupSuccess"] = "cpf_success";
    GtagEvents["CpfSignupSubmitError"] = "cpf_error";
    GtagEvents["SignupSubmit"] = "reg_submit";
    GtagEvents["SignupSuccess"] = "reg_success";
    GtagEvents["SignupError"] = "reg_error";
    GtagEvents["SignupOpen"] = "reg_open";
})(GtagEvents || (GtagEvents = {}));
const useGtag = () => {
    const fireEvent = useCallback((name, payload) => {
        if (typeof window.gtag === "function") {
            window.gtag("event", name, payload);
        }
    }, []);
    return {
        fireEvent,
    };
};

const isProduction$1 = process.env.NODE_ENV === "production";
const useHost = () => {
    const DOMAIN = useRuntimeConfig("DOMAIN");
    const protocol = isProduction$1 ? "https" : "http";
    const { defaultLocale, asPath, locale } = useRouter();
    const hostWithProtocol = `${protocol}://${DOMAIN}`;
    const originWithLocale = defaultLocale === locale ? hostWithProtocol : `${hostWithProtocol}/${locale}`;
    return {
        origin: hostWithProtocol,
        originWithLocale,
        domain: DOMAIN,
        fullPath: `${originWithLocale}${asPath !== "/" ? asPath : ""}`,
    };
};

const formatSearchParamsToString = (record) => {
    var _a;
    return (_a = Object.entries(record)
        .map(([k, v]) => `${k}=${v}`)) === null || _a === void 0 ? void 0 : _a.join("&");
};
const useSearchParamsQuery = () => {
    const searchParams = useSearchParams();
    const query = useMemo(() => {
        const q = {};
        searchParams === null || searchParams === void 0 ? void 0 : searchParams.forEach((value, key) => {
            q[key] = value;
        });
        return q;
    }, [searchParams]);
    const getQueryString = useCallback(() => {
        return formatSearchParamsToString(query);
    }, [query]);
    return { query, searchParams, getQueryString };
};

const usePathnameWithLocal = () => {
    const { getQueryString } = useSearchParamsQuery();
    const params = useParams();
    const pathname = usePathname();
    const pathnameWithoutLocal = pathname.replace(`/${params.lang}`, "");
    const pathnameValues = pathnameWithoutLocal.split("/").filter((v) => Boolean(v));
    const path = `/${pathnameValues.join("/")}`;
    return useMemo(() => {
        return {
            path,
            pathname,
            pathnameValues: path.split("/").filter((v) => Boolean(v)),
            lang: params === null || params === void 0 ? void 0 : params.lang,
            fullPath: `${pathnameWithoutLocal}${!!getQueryString() ? `?${getQueryString()}` : ""}`,
        };
    }, [getQueryString, params === null || params === void 0 ? void 0 : params.lang, path, pathname, pathnameWithoutLocal]);
};

const isProduction = process.env.NODE_ENV === "production";
// @TODO debug is correctly working
const useHostV2 = () => {
    const { path: asPath, lang } = usePathnameWithLocal(); // refactor
    const DOMAIN = useRuntimeConfig("DOMAIN");
    const DEFAULT_LOCALE = useRuntimeConfig("COMMON_SITE_CONFIGS").defaultLocale;
    const protocol = isProduction ? "https" : "http";
    const hostWithProtocol = `${protocol}://${DOMAIN}`;
    const originWithLocale = DEFAULT_LOCALE === lang ? hostWithProtocol : `${hostWithProtocol}/${lang}`;
    return {
        origin: hostWithProtocol,
        originWithLocale,
        domain: DOMAIN,
        fullPath: `${originWithLocale}${asPath !== "/" ? asPath : ""}`,
    };
};

const useLayoutProfileConfig = (name, nestedSectionName) => {
    const siteLayoutsConfig = useSiteConfig("layouts");
    const sectionConfig = useMemo(() => {
        return (siteLayoutsConfig.profile.config.find((section) => section.name === name && section.enable) || null);
    }, [name, siteLayoutsConfig.profile.config]);
    const nestedSectionConfig = useMemo(() => {
        var _a;
        return (((_a = sectionConfig === null || sectionConfig === void 0 ? void 0 : sectionConfig.config) === null || _a === void 0 ? void 0 : _a.find((section) => section.name === nestedSectionName && section.enable)) || null);
    }, [nestedSectionName, sectionConfig === null || sectionConfig === void 0 ? void 0 : sectionConfig.config]);
    const allConfigs = useMemo(() => siteLayoutsConfig.profile.config.filter((config) => config.enable), [siteLayoutsConfig.profile.config]);
    return {
        allConfigs,
        config: nestedSectionName ? nestedSectionConfig : sectionConfig,
    };
};

const useLayoutCasinoConfig = (section) => {
    const siteLayoutsConfig = useSiteConfig("layouts");
    const sectionConfig = useMemo(() => {
        return siteLayoutsConfig._casino.sections[section];
    }, [section, siteLayoutsConfig._casino.sections]);
    const casinoFiltersConfig = useMemo(() => { var _a; return (_a = sectionConfig.filters) === null || _a === void 0 ? void 0 : _a.filter((config) => config.enable); }, [sectionConfig.filters]);
    const casinoWidgetsConfig = useMemo(() => { var _a; return (_a = sectionConfig.widgets) === null || _a === void 0 ? void 0 : _a.filter((config) => config.enable); }, [sectionConfig.widgets]);
    const casinoGamePageConfig = useMemo(() => sectionConfig.gamePage, [sectionConfig.gamePage]);
    return {
        casinoFiltersConfig,
        casinoWidgetsConfig,
        showWinners: sectionConfig.showWinners || false,
        casinoGamePageConfig,
    };
};

const useLazyLoad = (loading, setPagination, hasMore) => {
    const observer = useRef(null);
    const endRef = useCallback((node) => {
        if (loading)
            return;
        if (observer.current)
            observer.current.disconnect();
        observer.current = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting && hasMore) {
                setPagination((state) => (Object.assign(Object.assign({}, state), { page: state.page + 1 })));
            }
        });
        if (node)
            observer.current.observe(node);
    }, [loading, hasMore, setPagination]);
    return { endRef };
};

var OutcomeMagicNumbers;
(function (OutcomeMagicNumbers) {
    OutcomeMagicNumbers["HOME"] = "1";
    OutcomeMagicNumbers["DRAW"] = "X";
    OutcomeMagicNumbers["AWAY"] = "2";
})(OutcomeMagicNumbers || (OutcomeMagicNumbers = {}));
const useMainMarketOdds = (sportId, markets) => {
    var _a;
    const [mainMarket, setMainMarket] = useState();
    const [mainOdds, setMainOdds] = useState();
    const mainMarketName = (mainMarket === null || mainMarket === void 0 ? void 0 : mainMarket.name) || "";
    const mainMarketStatus = mainMarket === null || mainMarket === void 0 ? void 0 : mainMarket.status;
    const mainMarketTemplateId = (mainMarket === null || mainMarket === void 0 ? void 0 : mainMarket.template_id) || null;
    const mainMarketId = (mainMarket === null || mainMarket === void 0 ? void 0 : mainMarket.id) || null;
    const columnCount = ((_a = mainMarket === null || mainMarket === void 0 ? void 0 : mainMarket.outcomes_count) !== null && _a !== void 0 ? _a : 0) > 2 ? "three_columns" : "two_columns";
    useEffect(() => {
        const marketGroupId = MainMarketsMap[sportId];
        setMainMarket(markets === null || markets === void 0 ? void 0 : markets.find((market) => market.template_id === marketGroupId));
    }, [markets, sportId]);
    useEffect(() => {
        let homeOutcome = null;
        let drawOutcome = null;
        let awayOutcome = null;
        if (mainMarket) {
            mainMarket.outcomes.forEach((outcome) => {
                if (outcome.outcome_id === 2) {
                    drawOutcome = Object.assign(Object.assign({}, outcome), { name: OutcomeMagicNumbers.DRAW });
                }
                else if (!homeOutcome) {
                    homeOutcome = Object.assign(Object.assign({}, outcome), { name: OutcomeMagicNumbers.HOME });
                }
                else if (!awayOutcome) {
                    awayOutcome = Object.assign(Object.assign({}, outcome), { name: OutcomeMagicNumbers.AWAY });
                }
            });
        }
        setMainOdds({ homeOutcome, drawOutcome, awayOutcome });
    }, [mainMarket]);
    return {
        mainOdds,
        mainMarket,
        mainMarketName,
        mainMarketStatus,
        mainMarketTemplateId,
        mainMarketId,
        columnCount,
    };
};

const useOneStepCpfSignup = () => {
    const client = useContext(ClientBFFContext);
    const registerCPFUser = useCallback((data, cpfVerified) => __awaiter(void 0, void 0, void 0, function* () {
        if (cpfVerified) {
            return yield client.registerFromCPFNumber(data);
        }
        else {
            return yield client.registerFromCPFUser(data);
        }
    }), [client]);
    return { registerCPFUser };
};

const usePersonalDetailsVerificationConfig = () => {
    const COMMON_SITE_CONFIGS = useRuntimeConfig("COMMON_SITE_CONFIGS");
    const { userData } = useContext(UserAccountContextV2);
    const personalDetailsConfig = useMemo(() => COMMON_SITE_CONFIGS.verification.config.find((config) => config.name === SiteVerificationMethod.PersonalDetails), [COMMON_SITE_CONFIGS.verification.config]);
    const personalDetailsVerificationConfigObj = useMemo(() => {
        var _a;
        const result = {};
        (_a = personalDetailsConfig === null || personalDetailsConfig === void 0 ? void 0 : personalDetailsConfig.config) === null || _a === void 0 ? void 0 : _a.forEach((item) => {
            if (item.enable) {
                result[item.name] = item;
            }
        });
        return result;
    }, [personalDetailsConfig === null || personalDetailsConfig === void 0 ? void 0 : personalDetailsConfig.config]);
    const personalDetailsVerificationConfigMemo = useMemo(() => { var _a; return ((_a = personalDetailsConfig === null || personalDetailsConfig === void 0 ? void 0 : personalDetailsConfig.config) === null || _a === void 0 ? void 0 : _a.filter((field) => field.enable)) || []; }, [personalDetailsConfig === null || personalDetailsConfig === void 0 ? void 0 : personalDetailsConfig.config]);
    const needToVerify = useMemo(() => {
        if (!userData) {
            return;
        }
        const requiredFields = (personalDetailsVerificationConfigMemo === null || personalDetailsVerificationConfigMemo === void 0 ? void 0 : personalDetailsVerificationConfigMemo.filter((field) => field.required)) || [];
        const blankFields = [];
        requiredFields.forEach((field) => {
            const fieldName = field.name;
            if (fieldName in userData && !userData[fieldName]) {
                blankFields.push(fieldName);
            }
        });
        return !!blankFields.length;
    }, [personalDetailsVerificationConfigMemo, userData]);
    return {
        personalDetailsVerificationConfigObj,
        personalDetailsVerificationConfig: personalDetailsVerificationConfigMemo,
        needToVerify,
    };
};

const usePoliciesPagesConfig = () => {
    const COMMON_SITE_CONFIGS = useRuntimeConfig("COMMON_SITE_CONFIGS");
    const enabledPoliciesConfig = useMemo(() => COMMON_SITE_CONFIGS._policies.filter((config) => config.enable), [COMMON_SITE_CONFIGS._policies]);
    return enabledPoliciesConfig;
};

const usePrematchUpcomingWidgetConfig = () => {
    var _a, _b, _c;
    const prematchUpcomingWidgetConfig = (_c = (_b = (_a = useSiteConfig("layouts")) === null || _a === void 0 ? void 0 : _a.homePage) === null || _b === void 0 ? void 0 : _b.widgets) === null || _c === void 0 ? void 0 : _c.find((widget) => widget.name === HomePageSectionsEnum.PrematchUpcoming && widget.enable);
    if (prematchUpcomingWidgetConfig && !(prematchUpcomingWidgetConfig === null || prematchUpcomingWidgetConfig === void 0 ? void 0 : prematchUpcomingWidgetConfig.timeRange)) {
        prematchUpcomingWidgetConfig.timeRange = HoursRange.SIX;
    }
    return prematchUpcomingWidgetConfig;
};
const usePrematchTopWidgetConfig = () => {
    var _a, _b, _c;
    const prematchTopWidgetConfig = (_c = (_b = (_a = useSiteConfig("layouts")) === null || _a === void 0 ? void 0 : _a.homePage) === null || _b === void 0 ? void 0 : _b.widgets) === null || _c === void 0 ? void 0 : _c.find((widget) => widget.name === HomePageSectionsEnum.PrematchTop && widget.enable);
    return prematchTopWidgetConfig;
};
const useUpcomingLiveWidgetConfig = () => {
    var _a, _b, _c;
    const upcomingLiveWidgetConfig = (_c = (_b = (_a = useSiteConfig("layouts")) === null || _a === void 0 ? void 0 : _a.homePage) === null || _b === void 0 ? void 0 : _b.widgets) === null || _c === void 0 ? void 0 : _c.find((widget) => widget.name === HomePageSectionsEnum.LiveUpcoming && widget.enable);
    return upcomingLiveWidgetConfig;
};

const useProfileDetailsConfig = (fields) => {
    const SITE_CONFIG = useRuntimeConfig("SITE_CONFIG");
    const accountDetailsConfig = SITE_CONFIG._accountFields;
    const accountDetailsConfigCollections = useMemo(() => accountDetailsConfig.filter((config) => config.enable), [accountDetailsConfig]);
    const accountDetailsConfigObject = useMemo(() => {
        const result = {};
        accountDetailsConfigCollections === null || accountDetailsConfigCollections === void 0 ? void 0 : accountDetailsConfigCollections.forEach((collection) => {
            var _a;
            if (collection.config) {
                (_a = collection.config) === null || _a === void 0 ? void 0 : _a.forEach((config) => {
                    if (config.enable && (fields ? fields.includes(config.name) : true)) {
                        result[config.name] = config;
                    }
                });
            }
            else {
                if (collection.enable && (fields ? fields.includes(collection.name) : true)) {
                    result[collection.name] = collection;
                }
            }
        });
        return result;
    }, [accountDetailsConfigCollections, fields]);
    /*  const accountDetailsConfigArray = useMemo(() => {
        const result: AccountConfigType[] = [];

        accountDetailsConfigCollections?.forEach((collection) => {
            collection.config?.forEach((config) => {
                if (config.enable && (fields ? fields.includes(config.name) : true)) {
                    result.push(config)
                }
            });
        });

        return result;
    }, [accountDetailsConfigCollections, fields]) */
    return { accountDetailsConfigObject, accountDetailsConfigCollections };
};

const useSignupConfig = (fields) => {
    const siteSignupFieldsConfig = useSiteConfig("signupFields");
    const { siteRegistrationConfig } = useContext(ConfigContext);
    const signupConfig = useMemo(() => siteSignupFieldsConfig === null || siteSignupFieldsConfig === void 0 ? void 0 : siteSignupFieldsConfig.filter((field) => field.enable && (fields ? fields.includes(field.name) : true)), [fields, siteSignupFieldsConfig]);
    const signupConfigObj = useMemo(() => {
        const result = {};
        signupConfig === null || signupConfig === void 0 ? void 0 : signupConfig.forEach((item) => {
            if (item.name === SignupInputFieldName.Password) {
                item = Object.assign(Object.assign({}, item), { has_digit: (siteRegistrationConfig === null || siteRegistrationConfig === void 0 ? void 0 : siteRegistrationConfig.password_has_digit) || false, has_letter: (siteRegistrationConfig === null || siteRegistrationConfig === void 0 ? void 0 : siteRegistrationConfig.password_has_letter) || false });
            }
            if (item.enable && (fields ? fields.includes(item.name) : true)) {
                result[item.name] = item;
            }
        });
        return result;
    }, [
        fields,
        signupConfig,
        siteRegistrationConfig === null || siteRegistrationConfig === void 0 ? void 0 : siteRegistrationConfig.password_has_digit,
        siteRegistrationConfig === null || siteRegistrationConfig === void 0 ? void 0 : siteRegistrationConfig.password_has_letter,
    ]);
    return { signupConfigObj, signupConfig };
};

const useSignupConfigV2 = (fields) => {
    const siteSignupFieldsConfig = useSiteConfig("signupFields");
    const { siteRegistrationConfig } = useContext(ConfigContextV2); // refactor
    const signupConfig = useMemo(() => siteSignupFieldsConfig === null || siteSignupFieldsConfig === void 0 ? void 0 : siteSignupFieldsConfig.filter((field) => field.enable && (fields ? fields.includes(field.name) : true)), [fields, siteSignupFieldsConfig]);
    const signupConfigObj = useMemo(() => {
        const result = {};
        signupConfig === null || signupConfig === void 0 ? void 0 : signupConfig.forEach((item) => {
            if (item.name === SignupInputFieldName.Password) {
                item = Object.assign(Object.assign({}, item), { has_digit: (siteRegistrationConfig === null || siteRegistrationConfig === void 0 ? void 0 : siteRegistrationConfig.password_has_digit) || false, has_letter: (siteRegistrationConfig === null || siteRegistrationConfig === void 0 ? void 0 : siteRegistrationConfig.password_has_letter) || false });
            }
            if (item.enable && (fields ? fields.includes(item.name) : true)) {
                result[item.name] = item;
            }
        });
        return result;
    }, [
        fields,
        signupConfig,
        siteRegistrationConfig === null || siteRegistrationConfig === void 0 ? void 0 : siteRegistrationConfig.password_has_digit,
        siteRegistrationConfig === null || siteRegistrationConfig === void 0 ? void 0 : siteRegistrationConfig.password_has_letter,
    ]);
    return { signupConfigObj, signupConfig };
};

const useSportsbookConfig = () => {
    const sportsbookConfig = useSiteConfig("layouts").sportsbook;
    return sportsbookConfig || {};
};

const useVerificationMethods = () => {
    const COMMON_SITE_CONFIGS = useRuntimeConfig("COMMON_SITE_CONFIGS");
    const verificationMethods = useMemo(() => COMMON_SITE_CONFIGS.verification.config.filter((method) => method.enable), [COMMON_SITE_CONFIGS.verification.config]);
    return {
        verificationMethods,
    };
};

var BrowserStorageIdsEnum;
(function (BrowserStorageIdsEnum) {
    BrowserStorageIdsEnum["FAVORITE_EVENTS"] = "favoriteEvents";
    BrowserStorageIdsEnum["FAVORITE_LIVE_MARKETS_IDS"] = "favoriteLiveMarketsIds";
    BrowserStorageIdsEnum["FAVORITE_PREMATCH_MARKETS_IDS"] = "favoritePrematchMarketsIds";
    BrowserStorageIdsEnum["BET_ITEMS"] = "betItems";
    BrowserStorageIdsEnum["ODD_FORMAT"] = "oddFormat";
    BrowserStorageIdsEnum["WALLET"] = "wallet";
    BrowserStorageIdsEnum["DEVICE_ID"] = "deviceId";
    BrowserStorageIdsEnum["TOKEN"] = "token";
    BrowserStorageIdsEnum["SITE_NOTIFICATIONS"] = "siteNotifications";
    BrowserStorageIdsEnum["POPUP_BANNERS"] = "popupBanners";
    BrowserStorageIdsEnum["REELS"] = "reels";
    BrowserStorageIdsEnum["AFF_CLICK"] = "affclick";
    BrowserStorageIdsEnum["BTAG"] = "btag";
    BrowserStorageIdsEnum["UTM_CAMPAIGN"] = "utm_campaign";
})(BrowserStorageIdsEnum || (BrowserStorageIdsEnum = {}));
const BrowserStorageContext = createContext(null);
const BrowserStorageProvider = ({ children }) => {
    const get = useCallback((key) => {
        if (typeof window !== "undefined") {
            const storage = localStorage.getItem(key);
            if (storage) {
                if (isJsonString(storage)) {
                    return JSON.parse(storage);
                }
                else {
                    return storage;
                }
            }
        }
        return null;
    }, []);
    const set = useCallback((key, val) => {
        localStorage.setItem(key, val);
    }, []);
    const remove = useCallback((key) => {
        localStorage.removeItem(key);
    }, []);
    const value = useMemo(() => ({ get, set, remove }), [get, set, remove]);
    return (jsx(BrowserStorageContext.Provider, { value: value, children: children }));
};

const AffiliateTrackerContext = createContext(null);
const AffiliateTrackerProvider = ({ children }) => {
    const searchParams = useSearchParams();
    const COMMON_SITE_CONFIGS = useRuntimeConfig("COMMON_SITE_CONFIGS");
    const { get } = useContext(BrowserStorageContext);
    useEffect(() => {
        if (COMMON_SITE_CONFIGS.affiliateTracker.enable &&
            COMMON_SITE_CONFIGS.affiliateTracker.name === AffiliateTracker.Smartico &&
            searchParams.has(BrowserStorageIdsEnum.BTAG)) {
            sessionStorage.setItem(BrowserStorageIdsEnum.BTAG, searchParams.get(BrowserStorageIdsEnum.BTAG) || "");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const getTracker = useCallback(() => {
        switch (COMMON_SITE_CONFIGS.affiliateTracker.name) {
            case AffiliateTracker.Affise:
                if (get(BrowserStorageIdsEnum.AFF_CLICK)) {
                    return `${get(BrowserStorageIdsEnum.UTM_CAMPAIGN) ? `${get(BrowserStorageIdsEnum.UTM_CAMPAIGN)}-` : ""}${get(BrowserStorageIdsEnum.AFF_CLICK)}`;
                }
                return undefined;
            case AffiliateTracker.Smartico:
                if (typeof document !== "undefined" &&
                    sessionStorage.getItem(BrowserStorageIdsEnum.BTAG)) {
                    return sessionStorage.getItem(BrowserStorageIdsEnum.BTAG) || "";
                }
                return undefined;
            default:
                return undefined;
        }
    }, [COMMON_SITE_CONFIGS.affiliateTracker.name, get]);
    const triggerRegistration = useCallback(() => {
        if (COMMON_SITE_CONFIGS.affiliateTracker.name === AffiliateTracker.Affise) {
            affiseTriggerRegistration();
        }
    }, [COMMON_SITE_CONFIGS.affiliateTracker.name]);
    const value = useMemo(() => ({
        getTracker,
        triggerRegistration,
    }), [getTracker, triggerRegistration]);
    return (jsxs(AffiliateTrackerContext.Provider, { value: value, children: [COMMON_SITE_CONFIGS.affiliateTracker.enable &&
                COMMON_SITE_CONFIGS.affiliateTracker.name === AffiliateTracker.Affise && (jsx(AffiseInitScript, {})), children] }));
};

const HOUR_IN_MS = 60 * 60 * 1000;
const FavoriteEventsContext = createContext(null);
const FavoriteEventsProvider = ({ children, socketStorage, browserStorage, liveFeedReady, prematchFeedReady, }) => {
    const [favEvents, setFavEvents] = useState([]);
    const [favLiveLeagues, setFavLiveLeagues] = useState([]);
    const [favPrematchLeagues, setFavPrematchLeagues] = useState([]);
    const favLiveLeaguesGameCount = useMemo(() => favLiveLeagues.reduce((acc, league) => acc + league.games_count, 0), [favLiveLeagues]);
    const favPrematchLeaguesGameCount = useMemo(() => favEvents.filter((event) => Date.now() < event.timestamp).length, [favEvents]);
    useEffect(() => {
        const savedEvents = browserStorage.get(BrowserStorageIdsEnum.FAVORITE_EVENTS);
        if (savedEvents) {
            const activeEvents = savedEvents.filter((event) => Date.now() - event.timestamp < 4 * HOUR_IN_MS);
            setFavEvents(activeEvents);
            browserStorage.set(BrowserStorageIdsEnum.FAVORITE_EVENTS, JSON.stringify(activeEvents));
        }
        else {
            browserStorage.set(BrowserStorageIdsEnum.FAVORITE_EVENTS, JSON.stringify([]));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        if (liveFeedReady) {
            updateFavLiveLeagues();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [liveFeedReady]);
    const updateFavPrematchLeagues = useCallback(() => {
        const favPrematchLeaguesArr = [];
        favEvents.forEach((event) => {
            if (Date.now() < event.timestamp) {
                const favLeague = favPrematchLeaguesArr.find((league) => league.id === event.tournament_id);
                if (!favLeague) {
                    favPrematchLeaguesArr.push({
                        events: [event.id],
                        id: event.tournament_id,
                        games_count: 1,
                        name: "",
                        is_top: false,
                        top_index: 0,
                        sport_slug: "",
                        sport_id: event.sport_id,
                        sport_name: "",
                        category_id: -1,
                        category_name: "",
                    });
                }
                else {
                    favLeague.events.push(event.id);
                    favLeague.games_count += 1;
                }
            }
        });
        setFavPrematchLeagues(favPrematchLeaguesArr);
    }, [favEvents]);
    const updateFavLiveLeagues = useCallback(() => {
        const favLiveLeaguesArr = [];
        favEvents.forEach((event) => {
            var _a;
            const liveEvent = socketStorage.getLiveEvent(event.id);
            if (liveEvent) {
                const isTop = (_a = socketStorage.getTournamentById(liveEvent.tournament_id)) === null || _a === void 0 ? void 0 : _a.is_top;
                if (!isTop) {
                    const favLeague = favLiveLeaguesArr.find((league) => league.id === liveEvent.tournament_id);
                    if (!favLeague) {
                        favLiveLeaguesArr.push({
                            events: [event.id],
                            id: liveEvent.tournament_id,
                            games_count: 1,
                            name: liveEvent.tournament_name,
                            is_top: false,
                            top_index: 0,
                            sport_slug: liveEvent.sport_slug,
                            sport_id: liveEvent.sport_id,
                            sport_name: liveEvent.sport_name,
                            category_id: liveEvent.category_id,
                            category_name: liveEvent.category_name,
                        });
                    }
                    else {
                        favLeague.events.push(event.id);
                        favLeague.games_count += 1;
                    }
                }
            }
        });
        setFavLiveLeagues(favLiveLeaguesArr);
    }, [favEvents, socketStorage]);
    useEffect(() => {
        if (prematchFeedReady) {
            updateFavPrematchLeagues();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [prematchFeedReady]);
    useDidUpdateEffect(() => {
        if (favEvents.length) {
            if (prematchFeedReady) {
                updateFavPrematchLeagues();
            }
            if (liveFeedReady) {
                updateFavLiveLeagues();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [favEvents]);
    const addFav = useCallback((event) => {
        const result = [...favEvents, event];
        setFavEvents(result);
        browserStorage.set(BrowserStorageIdsEnum.FAVORITE_EVENTS, JSON.stringify(result));
    }, [favEvents, browserStorage]);
    const removeFav = useCallback((id) => {
        const result = favEvents.filter((event) => event.id !== id);
        setFavEvents(result);
        browserStorage.set(BrowserStorageIdsEnum.FAVORITE_EVENTS, JSON.stringify(result));
    }, [favEvents, browserStorage]);
    const isFav = useCallback((id) => {
        return !!favEvents.find((item) => item.id === id);
    }, [favEvents]);
    const value = useMemo(() => ({
        favEvents,
        favLiveLeagues,
        favPrematchLeagues,
        favLiveLeaguesGameCount,
        favPrematchLeaguesGameCount,
        addFav,
        removeFav,
        isFav,
    }), [
        favEvents,
        favLiveLeagues,
        favPrematchLeagues,
        favLiveLeaguesGameCount,
        favPrematchLeaguesGameCount,
        addFav,
        removeFav,
        isFav,
    ]);
    return (jsx(FavoriteEventsContext.Provider, { value: value, children: children }));
};

// iOS restricts cookies when site loaded in iframe, and therefore we fallback to "Authorization" header approach
class IOSAuthorizationMiddleware {
    constructor(tokenAccessKey, onTokenChanged) {
        this.tokenAccessKey = tokenAccessKey;
        this.onTokenChanged = onTokenChanged;
        this.canAccessCookiesStorage = null;
    }
    hasStorageAccess() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return document.hasStorageAccess();
            }
            catch (_a) {
                return true;
            }
        });
    }
    onRequest(request, next) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.canAccessCookiesStorage === null) {
                this.canAccessCookiesStorage = yield this.hasStorageAccess();
            }
            if (this.canAccessCookiesStorage) {
                return next();
            }
            const token = localStorage.getItem(this.tokenAccessKey);
            if (token) {
                request.headers["Authorization"] = `Bearer ${token}`;
            }
            const response = yield next();
            if (response.statusCode === 401) {
                localStorage.removeItem(this.tokenAccessKey);
                this.onTokenChanged("");
            }
            if (response.statusCode >= 200 &&
                response.statusCode < 300 &&
                response.body &&
                response.body.token) {
                localStorage.setItem(this.tokenAccessKey, response.body.token);
                this.onTokenChanged(response.body.token);
            }
            return response;
        });
    }
}

const AuthContext = createContext(null);
const AuthProvider = ({ children, initialJwt }) => {
    const [jwt, setJwt] = useState(initialJwt || null);
    const prevToken = usePrevious(jwt);
    const setToken = useCallback((token) => {
        if (!token) {
            localStorage.removeItem(BrowserStorageIdsEnum.TOKEN);
            setJwt(null);
        }
        else {
            localStorage.setItem(BrowserStorageIdsEnum.TOKEN, token);
            setJwt(token);
        }
    }, []);
    useDidUpdateEffect(() => {
        if (initialJwt !== jwt) {
            setToken(initialJwt);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialJwt]);
    const value = useMemo(() => ({
        setToken,
        userToken: jwt,
        prevToken,
        isUserLoggedIn: jwt !== null && !!jwt,
    }), [jwt, setToken, prevToken]);
    return jsx(AuthContext.Provider, { value: value, children: children });
};

// @TODO handle capture exception
const ClientBFFContext = createContext(null);
const ClientProvider = ({ children, client, captureException, }) => {
    const { setToken } = useContext(AuthContext);
    const value = useMemo(() => {
        if (!client) {
            const origin = typeof window !== "undefined" && window.location.origin
                ? window.location.origin
                : "";
            return new ClientBFFClient(`${origin}/api/proxy/`, "sportsbook-mobile", [
                new IOSAuthorizationMiddleware(BrowserStorageIdsEnum.TOKEN, (token) => {
                    setToken(token);
                }),
                new AxiosLikeErrorMiddleware({
                    handleNotOkStatusCode(error, response) {
                        var _a;
                        if (response.statusCode === 401) {
                            setToken("");
                        }
                        else if (response.statusCode >= 500) {
                            const traceparent = (_a = response === null || response === void 0 ? void 0 : response.headers) === null || _a === void 0 ? void 0 : _a.traceparent;
                            const traceId = traceparent ? traceparent === null || traceparent === void 0 ? void 0 : traceparent.split("-")[1] : "unknown";
                            captureException &&
                                captureException(error, {
                                    tags: {
                                        // eslint-disable-next-line @typescript-eslint/naming-convention
                                        "trace-id": traceId,
                                    },
                                });
                        }
                    },
                }),
            ]);
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }
        return client;
    }, [captureException, client, setToken]);
    return (jsx(Fragment, { children: jsx(ClientBFFContext.Provider, { value: value, children: children }) }));
};

const LocaleContext = createContext(null);
const LocaleProvider = ({ children, locale }) => {
    const [loc, setLoc] = useState(locale);
    const value = useMemo(() => ({
        locale: loc,
        setLocale: setLoc,
    }), [loc, setLoc]);
    return jsx(LocaleContext.Provider, { value: value, children: children });
};

const BannersContext = createContext(null);
const BannersProvider = ({ banners, device, children }) => {
    const client = useContext(ClientBFFContext);
    const COMMON_SITE_CONFIGS = useRuntimeConfig("COMMON_SITE_CONFIGS");
    const { locale } = useContext(LocaleContext);
    const [bannersState, setBannersState] = useState(banners || []);
    useDidUpdateEffect(() => {
        if (banners) {
            setBannersState(banners);
        }
    }, [banners]);
    const getBanners = useCallback((scopes) => __awaiter(void 0, void 0, void 0, function* () {
        const tags = [device, COMMON_SITE_CONFIGS.appName, ...scopes];
        let result = [];
        try {
            const response = yield client.getBanners({
                language: locale,
                tags,
                equal: false,
            });
            if (response.items) {
                result = response.items;
            }
        }
        catch (error) {
            result = [];
        }
        return result;
    }), [COMMON_SITE_CONFIGS.appName, client, device, locale]);
    const value = useMemo(() => ({
        banners: bannersState,
        setBannersState,
        getBanners,
    }), [bannersState, setBannersState, getBanners]);
    return jsx(BannersContext.Provider, { value: value, children: children });
};

const PopupBannersContext = createContext(null);
const PopupBannersProvider = ({ popupScope, popups: ssrPopups, children, device, ignore, }) => {
    const client = useContext(ClientBFFContext);
    const COMMON_SITE_CONFIGS = useRuntimeConfig("COMMON_SITE_CONFIGS");
    const { isUserLoggedIn: isLoggedIn } = useContext(AuthContext);
    const { locale } = useContext(LocaleContext);
    const { get, set } = useContext(BrowserStorageContext);
    const [popups, setPopups] = useState(ssrPopups || []);
    useEffect(() => {
        function loadPopups() {
            return __awaiter(this, void 0, void 0, function* () {
                let response;
                const deviceTag = device === "desktop" ? PopupTags.Desktop : PopupTags.Mobile;
                let tags = [deviceTag, COMMON_SITE_CONFIGS.appName];
                if (popupScope === null || popupScope === void 0 ? void 0 : popupScope.length) {
                    tags = [...tags, ...popupScope];
                }
                else {
                    tags = [...tags, PopupTags.Allpages];
                }
                if (isLoggedIn) {
                    response = yield client.getLoggedInPopups({
                        language: locale,
                        tags,
                    });
                }
                else {
                    response = yield client.getPublicPopups({
                        language: locale,
                        tags,
                    });
                }
                setPopups(response.items.filter((item) => item.tags.includes(COMMON_SITE_CONFIGS.appName)));
            });
        }
        if (!ssrPopups && client && !ignore) {
            loadPopups();
        }
        return () => {
            setPopups([]);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const updateStoragePopupBanners = useCallback((ids) => {
        var _a;
        const storagePopupBanners = (_a = get(BrowserStorageIdsEnum.POPUP_BANNERS)) !== null && _a !== void 0 ? _a : {};
        Object.values(storagePopupBanners).forEach((item) => {
            if (Date.now() - item.last_seen_timestamp > 30 * DAY_IN_MS) {
                delete storagePopupBanners[item.id];
            }
        });
        ids.forEach((id) => {
            storagePopupBanners[id] = {
                id,
                last_seen_timestamp: Date.now(),
            };
        });
        set(BrowserStorageIdsEnum.POPUP_BANNERS, JSON.stringify(storagePopupBanners));
    }, [get, set]);
    const value = useMemo(() => ({
        popups,
        hasPopups: popups.length > 0,
        updateStoragePopupBanners,
        popupScope,
        setPopups,
    }), [popupScope, popups, updateStoragePopupBanners, setPopups]);
    return jsx(PopupBannersContext.Provider, { value: value, children: children });
};

const SiteNotificationsContext = createContext(null);
const SiteNotificationsProvider = ({ children, ignore, appName, }) => {
    const client = useContext(ClientBFFContext);
    const { isUserLoggedIn: isLoggedIn } = useContext(AuthContext);
    const { locale } = useContext(LocaleContext);
    const { get, set } = useContext(BrowserStorageContext);
    const [notifications, setNotifications] = useState([]);
    const loadNotifications = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        if (!ignore) {
            const now = Date.now();
            let response;
            if (isLoggedIn) {
                response = yield client.getLoggedInNotifications({
                    language: locale,
                    tags: [appName],
                });
            }
            else {
                response = yield client.getPublicNotifications({
                    language: locale,
                    tags: [appName],
                });
            }
            const filteredNotifications = response.items.filter((notification) => {
                if (notification.active_from && notification.active_to) {
                    return (now >= new Date(notification.active_from).getTime() &&
                        now <= new Date(notification.active_to).getTime());
                }
                return true;
            });
            setNotifications(filteredNotifications);
        }
    }), [appName, client, ignore, isLoggedIn, locale]);
    const updateStorageNotifications = useCallback((ids) => {
        var _a;
        const storageNotifications = (_a = get(BrowserStorageIdsEnum.SITE_NOTIFICATIONS)) !== null && _a !== void 0 ? _a : {};
        Object.values(storageNotifications).forEach((item) => {
            if (Date.now() - item.last_seen_timestamp > 30 * DAY_IN_MS) {
                delete storageNotifications[item.id];
            }
        });
        ids.forEach((id) => {
            storageNotifications[id] = {
                id,
                last_seen_timestamp: Date.now(),
            };
        });
        set(BrowserStorageIdsEnum.SITE_NOTIFICATIONS, JSON.stringify(storageNotifications));
    }, [get, set]);
    useEffect(() => {
        if (client) {
            loadNotifications();
        }
        return () => {
            setNotifications([]);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const value = useMemo(() => ({
        notifications,
        hasNotifications: notifications.length > 0,
        loadNotifications,
        updateStorageNotifications,
    }), [notifications, loadNotifications, updateStorageNotifications]);
    return (jsx(SiteNotificationsContext.Provider, { value: value, children: children }));
};

const WebsocketContext = createContext(null);
const WebsocketProvider = ({ socketClient, token, connected, children, debug }) => {
    const value = useMemo(() => ({ socketClient, token, connected, debug: !!debug }), [socketClient, token, connected, debug]);
    return jsx(WebsocketContext.Provider, { value: value, children: children });
};

const createI18n = (() => {
    let instance = null;
    return (locale, resourcesFromServer) => {
        if (instance) {
            for (const scope in resourcesFromServer) {
                instance.addResourceBundle(locale, scope, resourcesFromServer[scope]);
            }
            if (instance.language !== locale) {
                void instance.changeLanguage(locale);
            }
            return instance;
        }
        instance = i18next.use(initReactI18next).createInstance({
            fallbackLng: Language.en,
            lng: locale,
            debug: false,
            defaultNS: TranslationScopes.Common,
            resources: {
                [locale]: resourcesFromServer,
            },
            interpolation: {
                escapeValue: false,
            },
        }, 
        // callback forces init
        (err) => {
            if (err)
                return console.log("something went wrong while initializing i18n", err);
        });
        return instance;
    };
})();
const I18nextProvider = (props) => {
    const { locale } = useContext(LocaleContext);
    const i18n = createI18n(locale, props.translations);
    return (jsx(I18nextProvider$1, { i18n: i18n, defaultNS: TranslationScopes.Common, children: props.children }));
};

const CasinoFavoritesContext = createContext(null);
const CasinoFavoritesProvider = ({ children, favoriteGames, mobile, }) => {
    const client = useContext(ClientBFFContext);
    const [favoriteGamesState, setFavoriteGamesState] = useState({
        games: favoriteGames !== null && favoriteGames !== void 0 ? favoriteGames : [],
        loading: true,
    });
    useEffect(() => {
        if (!favoriteGames) {
            return;
        }
        setFavoriteGamesState((state) => (Object.assign(Object.assign({}, state), { games: favoriteGames })));
    }, [favoriteGames]);
    const updateFavoriteGames = useCallback((games) => {
        setFavoriteGamesState((state) => (Object.assign(Object.assign({}, state), { games })));
    }, []);
    const createCasinoFavorite = useCallback((gameId) => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield client.createCasinoFavorite({
            game_id: gameId,
        });
        if ((response === null || response === void 0 ? void 0 : response.game_id) === gameId) {
            updateFavoriteGames([...favoriteGamesState.games, response]);
        }
    }), [client, favoriteGamesState.games, updateFavoriteGames]);
    const deleteCasinoFavorite = useCallback((gameId) => __awaiter(void 0, void 0, void 0, function* () {
        console.log(gameId, mobile);
        yield client.deleteCasinoFavorite(gameId, mobile || false);
        const currentGames = [...favoriteGamesState.games];
        const gameIndex = currentGames.findIndex((item) => item.game_id === gameId);
        if (gameIndex !== -1) {
            currentGames.splice(gameIndex, 1);
        }
        updateFavoriteGames(currentGames);
    }), [client, favoriteGamesState.games, mobile, updateFavoriteGames]);
    const value = useMemo(() => ({
        favoriteGamesState,
        createCasinoFavorite,
        deleteCasinoFavorite,
        updateFavoriteGames,
    }), [favoriteGamesState, createCasinoFavorite, deleteCasinoFavorite, updateFavoriteGames]);
    return (jsx(CasinoFavoritesContext.Provider, { value: value, children: children }));
};

const SubscribeToChatMessages = ({ handleChatUpdates, token }) => {
    const params = useMemo(() => ({ token: token || "" }), [token]);
    useWebsocketUpdates("chat_message", handleChatUpdates, true, params);
    return null;
};
const ChatContext = createContext(null);
const ChatProvider = ({ children }) => {
    const client = useContext(ClientBFFContext);
    const { userToken: token } = useContext(AuthContext);
    const { connected } = useContext(WebsocketContext);
    const isLoggedIn = token !== null && !!token;
    const [unreadMessages, setUnreadMessages] = useState([]);
    const [chatStats, setChatStats] = useState(null);
    useEffect(() => {
        const loadChatStats = () => __awaiter(void 0, void 0, void 0, function* () {
            const response = yield client.getChatStats();
            setChatStats(response);
        });
        if (isLoggedIn) {
            loadChatStats();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoggedIn]);
    const removeMessage = useCallback((chatId, messageIds) => __awaiter(void 0, void 0, void 0, function* () {
        const filteredMessages = unreadMessages.filter((msg) => msg.chat.id !== chatId);
        setUnreadMessages(filteredMessages);
        messageIds.forEach((messageId) => __awaiter(void 0, void 0, void 0, function* () {
            yield client.updateMessage(chatId, messageId, {
                is_read: true,
            });
        }));
    }), [client, unreadMessages]);
    const getUnreadMessagesByChatId = useCallback((id) => {
        const result = [];
        const filteredMessages = unreadMessages.filter((msg) => msg.chat.id === id);
        filteredMessages.forEach((message) => {
            const newMessage = {
                id: message.id,
                message: message.message,
                author: message.author,
                created_at: message.created_at,
                updated_at: message.updated_at,
                is_read: message.is_read,
            };
            result.push(newMessage);
        });
        return result;
    }, [unreadMessages]);
    const handleChatUpdates = useCallback((payload, error) => {
        if (!error) {
            if (payload.author === "Admin") {
                setUnreadMessages((state) => [...state, payload]);
            }
        }
        else {
            console.error(error);
        }
    }, []);
    useEffect(() => {
        if (!isLoggedIn) {
            setUnreadMessages([]);
            setChatStats(null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [connected, isLoggedIn]);
    const value = useMemo(() => ({
        unreadMessages,
        removeMessage,
        getUnreadMessagesByChatId,
        chatStats,
        setChatStats,
    }), [getUnreadMessagesByChatId, removeMessage, unreadMessages, chatStats, setChatStats]);
    return (jsxs(ChatContext.Provider, { value: value, children: [isLoggedIn && (jsx(SubscribeToChatMessages, { handleChatUpdates: handleChatUpdates, token: token })), children] }));
};

const ChatServiceContext = createContext(null);
const ChatServiceProvider = ({ children, script, }) => {
    const COMMON_SITE_CONFIGS = useRuntimeConfig("COMMON_SITE_CONFIGS");
    const [visible, setVisible] = useState(false);
    const hideWidget = useCallback(() => {
        switch (COMMON_SITE_CONFIGS.chatService.name) {
            case ChatServiceNameEnum.LiveChat:
                if (window.LiveChatWidget) {
                    if (window.LiveChatWidget._h) {
                        window.LiveChatWidget.call("hide");
                    }
                }
                break;
            case ChatServiceNameEnum.Zendesk:
                if (window.zE) {
                    window.zE("messenger", "hide");
                    setVisible(false);
                }
                break;
            case ChatServiceNameEnum.Tawk:
                if (window.Tawk_API) {
                    window.Tawk_API.hideWidget();
                }
                break;
        }
    }, [COMMON_SITE_CONFIGS.chatService.name]);
    const showWidget = useCallback(() => {
        switch (COMMON_SITE_CONFIGS.chatService.name) {
            case ChatServiceNameEnum.LiveChat:
                if (window.LiveChatWidget) {
                    if (window.LiveChatWidget._h) {
                        window.LiveChatWidget.call("minimize");
                    }
                    else {
                        window.LiveChatWidget.init();
                    }
                }
                break;
            case ChatServiceNameEnum.Zendesk:
                if (typeof window.zE === "function") {
                    window.zE("messenger", "show");
                    setVisible(true);
                }
                break;
            case ChatServiceNameEnum.Tawk:
                if (window.Tawk_API) {
                    window.Tawk_API.showWidget();
                    setVisible(true);
                }
                break;
        }
    }, [COMMON_SITE_CONFIGS.chatService.name]);
    const value = useMemo(() => ({ showWidget, hideWidget, setVisible, visible }), [showWidget, hideWidget, visible]);
    return (jsxs(ChatServiceContext.Provider, { value: value, children: [COMMON_SITE_CONFIGS.chatService.enable && script, children] }));
};

const convertToLocalStorageItem$1 = (wallet) => {
    return { type: wallet.type, currency: wallet.currency };
};
const UserAccountContext = createContext(null);
const UserAccountProvider = ({ children, initialProfile, uuid, }) => {
    var _a;
    const router = useRouter();
    const client = useContext(ClientBFFContext);
    const { set } = useContext(BrowserStorageContext);
    const { userToken, setToken, prevToken } = useContext(AuthContext);
    const [deviceId] = useState(uuid);
    const [profile, setProfile] = useState({
        data: initialProfile ? Object.assign(Object.assign({}, initialProfile), { wallets: [] }) : null,
        loading: false,
    });
    const [currentWallet, setCurrentWallet] = useState(null);
    const [wallets, setWallets] = useState({
        data: initialProfile ? initialProfile.wallets : [],
        loading: false,
    });
    useDidUpdateEffect(() => {
        if (userToken && userToken !== prevToken) {
            loadProfile();
        }
        else if (prevToken && !userToken && profile.data) {
            logout();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userToken]);
    useDidUpdateEffect(() => {
        if (initialProfile) {
            setProfileData(initialProfile);
            setWalletsData(initialProfile.wallets);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialProfile]);
    const setProfileData = useCallback((val) => {
        setProfile((state) => (Object.assign(Object.assign({}, state), { data: Object.assign(Object.assign({}, val), { wallets: [] }), loading: false })));
    }, [setProfile]);
    const setWalletsData = useCallback((val) => {
        setWallets((state) => (Object.assign(Object.assign({}, state), { data: val, loading: false })));
    }, [setWallets]);
    const loadProfile = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        setProfile((state) => (Object.assign(Object.assign({}, state), { loading: true })));
        setWallets((state) => (Object.assign(Object.assign({}, state), { loading: true })));
        const response = yield client.profile();
        setProfileData(response);
        setWalletsData(response.wallets);
    }), [client, setProfileData, setWalletsData]);
    const updateUser = useCallback((payload) => {
        setProfile((state) => (Object.assign(Object.assign({}, state), { data: Object.assign(Object.assign({}, state.data), payload) })));
    }, []);
    const setSelectedWallet = useCallback((payload) => {
        let newCurrentWallet = payload;
        if (userToken && !payload.id) {
            const userWallet = wallets.data.find((wallet) => wallet.type === (payload === null || payload === void 0 ? void 0 : payload.type) && wallet.currency === payload.currency);
            if (userWallet) {
                newCurrentWallet = userWallet;
            }
        }
        setCurrentWallet(newCurrentWallet);
        set(BrowserStorageIdsEnum.WALLET, JSON.stringify(convertToLocalStorageItem$1(payload)));
    }, [userToken, set, wallets.data]);
    const updateBalance = useCallback((payload) => {
        var _a;
        const walletIndex = wallets.data.findIndex((d) => d.id === payload.id);
        if (walletIndex !== -1) {
            if (((_a = wallets.data[walletIndex]) === null || _a === void 0 ? void 0 : _a.balance) !== payload.balance) {
                const result = [...wallets.data];
                result[walletIndex] = payload;
                setWallets((state) => (Object.assign(Object.assign({}, state), { data: result })));
                if ((currentWallet === null || currentWallet === void 0 ? void 0 : currentWallet.id) === payload.id) {
                    setCurrentWallet(payload);
                }
            }
        }
        else if ((currentWallet === null || currentWallet === void 0 ? void 0 : currentWallet.currency) === payload.currency) {
            setCurrentWallet(payload);
        }
    }, [currentWallet === null || currentWallet === void 0 ? void 0 : currentWallet.currency, currentWallet === null || currentWallet === void 0 ? void 0 : currentWallet.id, wallets.data]);
    const logout = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        yield client.logout();
        setToken("");
        setProfile((state) => (Object.assign(Object.assign({}, state), { data: null })));
        setCurrentWallet(null);
        setWallets((state) => (Object.assign(Object.assign({}, state), { data: [] })));
        yield router.replace(router.asPath);
    }), [client, router, setToken]);
    const userCurrency = useMemo(() => { var _a; return ((_a = profile.data) === null || _a === void 0 ? void 0 : _a.currency) || ""; }, [(_a = profile.data) === null || _a === void 0 ? void 0 : _a.currency]);
    const value = useMemo(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        return ({
            logout,
            updateUser,
            loadProfile,
            setSelectedWallet,
            updateBalance,
            currentWallet,
            currentCurrency: currentWallet === null || currentWallet === void 0 ? void 0 : currentWallet.currency,
            currentBalance: (currentWallet === null || currentWallet === void 0 ? void 0 : currentWallet.balance) || "0",
            userCurrency,
            userWallets: wallets,
            currentWalletId: currentWallet === null || currentWallet === void 0 ? void 0 : currentWallet.id,
            deviceId,
            userData: profile.data,
            userEmail: ((_a = profile.data) === null || _a === void 0 ? void 0 : _a.email) || "",
            username: ((_b = profile.data) === null || _b === void 0 ? void 0 : _b.username) || "",
            firstName: ((_c = profile.data) === null || _c === void 0 ? void 0 : _c.first_name) || "",
            lastName: ((_d = profile.data) === null || _d === void 0 ? void 0 : _d.last_name) || "",
            userId: (_e = profile.data) === null || _e === void 0 ? void 0 : _e.id,
            mno_channel: (_f = profile.data) === null || _f === void 0 ? void 0 : _f.mno_channel,
            userProfileStatus: (_g = profile.data) === null || _g === void 0 ? void 0 : _g.status,
            isUserVerified: ((_h = profile.data) === null || _h === void 0 ? void 0 : _h.status) === UserStatus.Registered,
            userLanguage: (_j = profile.data) === null || _j === void 0 ? void 0 : _j.language,
            userReferralSlug: ((_k = profile.data) === null || _k === void 0 ? void 0 : _k.referral_slug) || "",
            userIsAgent: (_l = profile.data) === null || _l === void 0 ? void 0 : _l.is_agent,
            isEmailVerified: ((_m = profile.data) === null || _m === void 0 ? void 0 : _m.email_verified) || false,
            isPhoneVerified: ((_o = profile.data) === null || _o === void 0 ? void 0 : _o.phone_verified) || false,
            isKycVerified: ((_p = profile.data) === null || _p === void 0 ? void 0 : _p.kyc_id_verified) || false,
        });
    }, [
        logout,
        updateUser,
        loadProfile,
        setSelectedWallet,
        updateBalance,
        currentWallet,
        userCurrency,
        wallets,
        deviceId,
        profile.data,
    ]);
    return jsx(UserAccountContext.Provider, { value: value, children: children });
};

const prepareConfigs = (payload) => {
    const result = Object.assign(Object.assign({}, payload), { currency_format: {} });
    const currencyConfig = payload === null || payload === void 0 ? void 0 : payload.payments.currency;
    if (currencyConfig) {
        Object.keys(currencyConfig).forEach((currency) => {
            var _a, _b;
            result.currency_format[currency] = {
                code: currency,
                decimal_digits: (_b = (_a = currencyConfig[currency]) === null || _a === void 0 ? void 0 : _a.digits) !== null && _b !== void 0 ? _b : 0,
                decimal_separator: "dot",
                symbol: CurrencySymbolsMap[currency] || "",
                thousands_separator: "comma",
            };
        });
    }
    return result;
};
const ConfigContext = createContext(null);
const ConfigProvider = ({ children, defaultConfig, defaultCountry, walletConfigs, }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    const { domain } = useHost();
    const COMMON_SITE_CONFIGS = useRuntimeConfig("COMMON_SITE_CONFIGS");
    const { userWallets, setSelectedWallet, currentWallet, userCurrency } = useContext(UserAccountContext);
    const { userToken, prevToken, isUserLoggedIn } = useContext(AuthContext);
    const { get } = useContext(BrowserStorageContext);
    const client = useContext(ClientBFFContext);
    const [config, setConfig] = useState({
        data: defaultConfig,
        loading: false,
        error: "",
    });
    const [oddFormat, setOddFormat] = useState("");
    const [siteSupportedWallets, setSiteSupportedWallets] = useState([]);
    const siteConfigReady = useMemo(() => !config.loading, [config.loading]);
    const fiatEnabled = COMMON_SITE_CONFIGS.wallet.fiat;
    const sitePaymentsConfig = useMemo(() => { var _a, _b; return (_b = (_a = config.data) === null || _a === void 0 ? void 0 : _a.payments) === null || _b === void 0 ? void 0 : _b.currency; }, [(_b = (_a = config.data) === null || _a === void 0 ? void 0 : _a.payments) === null || _b === void 0 ? void 0 : _b.currency]);
    const initSupportedWallets = useCallback(() => {
        let filtered = [];
        if (sitePaymentsConfig) {
            Object.keys(sitePaymentsConfig).forEach((currency) => {
                const currencyConfig = sitePaymentsConfig[currency];
                const balanceWallet = userWallets.data.find((item) => item.type === WalletType.Balance && item.currency === currency);
                const bonusWallet = userWallets.data.find((item) => item.type === WalletType.Bonus && item.currency === currency);
                const balance = parseFloat((balanceWallet === null || balanceWallet === void 0 ? void 0 : balanceWallet.balance) || "0");
                const bonusBalance = parseFloat((bonusWallet === null || bonusWallet === void 0 ? void 0 : bonusWallet.balance) || "0");
                if (balance > 0 || (currencyConfig === null || currencyConfig === void 0 ? void 0 : currencyConfig.enabled)) {
                    const wallet = balanceWallet !== null && balanceWallet !== void 0 ? balanceWallet : {
                        currency: currency,
                        balance: "0",
                        type: WalletType.Balance,
                    };
                    filtered.push(wallet);
                }
                if (bonusWallet && bonusBalance > 0) {
                    filtered.push(bonusWallet);
                }
            });
        }
        if (!walletConfigs._crypto.enable) {
            filtered = filtered.filter((wallet) => {
                return wallet.currency && !isCryptoCurrency(wallet.currency);
            });
        }
        if (!walletConfigs.fiat) {
            filtered = filtered.filter((wallet) => {
                return wallet.currency && !FiatCurrencies.includes(wallet.currency);
            });
        }
        if (userCurrency && isCryptoCurrency(userCurrency)) {
            filtered = filtered.filter((wallet) => {
                return (wallet.currency &&
                    !(FiatCurrencies.includes(wallet.currency) && parseFloat(wallet.balance) === 0));
            });
        }
        const sorted = filtered.sort((a, b) => {
            var _a, _b;
            if (a.currency && b.currency) {
                return ((((_a = sitePaymentsConfig === null || sitePaymentsConfig === void 0 ? void 0 : sitePaymentsConfig[a.currency]) === null || _a === void 0 ? void 0 : _a.confirmation_count) || 0) -
                    (((_b = sitePaymentsConfig === null || sitePaymentsConfig === void 0 ? void 0 : sitePaymentsConfig[b.currency]) === null || _b === void 0 ? void 0 : _b.confirmation_count) || 0));
            }
            return -1;
        });
        setSiteSupportedWallets(sorted);
    }, [
        sitePaymentsConfig,
        userCurrency,
        userWallets.data,
        walletConfigs._crypto.enable,
        walletConfigs.fiat,
    ]);
    useEffect(() => {
        if (siteConfigReady && !userWallets.loading) {
            initSupportedWallets();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [siteConfigReady, userWallets.loading]);
    useEffect(() => {
        if (!!siteSupportedWallets.length) {
            if (!(currentWallet === null || currentWallet === void 0 ? void 0 : currentWallet.currency)) {
                initSelectedWallet();
            }
            else {
                const wallet = siteSupportedWallets.find((item) => item.type === (currentWallet === null || currentWallet === void 0 ? void 0 : currentWallet.type) &&
                    item.currency === (currentWallet === null || currentWallet === void 0 ? void 0 : currentWallet.currency));
                if (wallet) {
                    setSelectedWallet(wallet);
                }
                else {
                    initSelectedWallet();
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [siteSupportedWallets]);
    useDidUpdateEffect(() => {
        if (userToken !== prevToken) {
            loadSiteConfig();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userToken]);
    const isCurrencySupported = useCallback((val) => siteSupportedWallets.find((wallet) => wallet.currency === val) !== undefined, [siteSupportedWallets]);
    const initSelectedWallet = useCallback(() => {
        let localStorageWallet = get(BrowserStorageIdsEnum.WALLET);
        const isStorageWalletBonus = (localStorageWallet === null || localStorageWallet === void 0 ? void 0 : localStorageWallet.type) === WalletType.Bonus;
        const isStorageWalletSupported = (localStorageWallet === null || localStorageWallet === void 0 ? void 0 : localStorageWallet.currency) && isCurrencySupported(localStorageWallet.currency);
        const isUserCurrencyCrypto = userCurrency && isCryptoCurrency(userCurrency);
        if ((!isUserLoggedIn && isStorageWalletBonus) || !isStorageWalletSupported) {
            localStorageWallet = null;
        }
        const defaultCryptoWallet = siteSupportedWallets.find((wallet) => wallet.currency === COMMON_SITE_CONFIGS.wallet._crypto.default);
        const getNewWalletValue = () => {
            if (localStorageWallet === null || localStorageWallet === void 0 ? void 0 : localStorageWallet.type) {
                return localStorageWallet;
            }
            else if (defaultCryptoWallet &&
                (!fiatEnabled || (fiatEnabled && isUserCurrencyCrypto))) {
                return defaultCryptoWallet;
            }
            else {
                return siteSupportedWallets[0];
            }
        };
        const newSelectedWallet = getNewWalletValue();
        setSelectedWallet(newSelectedWallet);
    }, [
        COMMON_SITE_CONFIGS.wallet._crypto.default,
        fiatEnabled,
        get,
        isCurrencySupported,
        setSelectedWallet,
        siteSupportedWallets,
        userCurrency,
        isUserLoggedIn,
    ]);
    const changeOddFormat = useCallback((value) => {
        setOddFormat(value);
        localStorage.setItem(BrowserStorageIdsEnum.ODD_FORMAT, value);
    }, []);
    const loadSiteConfig = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        setConfig((state) => (Object.assign(Object.assign({}, state), { loading: true })));
        const response = yield client.getSiteConfig();
        setConfig((state) => (Object.assign(Object.assign({}, state), { data: prepareConfigs(response), loading: false })));
    }), [client]);
    const siteCurrentOddFormat = useMemo(() => oddFormat, [oddFormat]);
    const siteDefaultCurrency = useMemo(() => { var _a; return (_a = config.data) === null || _a === void 0 ? void 0 : _a.currency.default; }, [(_c = config.data) === null || _c === void 0 ? void 0 : _c.currency.default]);
    const siteSupportedOddsFormat = useMemo(() => { var _a, _b; return (_b = (_a = config.data) === null || _a === void 0 ? void 0 : _a.odds_format) === null || _b === void 0 ? void 0 : _b.supported; }, [(_e = (_d = config.data) === null || _d === void 0 ? void 0 : _d.odds_format) === null || _e === void 0 ? void 0 : _e.supported]);
    const siteDefaultOddsFormat = useMemo(() => { var _a, _b; return (_b = (_a = config.data) === null || _a === void 0 ? void 0 : _a.odds_format) === null || _b === void 0 ? void 0 : _b.default; }, [(_g = (_f = config.data) === null || _f === void 0 ? void 0 : _f.odds_format) === null || _g === void 0 ? void 0 : _g.default]);
    const siteCurrencyFormat = useMemo(() => { var _a; return ((_a = config.data) === null || _a === void 0 ? void 0 : _a.currency_format) || null; }, [(_h = config.data) === null || _h === void 0 ? void 0 : _h.currency_format]);
    const siteRegistrationConfig = useMemo(() => { var _a, _b; return (_b = (_a = config.data) === null || _a === void 0 ? void 0 : _a.users) === null || _b === void 0 ? void 0 : _b.registration; }, [(_k = (_j = config.data) === null || _j === void 0 ? void 0 : _j.users) === null || _k === void 0 ? void 0 : _k.registration]);
    const siteMessagingConfig = useMemo(() => { var _a, _b; return (_b = (_a = config.data) === null || _a === void 0 ? void 0 : _a.message) === null || _b === void 0 ? void 0 : _b.messaging; }, [(_m = (_l = config.data) === null || _l === void 0 ? void 0 : _l.message) === null || _m === void 0 ? void 0 : _m.messaging]);
    const betSlipMaxSelections = useMemo(() => { var _a, _b, _c; return (_c = (_b = (_a = config.data) === null || _a === void 0 ? void 0 : _a.betprocessor) === null || _b === void 0 ? void 0 : _b.max_selections) !== null && _c !== void 0 ? _c : 0; }, [(_o = config.data) === null || _o === void 0 ? void 0 : _o.betprocessor]);
    const siteMaxOdds = useMemo(() => { var _a, _b, _c; return (_c = (_b = (_a = config.data) === null || _a === void 0 ? void 0 : _a.betprocessor) === null || _b === void 0 ? void 0 : _b.max_odds) !== null && _c !== void 0 ? _c : 0; }, [(_p = config.data) === null || _p === void 0 ? void 0 : _p.betprocessor]);
    const isBetProcessorEnabled = useMemo(() => { var _a, _b, _c; return (_c = (_b = (_a = config.data) === null || _a === void 0 ? void 0 : _a.betprocessor) === null || _b === void 0 ? void 0 : _b.enabled) !== null && _c !== void 0 ? _c : false; }, [(_q = config.data) === null || _q === void 0 ? void 0 : _q.betprocessor]);
    const betProcessorConfig = useMemo(() => { var _a, _b; return (_b = (_a = config.data) === null || _a === void 0 ? void 0 : _a.betprocessor) !== null && _b !== void 0 ? _b : null; }, [(_r = config.data) === null || _r === void 0 ? void 0 : _r.betprocessor]);
    const siteClientCountry = useMemo(() => {
        var _a;
        return ((_a = config.data) === null || _a === void 0 ? void 0 : _a.country) || {
            isoAlpha2: CountryISO2Mapping[defaultCountry],
            isoAlpha3: defaultCountry,
        };
    }, [(_s = config.data) === null || _s === void 0 ? void 0 : _s.country, defaultCountry]);
    const siteSupportedCurrencies = useMemo(() => {
        return siteSupportedWallets
            .filter((wallet) => wallet.type === WalletType.Balance && wallet.currency)
            .map((wallet) => wallet.currency);
    }, [siteSupportedWallets]);
    const sportMultiBetBonus = useMemo(() => { var _a; return ((_a = config.data) === null || _a === void 0 ? void 0 : _a.bonus[BonusType.Multibet][BonusVertical.Sport]) || null; }, [(_t = config.data) === null || _t === void 0 ? void 0 : _t.bonus]);
    const isSportMultiBetBonusesEnabled = useMemo(() => {
        var _a;
        const isBrandAllowed = !!((_a = sportMultiBetBonus === null || sportMultiBetBonus === void 0 ? void 0 : sportMultiBetBonus.allowed_brands) === null || _a === void 0 ? void 0 : _a.find((brand) => domain.endsWith(brand))) || false;
        return domain.includes("localhost")
            ? !!(sportMultiBetBonus === null || sportMultiBetBonus === void 0 ? void 0 : sportMultiBetBonus.enabled)
            : isBrandAllowed && !!(sportMultiBetBonus === null || sportMultiBetBonus === void 0 ? void 0 : sportMultiBetBonus.enabled);
    }, [domain, sportMultiBetBonus === null || sportMultiBetBonus === void 0 ? void 0 : sportMultiBetBonus.allowed_brands, sportMultiBetBonus === null || sportMultiBetBonus === void 0 ? void 0 : sportMultiBetBonus.enabled]);
    const sportMultiBetBonusRanges = useMemo(() => (sportMultiBetBonus === null || sportMultiBetBonus === void 0 ? void 0 : sportMultiBetBonus.ranges) || [], [sportMultiBetBonus === null || sportMultiBetBonus === void 0 ? void 0 : sportMultiBetBonus.ranges]);
    const sportMultiBetMinOdds = useMemo(() => (sportMultiBetBonus === null || sportMultiBetBonus === void 0 ? void 0 : sportMultiBetBonus.min_odds) || "", [sportMultiBetBonus === null || sportMultiBetBonus === void 0 ? void 0 : sportMultiBetBonus.min_odds]);
    const sportMultiBetLimits = useMemo(() => (sportMultiBetBonus === null || sportMultiBetBonus === void 0 ? void 0 : sportMultiBetBonus.limit) || null, [sportMultiBetBonus]);
    const value = useMemo(() => ({
        changeOddFormat,
        oddFormat,
        siteConfigs: config.data,
        loadSiteConfig,
        siteDefaultCurrency,
        siteSupportedOddsFormat,
        siteDefaultOddsFormat,
        siteCurrencyFormat,
        sitePaymentsConfig,
        siteRegistrationConfig,
        siteMessagingConfig,
        betSlipMaxSelections,
        siteMaxOdds,
        isBetProcessorEnabled,
        betProcessorConfig,
        siteClientCountry,
        siteSupportedWallets,
        siteSupportedCurrencies,
        siteConfigReady,
        siteCurrentOddFormat,
        isCurrencySupported,
        isSportMultiBetBonusesEnabled,
        sportMultiBetBonusRanges,
        sportMultiBetMinOdds,
        sportMultiBetLimits,
    }), [
        changeOddFormat,
        oddFormat,
        config.data,
        loadSiteConfig,
        siteDefaultCurrency,
        siteSupportedOddsFormat,
        siteDefaultOddsFormat,
        siteCurrencyFormat,
        sitePaymentsConfig,
        siteRegistrationConfig,
        siteMessagingConfig,
        betSlipMaxSelections,
        siteMaxOdds,
        isBetProcessorEnabled,
        betProcessorConfig,
        siteClientCountry,
        siteSupportedWallets,
        siteSupportedCurrencies,
        siteConfigReady,
        siteCurrentOddFormat,
        isCurrencySupported,
        isSportMultiBetBonusesEnabled,
        sportMultiBetBonusRanges,
        sportMultiBetMinOdds,
        sportMultiBetLimits,
    ]);
    return jsx(ConfigContext.Provider, { value: value, children: children });
};

const convertToLocalStorageItem = (wallet) => {
    return { type: wallet.type, currency: wallet.currency };
};
const UserAccountContextV2 = createContext(null);
const UserAccountProviderV2 = ({ children, initialProfile, uuid, }) => {
    var _a;
    const router = useRouter$1();
    const pathname = usePathname();
    const client = useContext(ClientBFFContext);
    const { set } = useContext(BrowserStorageContext);
    const { userToken, setToken, prevToken } = useContext(AuthContext);
    const [deviceId] = useState(uuid);
    const [profile, setProfile] = useState({
        data: initialProfile ? Object.assign(Object.assign({}, initialProfile), { wallets: [] }) : null,
        loading: false,
    });
    const [currentWallet, setCurrentWallet] = useState(null);
    const [wallets, setWallets] = useState({
        data: initialProfile ? initialProfile.wallets : [],
        loading: false,
    });
    useDidUpdateEffect(() => {
        if (userToken && userToken !== prevToken) {
            loadProfile();
        }
        else if (prevToken && !userToken && profile.data) {
            logout();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userToken]);
    useDidUpdateEffect(() => {
        if (initialProfile) {
            setProfileData(initialProfile);
            setWalletsData(initialProfile.wallets);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialProfile]);
    const setProfileData = useCallback((val) => {
        setProfile((state) => (Object.assign(Object.assign({}, state), { data: Object.assign(Object.assign({}, val), { wallets: [] }), loading: false })));
    }, [setProfile]);
    const setWalletsData = useCallback((val) => {
        setWallets((state) => (Object.assign(Object.assign({}, state), { data: val, loading: false })));
    }, [setWallets]);
    const loadProfile = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        setProfile((state) => (Object.assign(Object.assign({}, state), { loading: true })));
        setWallets((state) => (Object.assign(Object.assign({}, state), { loading: true })));
        const response = yield client.profile();
        setProfileData(response);
        setWalletsData(response.wallets);
    }), [client, setProfileData, setWalletsData]);
    const updateUser = useCallback((payload) => {
        setProfile((state) => (Object.assign(Object.assign({}, state), { data: Object.assign(Object.assign({}, state.data), payload) })));
    }, []);
    const setSelectedWallet = useCallback((payload) => {
        let newCurrentWallet = payload;
        if (userToken && !payload.id) {
            const userWallet = wallets.data.find((wallet) => wallet.type === (payload === null || payload === void 0 ? void 0 : payload.type) && wallet.currency === payload.currency);
            if (userWallet) {
                newCurrentWallet = userWallet;
            }
        }
        setCurrentWallet(newCurrentWallet);
        set(BrowserStorageIdsEnum.WALLET, JSON.stringify(convertToLocalStorageItem(payload)));
    }, [userToken, set, wallets.data]);
    const updateBalance = useCallback((payload) => {
        var _a;
        const walletIndex = wallets.data.findIndex((d) => d.id === payload.id);
        if (walletIndex !== -1) {
            if (((_a = wallets.data[walletIndex]) === null || _a === void 0 ? void 0 : _a.balance) !== payload.balance) {
                const result = [...wallets.data];
                result[walletIndex] = payload;
                setWallets((state) => (Object.assign(Object.assign({}, state), { data: result })));
                if ((currentWallet === null || currentWallet === void 0 ? void 0 : currentWallet.id) === payload.id) {
                    setCurrentWallet(payload);
                }
            }
        }
        else if ((currentWallet === null || currentWallet === void 0 ? void 0 : currentWallet.currency) === payload.currency) {
            setCurrentWallet(payload);
        }
    }, [currentWallet === null || currentWallet === void 0 ? void 0 : currentWallet.currency, currentWallet === null || currentWallet === void 0 ? void 0 : currentWallet.id, wallets.data]);
    const logout = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        yield client.logout();
        setToken("");
        setProfile((state) => (Object.assign(Object.assign({}, state), { data: null })));
        setCurrentWallet(null);
        setWallets((state) => (Object.assign(Object.assign({}, state), { data: [] })));
        router.replace(pathname);
    }), [client, pathname, router, setToken]);
    const userCurrency = useMemo(() => { var _a; return ((_a = profile.data) === null || _a === void 0 ? void 0 : _a.currency) || ""; }, [(_a = profile.data) === null || _a === void 0 ? void 0 : _a.currency]);
    const value = useMemo(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        return ({
            logout,
            updateUser,
            loadProfile,
            setSelectedWallet,
            updateBalance,
            currentWallet,
            currentCurrency: currentWallet === null || currentWallet === void 0 ? void 0 : currentWallet.currency,
            currentBalance: (currentWallet === null || currentWallet === void 0 ? void 0 : currentWallet.balance) || "0",
            userCurrency,
            userWallets: wallets,
            currentWalletId: currentWallet === null || currentWallet === void 0 ? void 0 : currentWallet.id,
            deviceId,
            userData: profile.data,
            userEmail: ((_a = profile.data) === null || _a === void 0 ? void 0 : _a.email) || "",
            username: ((_b = profile.data) === null || _b === void 0 ? void 0 : _b.username) || "",
            firstName: ((_c = profile.data) === null || _c === void 0 ? void 0 : _c.first_name) || "",
            lastName: ((_d = profile.data) === null || _d === void 0 ? void 0 : _d.last_name) || "",
            userId: (_e = profile.data) === null || _e === void 0 ? void 0 : _e.id,
            mno_channel: (_f = profile.data) === null || _f === void 0 ? void 0 : _f.mno_channel,
            userProfileStatus: (_g = profile.data) === null || _g === void 0 ? void 0 : _g.status,
            isUserVerified: ((_h = profile.data) === null || _h === void 0 ? void 0 : _h.status) === UserStatus.Registered,
            userLanguage: (_j = profile.data) === null || _j === void 0 ? void 0 : _j.language,
            userReferralSlug: ((_k = profile.data) === null || _k === void 0 ? void 0 : _k.referral_slug) || "",
            userIsAgent: (_l = profile.data) === null || _l === void 0 ? void 0 : _l.is_agent,
            isEmailVerified: ((_m = profile.data) === null || _m === void 0 ? void 0 : _m.email_verified) || false,
            isPhoneVerified: ((_o = profile.data) === null || _o === void 0 ? void 0 : _o.phone_verified) || false,
            isKycVerified: ((_p = profile.data) === null || _p === void 0 ? void 0 : _p.kyc_id_verified) || false,
        });
    }, [
        logout,
        updateUser,
        loadProfile,
        setSelectedWallet,
        updateBalance,
        currentWallet,
        userCurrency,
        wallets,
        deviceId,
        profile.data,
    ]);
    return jsx(UserAccountContextV2.Provider, { value: value, children: children });
};

const prepareConfigsV2 = (payload) => {
    const result = Object.assign(Object.assign({}, payload), { currency_format: {} });
    const currencyConfig = payload === null || payload === void 0 ? void 0 : payload.payments.currency;
    if (currencyConfig) {
        Object.keys(currencyConfig).forEach((currency) => {
            var _a, _b;
            result.currency_format[currency] = {
                code: currency,
                decimal_digits: (_b = (_a = currencyConfig[currency]) === null || _a === void 0 ? void 0 : _a.digits) !== null && _b !== void 0 ? _b : 0,
                decimal_separator: "dot",
                symbol: CurrencySymbolsMap[currency] || "",
                thousands_separator: "comma",
            };
        });
    }
    return result;
};
const ConfigContextV2 = createContext(null);
const ConfigProviderV2 = ({ children, defaultConfig, defaultCountry, walletConfigs, }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    const { domain } = useHostV2();
    const COMMON_SITE_CONFIGS = useRuntimeConfig("COMMON_SITE_CONFIGS");
    const { userWallets, setSelectedWallet, currentWallet, userCurrency } = useContext(UserAccountContextV2);
    const { userToken, prevToken, isUserLoggedIn } = useContext(AuthContext);
    const { get } = useContext(BrowserStorageContext);
    const client = useContext(ClientBFFContext);
    const [config, setConfig] = useState({
        data: defaultConfig,
        loading: false,
        error: "",
    });
    const [oddFormat, setOddFormat] = useState("");
    const [siteSupportedWallets, setSiteSupportedWallets] = useState([]);
    const siteConfigReady = useMemo(() => !config.loading, [config.loading]);
    const fiatEnabled = COMMON_SITE_CONFIGS.wallet.fiat;
    const sitePaymentsConfig = useMemo(() => { var _a, _b; return (_b = (_a = config.data) === null || _a === void 0 ? void 0 : _a.payments) === null || _b === void 0 ? void 0 : _b.currency; }, [(_b = (_a = config.data) === null || _a === void 0 ? void 0 : _a.payments) === null || _b === void 0 ? void 0 : _b.currency]);
    const initSupportedWallets = useCallback(() => {
        let filtered = [];
        if (sitePaymentsConfig) {
            Object.keys(sitePaymentsConfig).forEach((currency) => {
                const currencyConfig = sitePaymentsConfig[currency];
                const balanceWallet = userWallets.data.find((item) => item.type === WalletType.Balance && item.currency === currency);
                const bonusWallet = userWallets.data.find((item) => item.type === WalletType.Bonus && item.currency === currency);
                const balance = parseFloat((balanceWallet === null || balanceWallet === void 0 ? void 0 : balanceWallet.balance) || "0");
                const bonusBalance = parseFloat((bonusWallet === null || bonusWallet === void 0 ? void 0 : bonusWallet.balance) || "0");
                if (balance > 0 || (currencyConfig === null || currencyConfig === void 0 ? void 0 : currencyConfig.enabled)) {
                    const wallet = balanceWallet !== null && balanceWallet !== void 0 ? balanceWallet : {
                        currency: currency,
                        balance: "0",
                        type: WalletType.Balance,
                    };
                    filtered.push(wallet);
                }
                if (bonusWallet && bonusBalance > 0) {
                    filtered.push(bonusWallet);
                }
            });
        }
        if (!walletConfigs._crypto.enable) {
            filtered = filtered.filter((wallet) => {
                return wallet.currency && !isCryptoCurrency(wallet.currency);
            });
        }
        if (!walletConfigs.fiat) {
            filtered = filtered.filter((wallet) => {
                return wallet.currency && !FiatCurrencies.includes(wallet.currency);
            });
        }
        if (userCurrency && isCryptoCurrency(userCurrency)) {
            filtered = filtered.filter((wallet) => {
                return (wallet.currency &&
                    !(FiatCurrencies.includes(wallet.currency) && parseFloat(wallet.balance) === 0));
            });
        }
        const sorted = filtered.sort((a, b) => {
            var _a, _b;
            if (a.currency && b.currency) {
                return ((((_a = sitePaymentsConfig === null || sitePaymentsConfig === void 0 ? void 0 : sitePaymentsConfig[a.currency]) === null || _a === void 0 ? void 0 : _a.confirmation_count) || 0) -
                    (((_b = sitePaymentsConfig === null || sitePaymentsConfig === void 0 ? void 0 : sitePaymentsConfig[b.currency]) === null || _b === void 0 ? void 0 : _b.confirmation_count) || 0));
            }
            return -1;
        });
        setSiteSupportedWallets(sorted);
    }, [
        sitePaymentsConfig,
        userCurrency,
        userWallets.data,
        walletConfigs._crypto.enable,
        walletConfigs.fiat,
    ]);
    useEffect(() => {
        if (siteConfigReady && !userWallets.loading) {
            initSupportedWallets();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [siteConfigReady, userWallets.loading]);
    useEffect(() => {
        if (!!siteSupportedWallets.length) {
            if (!(currentWallet === null || currentWallet === void 0 ? void 0 : currentWallet.currency)) {
                initSelectedWallet();
            }
            else {
                const wallet = siteSupportedWallets.find((item) => item.type === (currentWallet === null || currentWallet === void 0 ? void 0 : currentWallet.type) &&
                    item.currency === (currentWallet === null || currentWallet === void 0 ? void 0 : currentWallet.currency));
                if (wallet) {
                    setSelectedWallet(wallet);
                }
                else {
                    initSelectedWallet();
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [siteSupportedWallets]);
    useDidUpdateEffect(() => {
        if (userToken !== prevToken) {
            loadSiteConfig();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userToken]);
    const isCurrencySupported = useCallback((val) => siteSupportedWallets.find((wallet) => wallet.currency === val) !== undefined, [siteSupportedWallets]);
    const initSelectedWallet = useCallback(() => {
        let localStorageWallet = get(BrowserStorageIdsEnum.WALLET);
        const isStorageWalletBonus = (localStorageWallet === null || localStorageWallet === void 0 ? void 0 : localStorageWallet.type) === WalletType.Bonus;
        const isStorageWalletSupported = (localStorageWallet === null || localStorageWallet === void 0 ? void 0 : localStorageWallet.currency) && isCurrencySupported(localStorageWallet.currency);
        const isUserCurrencyCrypto = userCurrency && isCryptoCurrency(userCurrency);
        if ((!isUserLoggedIn && isStorageWalletBonus) || !isStorageWalletSupported) {
            localStorageWallet = null;
        }
        const defaultCryptoWallet = siteSupportedWallets.find((wallet) => wallet.currency === COMMON_SITE_CONFIGS.wallet._crypto.default);
        const getNewWalletValue = () => {
            if (localStorageWallet === null || localStorageWallet === void 0 ? void 0 : localStorageWallet.type) {
                return localStorageWallet;
            }
            else if (defaultCryptoWallet &&
                (!fiatEnabled || (fiatEnabled && isUserCurrencyCrypto))) {
                return defaultCryptoWallet;
            }
            else {
                return siteSupportedWallets[0];
            }
        };
        const newSelectedWallet = getNewWalletValue();
        setSelectedWallet(newSelectedWallet);
    }, [
        COMMON_SITE_CONFIGS.wallet._crypto.default,
        fiatEnabled,
        get,
        isCurrencySupported,
        setSelectedWallet,
        siteSupportedWallets,
        userCurrency,
        isUserLoggedIn,
    ]);
    const changeOddFormat = useCallback((value) => {
        setOddFormat(value);
        localStorage.setItem(BrowserStorageIdsEnum.ODD_FORMAT, value);
    }, []);
    const loadSiteConfig = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        setConfig((state) => (Object.assign(Object.assign({}, state), { loading: true })));
        const response = yield client.getSiteConfig();
        setConfig((state) => (Object.assign(Object.assign({}, state), { data: prepareConfigsV2(response), loading: false })));
    }), [client]);
    const siteCurrentOddFormat = useMemo(() => oddFormat, [oddFormat]);
    const siteDefaultCurrency = useMemo(() => { var _a; return (_a = config.data) === null || _a === void 0 ? void 0 : _a.currency.default; }, [(_c = config.data) === null || _c === void 0 ? void 0 : _c.currency.default]);
    const siteSupportedOddsFormat = useMemo(() => { var _a, _b; return (_b = (_a = config.data) === null || _a === void 0 ? void 0 : _a.odds_format) === null || _b === void 0 ? void 0 : _b.supported; }, [(_e = (_d = config.data) === null || _d === void 0 ? void 0 : _d.odds_format) === null || _e === void 0 ? void 0 : _e.supported]);
    const siteDefaultOddsFormat = useMemo(() => { var _a, _b; return (_b = (_a = config.data) === null || _a === void 0 ? void 0 : _a.odds_format) === null || _b === void 0 ? void 0 : _b.default; }, [(_g = (_f = config.data) === null || _f === void 0 ? void 0 : _f.odds_format) === null || _g === void 0 ? void 0 : _g.default]);
    const siteCurrencyFormat = useMemo(() => { var _a; return ((_a = config.data) === null || _a === void 0 ? void 0 : _a.currency_format) || null; }, [(_h = config.data) === null || _h === void 0 ? void 0 : _h.currency_format]);
    const siteRegistrationConfig = useMemo(() => { var _a, _b; return (_b = (_a = config.data) === null || _a === void 0 ? void 0 : _a.users) === null || _b === void 0 ? void 0 : _b.registration; }, [(_k = (_j = config.data) === null || _j === void 0 ? void 0 : _j.users) === null || _k === void 0 ? void 0 : _k.registration]);
    const siteMessagingConfig = useMemo(() => { var _a, _b; return (_b = (_a = config.data) === null || _a === void 0 ? void 0 : _a.message) === null || _b === void 0 ? void 0 : _b.messaging; }, [(_m = (_l = config.data) === null || _l === void 0 ? void 0 : _l.message) === null || _m === void 0 ? void 0 : _m.messaging]);
    const betSlipMaxSelections = useMemo(() => { var _a, _b, _c; return (_c = (_b = (_a = config.data) === null || _a === void 0 ? void 0 : _a.betprocessor) === null || _b === void 0 ? void 0 : _b.max_selections) !== null && _c !== void 0 ? _c : 0; }, [(_o = config.data) === null || _o === void 0 ? void 0 : _o.betprocessor]);
    const siteMaxOdds = useMemo(() => { var _a, _b, _c; return (_c = (_b = (_a = config.data) === null || _a === void 0 ? void 0 : _a.betprocessor) === null || _b === void 0 ? void 0 : _b.max_odds) !== null && _c !== void 0 ? _c : 0; }, [(_p = config.data) === null || _p === void 0 ? void 0 : _p.betprocessor]);
    const isBetProcessorEnabled = useMemo(() => { var _a, _b, _c; return (_c = (_b = (_a = config.data) === null || _a === void 0 ? void 0 : _a.betprocessor) === null || _b === void 0 ? void 0 : _b.enabled) !== null && _c !== void 0 ? _c : false; }, [(_q = config.data) === null || _q === void 0 ? void 0 : _q.betprocessor]);
    const betProcessorConfig = useMemo(() => { var _a, _b; return (_b = (_a = config.data) === null || _a === void 0 ? void 0 : _a.betprocessor) !== null && _b !== void 0 ? _b : null; }, [(_r = config.data) === null || _r === void 0 ? void 0 : _r.betprocessor]);
    const siteClientCountry = useMemo(() => {
        var _a;
        return ((_a = config.data) === null || _a === void 0 ? void 0 : _a.country) || {
            isoAlpha2: CountryISO2Mapping[defaultCountry],
            isoAlpha3: defaultCountry,
        };
    }, [(_s = config.data) === null || _s === void 0 ? void 0 : _s.country, defaultCountry]);
    const siteSupportedCurrencies = useMemo(() => {
        return siteSupportedWallets
            .filter((wallet) => wallet.type === WalletType.Balance && wallet.currency)
            .map((wallet) => wallet.currency);
    }, [siteSupportedWallets]);
    const sportMultiBetBonus = useMemo(() => { var _a; return ((_a = config.data) === null || _a === void 0 ? void 0 : _a.bonus[BonusType.Multibet][BonusVertical.Sport]) || null; }, [(_t = config.data) === null || _t === void 0 ? void 0 : _t.bonus]);
    const isSportMultiBetBonusesEnabled = useMemo(() => {
        var _a;
        const isBrandAllowed = !!((_a = sportMultiBetBonus === null || sportMultiBetBonus === void 0 ? void 0 : sportMultiBetBonus.allowed_brands) === null || _a === void 0 ? void 0 : _a.find((brand) => domain.endsWith(brand))) || false;
        return domain.includes("localhost")
            ? !!(sportMultiBetBonus === null || sportMultiBetBonus === void 0 ? void 0 : sportMultiBetBonus.enabled)
            : isBrandAllowed && !!(sportMultiBetBonus === null || sportMultiBetBonus === void 0 ? void 0 : sportMultiBetBonus.enabled);
    }, [domain, sportMultiBetBonus === null || sportMultiBetBonus === void 0 ? void 0 : sportMultiBetBonus.allowed_brands, sportMultiBetBonus === null || sportMultiBetBonus === void 0 ? void 0 : sportMultiBetBonus.enabled]);
    const sportMultiBetBonusRanges = useMemo(() => (sportMultiBetBonus === null || sportMultiBetBonus === void 0 ? void 0 : sportMultiBetBonus.ranges) || [], [sportMultiBetBonus === null || sportMultiBetBonus === void 0 ? void 0 : sportMultiBetBonus.ranges]);
    const sportMultiBetMinOdds = useMemo(() => (sportMultiBetBonus === null || sportMultiBetBonus === void 0 ? void 0 : sportMultiBetBonus.min_odds) || "", [sportMultiBetBonus === null || sportMultiBetBonus === void 0 ? void 0 : sportMultiBetBonus.min_odds]);
    const sportMultiBetLimits = useMemo(() => (sportMultiBetBonus === null || sportMultiBetBonus === void 0 ? void 0 : sportMultiBetBonus.limit) || null, [sportMultiBetBonus === null || sportMultiBetBonus === void 0 ? void 0 : sportMultiBetBonus.limit]);
    const value = useMemo(() => ({
        changeOddFormat,
        oddFormat,
        siteConfigs: config.data,
        loadSiteConfig,
        siteDefaultCurrency,
        siteSupportedOddsFormat,
        siteDefaultOddsFormat,
        siteCurrencyFormat,
        sitePaymentsConfig,
        siteRegistrationConfig,
        siteMessagingConfig,
        betSlipMaxSelections,
        siteMaxOdds,
        isBetProcessorEnabled,
        betProcessorConfig,
        siteClientCountry,
        siteSupportedWallets,
        siteSupportedCurrencies,
        siteConfigReady,
        siteCurrentOddFormat,
        isCurrencySupported,
        isSportMultiBetBonusesEnabled,
        sportMultiBetBonusRanges,
        sportMultiBetMinOdds,
        sportMultiBetLimits,
    }), [
        changeOddFormat,
        oddFormat,
        config.data,
        loadSiteConfig,
        siteDefaultCurrency,
        siteSupportedOddsFormat,
        siteDefaultOddsFormat,
        siteCurrencyFormat,
        sitePaymentsConfig,
        siteRegistrationConfig,
        siteMessagingConfig,
        betSlipMaxSelections,
        siteMaxOdds,
        isBetProcessorEnabled,
        betProcessorConfig,
        siteClientCountry,
        siteSupportedWallets,
        siteSupportedCurrencies,
        siteConfigReady,
        siteCurrentOddFormat,
        isCurrencySupported,
        isSportMultiBetBonusesEnabled,
        sportMultiBetBonusRanges,
        sportMultiBetMinOdds,
        sportMultiBetLimits,
    ]);
    return jsx(ConfigContextV2.Provider, { value: value, children: children });
};

const SmarticoScript = ({ isUserLoggedIn, onLoad }) => {
    const { userId } = useContext(UserAccountContext);
    const { locale } = useContext(LocaleContext);
    const COMMON_SITE_CONFIGS = useRuntimeConfig("COMMON_SITE_CONFIGS");
    useEffect(() => {
        setSmarticoVars();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isUserLoggedIn]);
    const setSmarticoVars = useCallback(() => {
        // window._smartico_allow_localhost = true;
        if (isUserLoggedIn) {
            window._smartico_language = locale !== null && locale !== void 0 ? locale : "";
            window._smartico_user_id = userId ? userId.toString() : "";
        }
        else {
            window._smartico_language = null;
            window._smartico_user_id = null;
        }
    }, [isUserLoggedIn, userId, locale]);
    const onSmarticoScriptLoad = useCallback(() => {
        setSmarticoVars();
        window._smartico.init(COMMON_SITE_CONFIGS.crm.config.labelId, {
            brand_key: COMMON_SITE_CONFIGS.crm.config.brandId,
        });
        onLoad === null || onLoad === void 0 ? void 0 : onLoad();
    }, [
        COMMON_SITE_CONFIGS.crm.config.brandId,
        COMMON_SITE_CONFIGS.crm.config.labelId,
        onLoad,
        setSmarticoVars,
    ]);
    return (jsx(Script, { src: "https://libs.smartico.ai/smartico.js", onLoad: onSmarticoScriptLoad, async: true }));
};

const CrmContext = createContext(null);
const CrmProvider = ({ children }) => {
    const { isUserLoggedIn } = useContext(AuthContext);
    const COMMON_SITE_CONFIGS = useRuntimeConfig("COMMON_SITE_CONFIGS");
    const [unreadMessagesCount, setUnreadMessagesCount] = useState(0);
    const onLoadHandler = useCallback(() => {
        window._smartico.on("props_change", function (props) {
            if (props.core_inbox_unread_count) {
                setUnreadMessagesCount(props.core_inbox_unread_count);
            }
        });
    }, []);
    const openGamificationUi = useCallback(() => {
        window._smartico.dp("dp:gf");
    }, []);
    const openInbox = useCallback(() => {
        window._smartico.dp("dp:inbox");
    }, []);
    const value = useMemo(() => ({
        unreadMessagesCount,
        openGamificationUi,
        openInbox,
    }), [unreadMessagesCount, openGamificationUi, openInbox]);
    return (jsxs(CrmContext.Provider, { value: value, children: [COMMON_SITE_CONFIGS.crm.enable && (jsx(SmarticoScript, { isUserLoggedIn: isUserLoggedIn, onLoad: onLoadHandler })), children] }));
};

const SmarticoScriptV2 = ({ isUserLoggedIn, onLoad }) => {
    const { userId } = useContext(UserAccountContextV2);
    const { locale } = useContext(LocaleContext);
    const COMMON_SITE_CONFIGS = useRuntimeConfig("COMMON_SITE_CONFIGS");
    useEffect(() => {
        setSmarticoVars();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isUserLoggedIn]);
    const setSmarticoVars = useCallback(() => {
        // window._smartico_allow_localhost = true;
        if (isUserLoggedIn) {
            window._smartico_language = locale !== null && locale !== void 0 ? locale : "";
            window._smartico_user_id = userId ? userId.toString() : "";
        }
        else {
            window._smartico_language = null;
            window._smartico_user_id = null;
        }
    }, [isUserLoggedIn, userId, locale]);
    const onSmarticoScriptLoad = useCallback(() => {
        setSmarticoVars();
        window._smartico.init(COMMON_SITE_CONFIGS.crm.config.labelId, {
            brand_key: COMMON_SITE_CONFIGS.crm.config.brandId,
        });
        onLoad === null || onLoad === void 0 ? void 0 : onLoad();
    }, [
        COMMON_SITE_CONFIGS.crm.config.brandId,
        COMMON_SITE_CONFIGS.crm.config.labelId,
        onLoad,
        setSmarticoVars,
    ]);
    return (jsx(Script, { src: "https://libs.smartico.ai/smartico.js", onLoad: onSmarticoScriptLoad, async: true }));
};

const CrmContextV2 = createContext(null);
const CrmProviderV2 = ({ children }) => {
    const { isUserLoggedIn } = useContext(AuthContext);
    const COMMON_SITE_CONFIGS = useRuntimeConfig("COMMON_SITE_CONFIGS");
    const [unreadMessagesCount, setUnreadMessagesCount] = useState(0);
    const onLoadHandler = useCallback(() => {
        window._smartico.on("props_change", function (props) {
            if (props.core_inbox_unread_count) {
                setUnreadMessagesCount(props.core_inbox_unread_count);
            }
        });
    }, []);
    const openGamificationUi = useCallback(() => {
        window._smartico.dp("dp:gf");
    }, []);
    const openInbox = useCallback(() => {
        window._smartico.dp("dp:inbox");
    }, []);
    const value = useMemo(() => ({
        unreadMessagesCount,
        openGamificationUi,
        openInbox,
    }), [unreadMessagesCount, openGamificationUi, openInbox]);
    return (jsxs(CrmContextV2.Provider, { value: value, children: [COMMON_SITE_CONFIGS.crm.enable && (jsx(SmarticoScriptV2, { isUserLoggedIn: isUserLoggedIn, onLoad: onLoadHandler })), children] }));
};

const VerificationDocumentsContext = createContext(null);
const VerificationDocumentsProvider = ({ children }) => {
    const client = useContext(ClientBFFContext);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [documents, setDocuments] = useState([]);
    const uploadFiles = useCallback((files, path) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        try {
            let fileIds = [];
            const fetchPromises = files.map((file) => __awaiter(void 0, void 0, void 0, function* () {
                const res = yield client.createFile({
                    path: path,
                    filename: file.name,
                    body: file,
                });
                return res;
            }));
            const results = yield Promise.all(fetchPromises);
            fileIds = results.map((result) => result.id);
            return fileIds;
        }
        catch (err) {
            const error = ((_a = err.response) === null || _a === void 0 ? void 0 : _a.data) || err;
            console.log(error);
            setError(error.message);
            return [];
        }
    }), [client]);
    const submitIdentityDocument = useCallback((files, type) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        setLoading(true);
        try {
            let response = null;
            const fileIds = yield uploadFiles(files, "kyc/documents");
            if (fileIds.length) {
                response = yield client.createDocument({
                    document_type: DocumentType.IDENTITY_DOCUMENT,
                    identity_document_type: type,
                    files: fileIds,
                });
            }
            else {
                setError("File ids unavailable");
            }
            setLoading(false);
            return response;
        }
        catch (err) {
            const error = ((_a = err.response) === null || _a === void 0 ? void 0 : _a.data) || err;
            console.log(error);
            setError(error.message);
            setLoading(false);
            return null;
        }
    }), [client, uploadFiles]);
    const submitAddressDocument = useCallback((files) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        setLoading(true);
        try {
            let response = null;
            const fileIds = yield uploadFiles(files, "kyc/address");
            if (fileIds.length) {
                response = yield client.createDocument({
                    document_type: DocumentType.ADDRESS,
                    files: fileIds,
                });
            }
            else {
                setError("File ids unavailable");
            }
            setLoading(false);
            return response;
        }
        catch (err) {
            const error = ((_a = err.response) === null || _a === void 0 ? void 0 : _a.data) || err;
            console.log(error);
            setError(error.message);
            setLoading(false);
            return null;
        }
    }), [client, uploadFiles]);
    const submitPaymentProof = useCallback((files) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        setLoading(true);
        try {
            let response = null;
            const fileIds = yield uploadFiles(files, "kyc/address");
            if (fileIds.length) {
                response = yield client.createDocument({
                    document_type: DocumentType.PAYMENT,
                    files: fileIds,
                });
            }
            else {
                setError("File ids unavailable");
            }
            setLoading(false);
            return response;
        }
        catch (err) {
            const error = ((_a = err.response) === null || _a === void 0 ? void 0 : _a.data) || err;
            console.log(error);
            setError(error.message);
            setLoading(false);
            return null;
        }
    }), [client, uploadFiles]);
    const loadAllDocuments = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        const response = yield client.getUserDocuments();
        setLoading(false);
        return response.items;
    }), [client]);
    useEffect(() => {
        loadDocuments();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const loadDocuments = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield loadAllDocuments();
        setDocuments(response);
    }), [loadAllDocuments]);
    const value = useMemo(() => ({
        loadDocuments,
        documents,
        loading,
        submitIdentityDocument,
        submitAddressDocument,
        submitPaymentProof,
        error,
    }), [
        loadDocuments,
        documents,
        loading,
        submitIdentityDocument,
        submitAddressDocument,
        submitPaymentProof,
        error,
    ]);
    return (jsx(VerificationDocumentsContext.Provider, { value: value, children: children }));
};

const ExchangeRatesContext = createContext(null);
const ExchangeRatesProvider = ({ children, fxCurrency }) => {
    var _a, _b;
    const { currentCurrency, userData } = useContext(UserAccountContext);
    const { siteDefaultCurrency, betProcessorConfig } = useContext(ConfigContext);
    const [rates, setRates] = useState({
        data: null,
        loading: false,
    });
    const setExchangeRatesData = useCallback((val) => {
        setRates((state) => (Object.assign(Object.assign({}, state), { data: val, loading: false })));
    }, []);
    const exchangeRatesIsReady = useMemo(() => { var _a; return Boolean((_a = rates.data) === null || _a === void 0 ? void 0 : _a.revision); }, [(_a = rates.data) === null || _a === void 0 ? void 0 : _a.revision]);
    const exchangeRates = useMemo(() => { var _a, _b; return (_b = (_a = rates.data) === null || _a === void 0 ? void 0 : _a.rates) !== null && _b !== void 0 ? _b : null; }, [(_b = rates.data) === null || _b === void 0 ? void 0 : _b.rates]);
    const exchangeRateForActiveCurrency = useMemo(() => currentCurrency && (exchangeRates === null || exchangeRates === void 0 ? void 0 : exchangeRates[currentCurrency]), [currentCurrency, exchangeRates]);
    const usdExchangeRate = useMemo(() => {
        var _a, _b;
        const result = parseFloat((_b = (_a = exchangeRateForActiveCurrency === null || exchangeRateForActiveCurrency === void 0 ? void 0 : exchangeRateForActiveCurrency.find((item) => item.toCurrency === Currency.USD)) === null || _a === void 0 ? void 0 : _a.rate) !== null && _b !== void 0 ? _b : "");
        return !Number.isNaN(result) ? result : 0;
    }, [exchangeRateForActiveCurrency]);
    const defaultCurrencyExchangeRate = useMemo(() => {
        var _a, _b;
        const result = parseFloat((_b = (_a = exchangeRateForActiveCurrency === null || exchangeRateForActiveCurrency === void 0 ? void 0 : exchangeRateForActiveCurrency.find((item) => item.toCurrency === siteDefaultCurrency)) === null || _a === void 0 ? void 0 : _a.rate) !== null && _b !== void 0 ? _b : "");
        return !Number.isNaN(result) ? result : 0;
    }, [exchangeRateForActiveCurrency, siteDefaultCurrency]);
    const fxCurrencyExchangeRate = useMemo(() => {
        var _a, _b;
        const result = parseFloat((_b = (_a = exchangeRateForActiveCurrency === null || exchangeRateForActiveCurrency === void 0 ? void 0 : exchangeRateForActiveCurrency.find((item) => item.toCurrency === fxCurrency)) === null || _a === void 0 ? void 0 : _a.rate) !== null && _b !== void 0 ? _b : "");
        return !Number.isNaN(result) ? result : 0;
    }, [exchangeRateForActiveCurrency, fxCurrency]);
    const userCurrencyExchangeRate = useMemo(() => {
        var _a, _b;
        const result = parseFloat((_b = (_a = exchangeRateForActiveCurrency === null || exchangeRateForActiveCurrency === void 0 ? void 0 : exchangeRateForActiveCurrency.find((item) => item.toCurrency === (userData === null || userData === void 0 ? void 0 : userData.currency))) === null || _a === void 0 ? void 0 : _a.rate) !== null && _b !== void 0 ? _b : "");
        return !Number.isNaN(result) ? result : 0;
    }, [exchangeRateForActiveCurrency, userData === null || userData === void 0 ? void 0 : userData.currency]);
    const minBet = useMemo(() => {
        var _a;
        const result = ((_a = betProcessorConfig === null || betProcessorConfig === void 0 ? void 0 : betProcessorConfig.min_bet.amount_usd) !== null && _a !== void 0 ? _a : 0) / usdExchangeRate;
        return !Number.isNaN(parseInt(result.toString())) ? Math.ceil(result) : 0;
    }, [usdExchangeRate, betProcessorConfig === null || betProcessorConfig === void 0 ? void 0 : betProcessorConfig.min_bet.amount_usd]);
    const maxBet = useMemo(() => {
        var _a;
        const result = ((_a = betProcessorConfig === null || betProcessorConfig === void 0 ? void 0 : betProcessorConfig.max_bet.amount_usd) !== null && _a !== void 0 ? _a : 0) / usdExchangeRate;
        return !Number.isNaN(parseInt(result.toString())) ? Math.floor(result) : 0;
    }, [usdExchangeRate, betProcessorConfig === null || betProcessorConfig === void 0 ? void 0 : betProcessorConfig.max_bet.amount_usd]);
    const maxWin = useMemo(() => {
        var _a;
        const result = ((_a = betProcessorConfig === null || betProcessorConfig === void 0 ? void 0 : betProcessorConfig.max_win.amount_usd) !== null && _a !== void 0 ? _a : 0) / usdExchangeRate;
        return !Number.isNaN(parseInt(result.toString())) ? Math.floor(result) : 0;
    }, [usdExchangeRate, betProcessorConfig === null || betProcessorConfig === void 0 ? void 0 : betProcessorConfig.max_win.amount_usd]);
    const value = useMemo(() => ({
        setExchangeRatesData,
        exchangeRatesIsReady,
        exchangeRates,
        exchangeRateForActiveCurrency,
        usdExchangeRate,
        defaultCurrencyExchangeRate,
        userCurrencyExchangeRate,
        fxCurrencyExchangeRate,
        minBet,
        maxBet,
        maxWin,
    }), [
        setExchangeRatesData,
        exchangeRatesIsReady,
        exchangeRates,
        exchangeRateForActiveCurrency,
        usdExchangeRate,
        defaultCurrencyExchangeRate,
        userCurrencyExchangeRate,
        fxCurrencyExchangeRate,
        minBet,
        maxBet,
        maxWin,
    ]);
    return jsx(ExchangeRatesContext.Provider, { value: value, children: children });
};

const ExchangeRatesContextV2 = createContext(null);
const ExchangeRatesProviderV2 = ({ children, fxCurrency, }) => {
    var _a, _b;
    const { currentCurrency, userData } = useContext(UserAccountContextV2);
    const { siteDefaultCurrency, betProcessorConfig } = useContext(ConfigContextV2);
    const [rates, setRates] = useState({
        data: null,
        loading: false,
    });
    const setExchangeRatesData = useCallback((val) => {
        setRates((state) => (Object.assign(Object.assign({}, state), { data: val, loading: false })));
    }, []);
    const exchangeRatesIsReady = useMemo(() => { var _a; return Boolean((_a = rates.data) === null || _a === void 0 ? void 0 : _a.revision); }, [(_a = rates.data) === null || _a === void 0 ? void 0 : _a.revision]);
    const exchangeRates = useMemo(() => { var _a, _b; return (_b = (_a = rates.data) === null || _a === void 0 ? void 0 : _a.rates) !== null && _b !== void 0 ? _b : null; }, [(_b = rates.data) === null || _b === void 0 ? void 0 : _b.rates]);
    const exchangeRateForActiveCurrency = useMemo(() => currentCurrency && (exchangeRates === null || exchangeRates === void 0 ? void 0 : exchangeRates[currentCurrency]), [currentCurrency, exchangeRates]);
    const usdExchangeRate = useMemo(() => {
        var _a, _b;
        const result = parseFloat((_b = (_a = exchangeRateForActiveCurrency === null || exchangeRateForActiveCurrency === void 0 ? void 0 : exchangeRateForActiveCurrency.find((item) => item.toCurrency === Currency.USD)) === null || _a === void 0 ? void 0 : _a.rate) !== null && _b !== void 0 ? _b : "");
        return !Number.isNaN(result) ? result : 0;
    }, [exchangeRateForActiveCurrency]);
    const defaultCurrencyExchangeRate = useMemo(() => {
        var _a, _b;
        const result = parseFloat((_b = (_a = exchangeRateForActiveCurrency === null || exchangeRateForActiveCurrency === void 0 ? void 0 : exchangeRateForActiveCurrency.find((item) => item.toCurrency === siteDefaultCurrency)) === null || _a === void 0 ? void 0 : _a.rate) !== null && _b !== void 0 ? _b : "");
        return !Number.isNaN(result) ? result : 0;
    }, [exchangeRateForActiveCurrency, siteDefaultCurrency]);
    const fxCurrencyExchangeRate = useMemo(() => {
        var _a, _b;
        const result = parseFloat((_b = (_a = exchangeRateForActiveCurrency === null || exchangeRateForActiveCurrency === void 0 ? void 0 : exchangeRateForActiveCurrency.find((item) => item.toCurrency === fxCurrency)) === null || _a === void 0 ? void 0 : _a.rate) !== null && _b !== void 0 ? _b : "");
        return !Number.isNaN(result) ? result : 0;
    }, [exchangeRateForActiveCurrency, fxCurrency]);
    const userCurrencyExchangeRate = useMemo(() => {
        var _a, _b;
        const result = parseFloat((_b = (_a = exchangeRateForActiveCurrency === null || exchangeRateForActiveCurrency === void 0 ? void 0 : exchangeRateForActiveCurrency.find((item) => item.toCurrency === (userData === null || userData === void 0 ? void 0 : userData.currency))) === null || _a === void 0 ? void 0 : _a.rate) !== null && _b !== void 0 ? _b : "");
        return !Number.isNaN(result) ? result : 0;
    }, [exchangeRateForActiveCurrency, userData === null || userData === void 0 ? void 0 : userData.currency]);
    const minBet = useMemo(() => {
        var _a;
        const result = ((_a = betProcessorConfig === null || betProcessorConfig === void 0 ? void 0 : betProcessorConfig.min_bet.amount_usd) !== null && _a !== void 0 ? _a : 0) / usdExchangeRate;
        return !Number.isNaN(parseInt(result.toString())) ? Math.ceil(result) : 0;
    }, [usdExchangeRate, betProcessorConfig === null || betProcessorConfig === void 0 ? void 0 : betProcessorConfig.min_bet.amount_usd]);
    const maxBet = useMemo(() => {
        var _a;
        const result = ((_a = betProcessorConfig === null || betProcessorConfig === void 0 ? void 0 : betProcessorConfig.max_bet.amount_usd) !== null && _a !== void 0 ? _a : 0) / usdExchangeRate;
        return !Number.isNaN(parseInt(result.toString())) ? Math.floor(result) : 0;
    }, [usdExchangeRate, betProcessorConfig === null || betProcessorConfig === void 0 ? void 0 : betProcessorConfig.max_bet.amount_usd]);
    const maxWin = useMemo(() => {
        var _a;
        const result = ((_a = betProcessorConfig === null || betProcessorConfig === void 0 ? void 0 : betProcessorConfig.max_win.amount_usd) !== null && _a !== void 0 ? _a : 0) / usdExchangeRate;
        return !Number.isNaN(parseInt(result.toString())) ? Math.floor(result) : 0;
    }, [usdExchangeRate, betProcessorConfig === null || betProcessorConfig === void 0 ? void 0 : betProcessorConfig.max_win.amount_usd]);
    const value = useMemo(() => ({
        setExchangeRatesData,
        exchangeRatesIsReady,
        exchangeRates,
        exchangeRateForActiveCurrency,
        usdExchangeRate,
        defaultCurrencyExchangeRate,
        userCurrencyExchangeRate,
        fxCurrencyExchangeRate,
        minBet,
        maxBet,
        maxWin,
    }), [
        setExchangeRatesData,
        exchangeRatesIsReady,
        exchangeRates,
        exchangeRateForActiveCurrency,
        usdExchangeRate,
        defaultCurrencyExchangeRate,
        userCurrencyExchangeRate,
        fxCurrencyExchangeRate,
        minBet,
        maxBet,
        maxWin,
    ]);
    return (jsx(ExchangeRatesContextV2.Provider, { value: value, children: children }));
};

const ModalsContext = createContext(null);
const ModalsProvider = ({ children }) => {
    const { loadSiteConfig } = useContext(ConfigContext);
    const [current, setCurrent] = useState(null);
    const [prev, setPrev] = useState(null);
    const loginModalRef = useRef(null);
    const signupModalRef = useRef(null);
    const accountModalRef = useRef(null);
    const walletModalRef = useRef(null);
    const kycVerifyModalRef = useRef(null);
    const personalDetailsVerificationModalRef = useRef(null);
    const openWalletModal = useCallback(() => {
        var _a;
        loadSiteConfig();
        (_a = walletModalRef.current) === null || _a === void 0 ? void 0 : _a.open();
    }, [loadSiteConfig]);
    const openKycVerifyModal = useCallback(() => {
        var _a;
        // loadSiteConfig();
        (_a = kycVerifyModalRef.current) === null || _a === void 0 ? void 0 : _a.open();
    }, []);
    const setCurrentModal = useCallback((val) => {
        setPrev(current);
        setCurrent(val);
    }, [current]);
    const clearCurrentModal = useCallback(() => {
        setCurrent(null);
    }, []);
    const clearPrevModal = useCallback(() => {
        setPrev(null);
    }, []);
    const isAnyModalOpened = useMemo(() => !!(current || prev), [current, prev]);
    const value = useMemo(() => ({
        currentModal: current,
        previousModal: prev,
        setCurrentModal,
        clearPrevModal,
        clearCurrentModal,
        isAnyModalOpened,
        loginModalRef,
        signupModalRef,
        accountModalRef,
        walletModalRef,
        kycVerifyModalRef,
        openWalletModal,
        openKycVerifyModal,
        personalDetailsVerificationModalRef,
    }), [
        current,
        prev,
        setCurrentModal,
        clearPrevModal,
        clearCurrentModal,
        isAnyModalOpened,
        openWalletModal,
        openKycVerifyModal,
    ]);
    return jsx(ModalsContext.Provider, { value: value, children: children });
};

const ModalsContextV2 = createContext(null);
const ModalsProviderV2 = ({ children }) => {
    const { loadSiteConfig } = useContext(ConfigContextV2);
    const [current, setCurrent] = useState(null);
    const [prev, setPrev] = useState(null);
    const loginModalRef = useRef(null);
    const signupModalRef = useRef(null);
    const accountModalRef = useRef(null);
    const walletModalRef = useRef(null);
    const kycVerifyModalRef = useRef(null);
    const personalDetailsVerificationModalRef = useRef(null);
    const openWalletModal = useCallback(() => {
        var _a;
        loadSiteConfig();
        (_a = walletModalRef.current) === null || _a === void 0 ? void 0 : _a.open();
    }, [loadSiteConfig]);
    const openKycVerifyModal = useCallback(() => {
        var _a;
        // loadSiteConfig();
        (_a = kycVerifyModalRef.current) === null || _a === void 0 ? void 0 : _a.open();
    }, []);
    const setCurrentModal = useCallback((val) => {
        setPrev(current);
        setCurrent(val);
    }, [current]);
    const clearCurrentModal = useCallback(() => {
        setCurrent(null);
    }, []);
    const clearPrevModal = useCallback(() => {
        setPrev(null);
    }, []);
    const isAnyModalOpened = useMemo(() => !!(current || prev), [current, prev]);
    const value = useMemo(() => ({
        currentModal: current,
        previousModal: prev,
        setCurrentModal,
        clearPrevModal,
        clearCurrentModal,
        isAnyModalOpened,
        loginModalRef,
        signupModalRef,
        accountModalRef,
        walletModalRef,
        kycVerifyModalRef,
        openWalletModal,
        openKycVerifyModal,
        personalDetailsVerificationModalRef,
    }), [
        clearCurrentModal,
        clearPrevModal,
        current,
        isAnyModalOpened,
        openKycVerifyModal,
        openWalletModal,
        prev,
        setCurrentModal,
    ]);
    return jsx(ModalsContextV2.Provider, { value: value, children: children });
};

const convertToLocalStorageItems$1 = (bets) => {
    return bets.map((bet) => (Object.assign(Object.assign({}, bet), { limits: undefined, stake: "", error: undefined })));
};
const getBetType$1 = (betsAmount, betType) => {
    if (betType === TicketType.Single && betsAmount >= 2) {
        return TicketType.Express;
    }
    if (betType === TicketType.Express && betsAmount < 2) {
        return TicketType.Single;
    }
    return betType;
};
const BetSlipContext = createContext(null);
const BetSlipProvider = ({ children }) => {
    const [betType, setBetTypeState] = useState(TicketType.Single);
    const [betMode, setBetMode] = useState(OddsChangeMode.Exact);
    const [betItems, setBetItems] = useState([]);
    const [placeBetButtonEnabled, setPlaceBetButtonEnabled] = useState(false);
    const [showAcceptButton, setShowAcceptButton] = useState(false);
    const [multipleBetStake, setMultipleBetStake] = useState("");
    const [systemBetStake, setSystemBetStake] = useState("");
    const [systemBetSelection, setSystemBetSelection] = useState(2);
    const [betProcessing, setBetProcessing] = useState(false);
    const [error, setError] = useState(null);
    // const { currentRange } = useContext(MultiBetBonusContext) ?? {};
    const { betProcessorConfig } = useContext(ConfigContext);
    useEffect(() => {
        if (betItems.length) {
            setBetType(getBetType$1(betItems.length, betType));
        }
        else if (betItems.length === 0) {
            setMultipleBetStake("0");
            setSystemBetStake("0");
        }
        sessionStorage.setItem(BrowserStorageIdsEnum.BET_ITEMS, JSON.stringify(convertToLocalStorageItems$1(betItems)));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [betItems.length]);
    const setBetType = useCallback((val) => {
        if (!betProcessing) {
            setBetTypeState(val);
        }
    }, [betProcessing]);
    const updateBetItemByIndex = useCallback((index, payload) => {
        let newBetItems = [];
        setBetItems((state) => {
            newBetItems = [...state];
            newBetItems[index] = payload;
            return newBetItems;
        });
        sessionStorage.setItem(BrowserStorageIdsEnum.BET_ITEMS, JSON.stringify(convertToLocalStorageItems$1(newBetItems)));
    }, []);
    const addBetItem = useCallback((payload) => {
        if (!betProcessing) {
            const index = betItems.findIndex((bet) => bet.gameId === payload.gameId);
            const betAlreadyExists = index !== -1;
            if (betAlreadyExists) {
                if (betProcessing)
                    return;
                updateBetItemByIndex(index, payload);
            }
            else {
                setBetItems((state) => [...state, payload]);
                setError(null);
            }
        }
    }, [betItems, betProcessing, updateBetItemByIndex]);
    const removeBetItem = useCallback((id) => {
        var _a;
        const index = betItems.findIndex((item) => item.outcomeId === id);
        const betAlreadyExists = index !== -1;
        const betIsLoading = (_a = betItems[index]) === null || _a === void 0 ? void 0 : _a.loading;
        if (betAlreadyExists && !betIsLoading) {
            const removeBetItemByIndex = (index) => {
                setBetItems((state) => {
                    /* const newBetItems = [...state];
                    newBetItems.splice(index, 1); */
                    const newBetItems = state.filter((_, i) => i !== index);
                    return newBetItems;
                });
            };
            removeBetItemByIndex(index);
            setError(null);
        }
    }, [betItems]);
    const updateBetItem = useCallback((payload) => {
        if (payload.outcomeId) {
            setBetItems((state) => {
                const index = state.findIndex((item) => item.outcomeId === payload.outcomeId);
                if (index !== -1) {
                    const newBetItems = [...state];
                    newBetItems[index] = Object.assign(Object.assign({}, state[index]), payload);
                    return newBetItems;
                }
                return state;
            });
        }
    }, []);
    const removeAllBetItems = useCallback(() => {
        if (!betProcessing) {
            sessionStorage.removeItem(BrowserStorageIdsEnum.BET_ITEMS);
            setBetItems([]);
        }
    }, [betProcessing]);
    const updateButtons = useCallback((payload) => {
        setPlaceBetButtonEnabled(payload.placeBetButtonEnabled);
        setShowAcceptButton(payload.showAcceptButton);
    }, []);
    const changeMultipleBetStake = useCallback((val) => {
        if (!betProcessing) {
            setMultipleBetStake(val);
        }
    }, [betProcessing]);
    const changeSystemBetStake = useCallback((val) => {
        if (!betProcessing) {
            setSystemBetStake(val);
        }
    }, [betProcessing]);
    const changeSystemBetSelection = useCallback((val) => {
        if (!betProcessing) {
            setSystemBetSelection(val);
        }
    }, [betProcessing]);
    const betItemsForBetMax = useMemo(() => betItems === null || betItems === void 0 ? void 0 : betItems.map((bet) => ({
        event_id: bet.gameId,
        market_id: bet.marketId,
        outcome_id: bet.outcomeId,
        odds: bet.outcomeValue,
    })), [betItems]);
    const multipleBetTotalOdds = useMemo(() => {
        const res = betItems.reduce((sum, a) => sum * parseFloat(a.outcomeValue), 1);
        return res === 1 ? 0 : parseFloat(res.toFixed(2));
    }, [betItems]);
    const systemBetVariantsCount = useMemo(() => {
        const count = betItems.length;
        if (count < 3) {
            return 0;
        }
        return (factorial(count) /
            (factorial(systemBetSelection) * factorial(count - systemBetSelection)));
    }, [betItems.length, systemBetSelection]);
    const systemBetTotalOdds = useMemo(() => {
        const oddsArray = sumOfOddsSubsets(betItems);
        return oddsArray[betItems.length][systemBetSelection];
    }, [betItems, systemBetSelection]);
    const totalStake = useMemo(() => {
        if (!betItems || !betItems.length)
            return 0;
        return betItems.reduce((memo, item) => (item.stake ? memo + parseFloat(item.stake) : memo + 0), 0);
    }, [betItems]);
    const isOutcomeSelected = useCallback((id) => betItems.findIndex((item) => item.outcomeId === id) !== -1, [betItems]);
    const possibleWinAmount = useMemo(() => {
        let win = 0;
        switch (betType) {
            case TicketType.Single:
                for (let i = 0; i < betItems.length; ++i) {
                    win +=
                        parseFloat(betItems[i].outcomeValue) *
                            (betItems[i].stake ? parseFloat(betItems[i].stake) : 0);
                }
                break;
            case TicketType.Express:
                win = multipleBetTotalOdds * (multipleBetStake ? parseFloat(multipleBetStake) : 0);
                break;
        }
        return win;
    }, [betItems, betType, multipleBetStake, multipleBetTotalOdds]);
    const getTaxAmount = useCallback((possibleBonusAmount) => {
        let tax = 0;
        if (betProcessorConfig === null || betProcessorConfig === void 0 ? void 0 : betProcessorConfig.tax.rate) {
            switch (betType) {
                case TicketType.Single:
                    tax =
                        ((possibleWinAmount - totalStake) * betProcessorConfig.tax.rate) / 100;
                    break;
                case TicketType.Express:
                    const bonus = possibleBonusAmount || 0;
                    tax =
                        ((possibleWinAmount -
                            (multipleBetStake ? parseFloat(multipleBetStake) : 0) +
                            bonus) *
                            betProcessorConfig.tax.rate) /
                            100;
                    break;
            }
        }
        return tax;
    }, [betProcessorConfig === null || betProcessorConfig === void 0 ? void 0 : betProcessorConfig.tax.rate, betType, multipleBetStake, possibleWinAmount, totalStake]);
    const getTotalWinAmount = useCallback((possibleBonusAmount) => {
        let win = 0;
        switch (betType) {
            case TicketType.Single:
                win = possibleWinAmount - getTaxAmount();
                break;
            case TicketType.Express:
                const bonus = possibleBonusAmount || 0;
                win = possibleWinAmount + bonus;
                if (betProcessorConfig === null || betProcessorConfig === void 0 ? void 0 : betProcessorConfig.tax.enabled) {
                    win -= getTaxAmount(possibleBonusAmount);
                }
                break;
        }
        return win;
    }, [betProcessorConfig === null || betProcessorConfig === void 0 ? void 0 : betProcessorConfig.tax.enabled, betType, getTaxAmount, possibleWinAmount]);
    const value = useMemo(() => ({
        betType,
        betItems,
        placeBetButtonEnabled,
        betMode,
        multipleBetStake,
        systemBetStake,
        showAcceptButton,
        betProcessing,
        betSlipError: error,
        systemBetSelection,
        betItemsForBetMax,
        multipleBetTotalOdds,
        systemBetVariantsCount,
        systemBetTotalOdds,
        totalStake,
        possibleWinAmount,
        getTaxAmount,
        getTotalWinAmount,
        setBetType,
        setBetMode,
        addBetItem,
        removeBetItem,
        updateBetItem,
        removeAllBetItems,
        updateButtons,
        changeMultipleBetStake,
        changeSystemBetStake,
        changeSystemBetSelection,
        changeBetProcessing: setBetProcessing,
        setBetError: setError,
        isOutcomeSelected,
    }), [
        betType,
        betItems,
        placeBetButtonEnabled,
        betMode,
        multipleBetStake,
        systemBetStake,
        showAcceptButton,
        betProcessing,
        error,
        systemBetSelection,
        betItemsForBetMax,
        multipleBetTotalOdds,
        systemBetVariantsCount,
        systemBetTotalOdds,
        totalStake,
        possibleWinAmount,
        getTaxAmount,
        getTotalWinAmount,
        setBetType,
        addBetItem,
        removeBetItem,
        updateBetItem,
        removeAllBetItems,
        updateButtons,
        changeMultipleBetStake,
        changeSystemBetStake,
        changeSystemBetSelection,
        isOutcomeSelected,
    ]);
    return jsx(BetSlipContext.Provider, { value: value, children: children });
};

const MultiBetBonusContext = createContext(null);
const MultiBetBonusProvider = ({ children }) => {
    const { betItems, possibleWinAmount, betType, multipleBetStake } = useContext(BetSlipContext);
    const { sportMultiBetBonusRanges, sportMultiBetMinOdds, sportMultiBetLimits } = useContext(ConfigContext);
    const [validation, setValidation] = useState({
        error: "",
        valid: true,
    });
    const betItemsAmount = betItems.length;
    const minRangeStart = useMemo(() => Math.min(...sportMultiBetBonusRanges.map((r) => r.range_start)), [sportMultiBetBonusRanges]);
    const currentRange = useMemo(() => {
        const lastRange = sportMultiBetBonusRanges[sportMultiBetBonusRanges.length - 1];
        if (validation.error) {
            return null;
        }
        if (betItemsAmount >= lastRange.range_end) {
            return lastRange;
        }
        return (sportMultiBetBonusRanges.find((range) => betItemsAmount >= range.range_start && betItemsAmount < range.range_end) || null);
    }, [betItemsAmount, sportMultiBetBonusRanges, validation.error]);
    const upcomingRange = useMemo(() => {
        let result;
        if (currentRange) {
            result = sportMultiBetBonusRanges.find((range) => range.range_start > currentRange.range_start &&
                betItemsAmount < range.range_end);
        }
        else {
            result = sportMultiBetBonusRanges.find((range) => range.range_start === minRangeStart);
        }
        return result || null;
    }, [betItemsAmount, currentRange, minRangeStart, sportMultiBetBonusRanges]);
    const possibleBonusAmount = useMemo(() => {
        let bonus = 0;
        switch (betType) {
            case TicketType.Express:
                const amount = possibleWinAmount - (multipleBetStake ? parseFloat(multipleBetStake) : 0);
                bonus = currentRange ? (amount * currentRange.rate) / 100 : 0;
                break;
        }
        if (!!(sportMultiBetLimits === null || sportMultiBetLimits === void 0 ? void 0 : sportMultiBetLimits.max_win)) {
            const multibetMaxWin = parseFloat(sportMultiBetLimits.max_win);
            if (bonus >= multibetMaxWin) {
                return multibetMaxWin;
            }
        }
        return bonus;
    }, [betType, currentRange, multipleBetStake, possibleWinAmount, sportMultiBetLimits === null || sportMultiBetLimits === void 0 ? void 0 : sportMultiBetLimits.max_win]);
    const performMultiBetBonusValidate = useCallback((betItems) => {
        let error = "";
        const lessThanMinOddBets = betItems.filter((bet) => parseFloat(bet.outcomeValue) < parseFloat(sportMultiBetMinOdds));
        if (lessThanMinOddBets.length) {
            error = "min_odds";
        }
        setValidation({ error, valid: !error });
    }, [sportMultiBetMinOdds]);
    const value = useMemo(() => ({
        validation,
        upcomingRange,
        performMultiBetBonusValidate,
        currentRange,
        possibleBonusAmount,
    }), [
        currentRange,
        validation,
        performMultiBetBonusValidate,
        upcomingRange,
        possibleBonusAmount,
    ]);
    return jsx(MultiBetBonusContext.Provider, { value: value, children: children });
};

const convertToLocalStorageItems = (bets) => {
    return bets.map((bet) => (Object.assign(Object.assign({}, bet), { limits: undefined, stake: "", error: undefined })));
};
const getBetType = (betsAmount, betType) => {
    if (betType === TicketType.Single && betsAmount >= 2) {
        return TicketType.Express;
    }
    if (betType === TicketType.Express && betsAmount < 2) {
        return TicketType.Single;
    }
    return betType;
};
const BetSlipContextV2 = createContext(null);
const BetSlipProviderV2 = ({ children }) => {
    const [betType, setBetTypeState] = useState(TicketType.Single);
    const [betMode, setBetMode] = useState(OddsChangeMode.Exact);
    const [betItems, setBetItems] = useState([]);
    const [placeBetButtonEnabled, setPlaceBetButtonEnabled] = useState(false);
    const [showAcceptButton, setShowAcceptButton] = useState(false);
    const [multipleBetStake, setMultipleBetStake] = useState("");
    const [systemBetStake, setSystemBetStake] = useState("");
    const [systemBetSelection, setSystemBetSelection] = useState(2);
    const [betProcessing, setBetProcessing] = useState(false);
    const [error, setError] = useState(null);
    // const { currentRange } = useContext(MultiBetBonusContext) ?? {};
    const { betProcessorConfig } = useContext(ConfigContextV2);
    useEffect(() => {
        if (betItems.length) {
            setBetType(getBetType(betItems.length, betType));
        }
        else if (betItems.length === 0) {
            setMultipleBetStake("0");
            setSystemBetStake("0");
        }
        sessionStorage.setItem(BrowserStorageIdsEnum.BET_ITEMS, JSON.stringify(convertToLocalStorageItems(betItems)));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [betItems.length]);
    const setBetType = useCallback((val) => {
        if (!betProcessing) {
            setBetTypeState(val);
        }
    }, [betProcessing]);
    const updateBetItemByIndex = useCallback((index, payload) => {
        let newBetItems = [];
        setBetItems((state) => {
            newBetItems = [...state];
            newBetItems[index] = payload;
            return newBetItems;
        });
        sessionStorage.setItem(BrowserStorageIdsEnum.BET_ITEMS, JSON.stringify(convertToLocalStorageItems(newBetItems)));
    }, []);
    const addBetItem = useCallback((payload) => {
        if (!betProcessing) {
            const index = betItems.findIndex((bet) => bet.gameId === payload.gameId);
            const betAlreadyExists = index !== -1;
            if (betAlreadyExists) {
                if (betProcessing)
                    return;
                updateBetItemByIndex(index, payload);
            }
            else {
                setBetItems((state) => [...state, payload]);
                setError(null);
            }
        }
    }, [betItems, betProcessing, updateBetItemByIndex]);
    const removeBetItem = useCallback((id) => {
        var _a;
        const index = betItems.findIndex((item) => item.outcomeId === id);
        const betAlreadyExists = index !== -1;
        const betIsLoading = (_a = betItems[index]) === null || _a === void 0 ? void 0 : _a.loading;
        if (betAlreadyExists && !betIsLoading) {
            const removeBetItemByIndex = (index) => {
                setBetItems((state) => {
                    /* const newBetItems = [...state];
                    newBetItems.splice(index, 1); */
                    const newBetItems = state.filter((_, i) => i !== index);
                    return newBetItems;
                });
            };
            removeBetItemByIndex(index);
            setError(null);
        }
    }, [betItems]);
    const updateBetItem = useCallback((payload) => {
        if (payload.outcomeId) {
            setBetItems((state) => {
                const index = state.findIndex((item) => item.outcomeId === payload.outcomeId);
                if (index !== -1) {
                    const newBetItems = [...state];
                    newBetItems[index] = Object.assign(Object.assign({}, state[index]), payload);
                    return newBetItems;
                }
                return state;
            });
        }
    }, []);
    const removeAllBetItems = useCallback(() => {
        if (!betProcessing) {
            sessionStorage.removeItem(BrowserStorageIdsEnum.BET_ITEMS);
            setBetItems([]);
        }
    }, [betProcessing]);
    const updateButtons = useCallback((payload) => {
        setPlaceBetButtonEnabled(payload.placeBetButtonEnabled);
        setShowAcceptButton(payload.showAcceptButton);
    }, []);
    const changeMultipleBetStake = useCallback((val) => {
        if (!betProcessing) {
            setMultipleBetStake(val);
        }
    }, [betProcessing]);
    const changeSystemBetStake = useCallback((val) => {
        if (!betProcessing) {
            setSystemBetStake(val);
        }
    }, [betProcessing]);
    const changeSystemBetSelection = useCallback((val) => {
        if (!betProcessing) {
            setSystemBetSelection(val);
        }
    }, [betProcessing]);
    const betItemsForBetMax = useMemo(() => betItems === null || betItems === void 0 ? void 0 : betItems.map((bet) => ({
        event_id: bet.gameId,
        market_id: bet.marketId,
        outcome_id: bet.outcomeId,
        odds: bet.outcomeValue,
    })), [betItems]);
    const multipleBetTotalOdds = useMemo(() => {
        const res = betItems.reduce((sum, a) => sum * parseFloat(a.outcomeValue), 1);
        return res === 1 ? 0 : parseFloat(res.toFixed(2));
    }, [betItems]);
    const systemBetVariantsCount = useMemo(() => {
        const count = betItems.length;
        if (count < 3) {
            return 0;
        }
        return (factorial(count) /
            (factorial(systemBetSelection) * factorial(count - systemBetSelection)));
    }, [betItems.length, systemBetSelection]);
    const systemBetTotalOdds = useMemo(() => {
        const oddsArray = sumOfOddsSubsets(betItems);
        return oddsArray[betItems.length][systemBetSelection];
    }, [betItems, systemBetSelection]);
    const totalStake = useMemo(() => {
        if (!betItems || !betItems.length)
            return 0;
        return betItems.reduce((memo, item) => (item.stake ? memo + parseFloat(item.stake) : memo + 0), 0);
    }, [betItems]);
    const isOutcomeSelected = useCallback((id) => betItems.findIndex((item) => item.outcomeId === id) !== -1, [betItems]);
    const possibleWinAmount = useMemo(() => {
        let win = 0;
        switch (betType) {
            case TicketType.Single:
                for (let i = 0; i < betItems.length; ++i) {
                    win +=
                        parseFloat(betItems[i].outcomeValue) *
                            (betItems[i].stake ? parseFloat(betItems[i].stake) : 0);
                }
                break;
            case TicketType.Express:
                win = multipleBetTotalOdds * (multipleBetStake ? parseFloat(multipleBetStake) : 0);
                break;
        }
        return win;
    }, [betItems, betType, multipleBetStake, multipleBetTotalOdds]);
    const getTaxAmount = useCallback((possibleBonusAmount) => {
        let tax = 0;
        if (betProcessorConfig === null || betProcessorConfig === void 0 ? void 0 : betProcessorConfig.tax.rate) {
            switch (betType) {
                case TicketType.Single:
                    tax =
                        ((possibleWinAmount - totalStake) * betProcessorConfig.tax.rate) / 100;
                    break;
                case TicketType.Express:
                    const bonus = possibleBonusAmount || 0;
                    tax =
                        ((possibleWinAmount -
                            (multipleBetStake ? parseFloat(multipleBetStake) : 0) +
                            bonus) *
                            betProcessorConfig.tax.rate) /
                            100;
                    break;
            }
        }
        return tax;
    }, [betProcessorConfig === null || betProcessorConfig === void 0 ? void 0 : betProcessorConfig.tax.rate, betType, multipleBetStake, possibleWinAmount, totalStake]);
    const getTotalWinAmount = useCallback((possibleBonusAmount) => {
        let win = 0;
        switch (betType) {
            case TicketType.Single:
                win = possibleWinAmount - getTaxAmount();
                break;
            case TicketType.Express:
                const bonus = possibleBonusAmount || 0;
                win = possibleWinAmount + bonus;
                if (betProcessorConfig === null || betProcessorConfig === void 0 ? void 0 : betProcessorConfig.tax.enabled) {
                    win -= getTaxAmount(possibleBonusAmount);
                }
                break;
        }
        return win;
    }, [betProcessorConfig === null || betProcessorConfig === void 0 ? void 0 : betProcessorConfig.tax.enabled, betType, getTaxAmount, possibleWinAmount]);
    const value = useMemo(() => ({
        betType,
        betItems,
        placeBetButtonEnabled,
        betMode,
        multipleBetStake,
        systemBetStake,
        showAcceptButton,
        betProcessing,
        betSlipError: error,
        systemBetSelection,
        betItemsForBetMax,
        multipleBetTotalOdds,
        systemBetVariantsCount,
        systemBetTotalOdds,
        totalStake,
        possibleWinAmount,
        getTaxAmount,
        getTotalWinAmount,
        setBetType,
        setBetMode,
        addBetItem,
        removeBetItem,
        updateBetItem,
        removeAllBetItems,
        updateButtons,
        changeMultipleBetStake,
        changeSystemBetStake,
        changeSystemBetSelection,
        changeBetProcessing: setBetProcessing,
        setBetError: setError,
        isOutcomeSelected,
    }), [
        betType,
        betItems,
        placeBetButtonEnabled,
        betMode,
        multipleBetStake,
        systemBetStake,
        showAcceptButton,
        betProcessing,
        error,
        systemBetSelection,
        betItemsForBetMax,
        multipleBetTotalOdds,
        systemBetVariantsCount,
        systemBetTotalOdds,
        totalStake,
        possibleWinAmount,
        getTaxAmount,
        getTotalWinAmount,
        setBetType,
        addBetItem,
        removeBetItem,
        updateBetItem,
        removeAllBetItems,
        updateButtons,
        changeMultipleBetStake,
        changeSystemBetStake,
        changeSystemBetSelection,
        isOutcomeSelected,
    ]);
    return jsx(BetSlipContextV2.Provider, { value: value, children: children });
};

const MultiBetBonusContextV2 = createContext(null);
const MultiBetBonusProviderV2 = ({ children }) => {
    const { betItems, possibleWinAmount, betType, multipleBetStake } = useContext(BetSlipContextV2);
    const { sportMultiBetBonusRanges, sportMultiBetMinOdds, sportMultiBetLimits } = useContext(ConfigContextV2);
    const [validation, setValidation] = useState({
        error: "",
        valid: true,
    });
    const betItemsAmount = betItems.length;
    const minRangeStart = useMemo(() => Math.min(...sportMultiBetBonusRanges.map((r) => r.range_start)), [sportMultiBetBonusRanges]);
    const currentRange = useMemo(() => {
        const lastRange = sportMultiBetBonusRanges[sportMultiBetBonusRanges.length - 1];
        if (validation.error) {
            return null;
        }
        if (betItemsAmount >= lastRange.range_end) {
            return lastRange;
        }
        return (sportMultiBetBonusRanges.find((range) => betItemsAmount >= range.range_start && betItemsAmount < range.range_end) || null);
    }, [betItemsAmount, sportMultiBetBonusRanges, validation.error]);
    const upcomingRange = useMemo(() => {
        let result;
        if (currentRange) {
            result = sportMultiBetBonusRanges.find((range) => range.range_start > currentRange.range_start &&
                betItemsAmount < range.range_end);
        }
        else {
            result = sportMultiBetBonusRanges.find((range) => range.range_start === minRangeStart);
        }
        return result || null;
    }, [betItemsAmount, currentRange, minRangeStart, sportMultiBetBonusRanges]);
    const possibleBonusAmount = useMemo(() => {
        let bonus = 0;
        switch (betType) {
            case TicketType.Express:
                const amount = possibleWinAmount - (multipleBetStake ? parseFloat(multipleBetStake) : 0);
                bonus = currentRange ? (amount * currentRange.rate) / 100 : 0;
                break;
        }
        if (!!(sportMultiBetLimits === null || sportMultiBetLimits === void 0 ? void 0 : sportMultiBetLimits.max_win)) {
            const multibetMaxWin = parseFloat(sportMultiBetLimits.max_win);
            if (bonus >= multibetMaxWin) {
                return multibetMaxWin;
            }
        }
        return bonus;
    }, [betType, currentRange, multipleBetStake, possibleWinAmount, sportMultiBetLimits === null || sportMultiBetLimits === void 0 ? void 0 : sportMultiBetLimits.max_win]);
    const performMultiBetBonusValidate = useCallback((betItems) => {
        let error = "";
        const lessThanMinOddBets = betItems.filter((bet) => parseFloat(bet.outcomeValue) < parseFloat(sportMultiBetMinOdds));
        if (lessThanMinOddBets.length) {
            error = "min_odds";
        }
        setValidation({ error, valid: !error });
    }, [sportMultiBetMinOdds]);
    const value = useMemo(() => ({
        validation,
        upcomingRange,
        performMultiBetBonusValidate,
        currentRange,
        possibleBonusAmount,
    }), [
        currentRange,
        validation,
        performMultiBetBonusValidate,
        upcomingRange,
        possibleBonusAmount,
    ]);
    return (jsx(MultiBetBonusContextV2.Provider, { value: value, children: children }));
};

const FeedContext = createContext(null);
const FeedProvider = ({ children }) => {
    const [prematch, setPrematch] = useState({
        loading: true,
        sports: [],
        topLeagues: [],
        error: "",
    });
    const [live, setLive] = useState({
        loading: false,
        sports: [],
        topLeagues: [],
        totalGames: 0,
    });
    const [results, setResults] = useState({
        loading: false,
        sports: [],
    });
    const liveTopLeaguesGamesCount = useMemo(() => live.topLeagues.reduce((acc, league) => acc + league.games_count, 0), [live.topLeagues]);
    const value = useMemo(() => ({
        setPrematch,
        setLive,
        setResults,
        prematchFeed: prematch.sports,
        prematchFeedError: prematch.error,
        liveFeed: live.sports,
        resultsFeed: results.sports,
        prematchTopLeagues: prematch.topLeagues,
        prematchIsLoading: prematch.loading,
        hasPrematchSports: Boolean(prematch.sports.length),
        liveTopLeagues: live.topLeagues,
        liveTopLeaguesGamesCount,
        liveIsLoading: live.loading,
        liveFeedCount: live.totalGames,
        hasLiveFeedGames: Boolean(live.totalGames),
        resultsIsLoading: results.loading,
        hasResultsSports: Boolean(results.sports.length),
    }), [
        live.loading,
        live.sports,
        live.topLeagues,
        live.totalGames,
        liveTopLeaguesGamesCount,
        prematch.error,
        prematch.loading,
        prematch.sports,
        prematch.topLeagues,
        results.loading,
        results.sports,
    ]);
    return jsx(FeedContext.Provider, { value: value, children: children });
};

const ReferralReportContext = createContext(null);
const ReferralReportProvider = ({ children }) => {
    const client = useContext(ClientBFFContext);
    const [referrals, setReferrals] = useState({ data: null, loading: false });
    const [timeframes, setTimeframes] = useState({
        loading: false,
        data: [],
    });
    const loadReferralTimeframes = useCallback((payload) => __awaiter(void 0, void 0, void 0, function* () {
        const { type, scope, count } = payload;
        setTimeframes((state) => (Object.assign(Object.assign({}, state), { loading: true, data: [] })));
        try {
            const response = yield client.getBonuses(type, scope, count);
            setTimeframes((state) => (Object.assign(Object.assign({}, state), { loading: false, data: response.items })));
        }
        catch (error) {
            setTimeframes((state) => (Object.assign(Object.assign({}, state), { loading: false, data: [] })));
        }
    }), [client]);
    const loadReferralReport = useCallback((payload) => __awaiter(void 0, void 0, void 0, function* () {
        const { bonusId } = payload;
        setReferrals((state) => (Object.assign(Object.assign({}, state), { loading: true, data: null })));
        try {
            const response = yield client.getReferralPersonalReport(bonusId);
            setReferrals((state) => (Object.assign(Object.assign({}, state), { loading: false, data: response !== null && response !== void 0 ? response : null })));
        }
        catch (error) {
            setReferrals((state) => (Object.assign(Object.assign({}, state), { loading: false, data: null })));
        }
    }), [client]);
    const value = useMemo(() => ({
        loadReferralReport,
        loadReferralTimeframes,
        referralReportReady: !referrals.loading,
        referralReport: referrals.data,
        referralTimeframesReady: !timeframes.loading,
        referralTimeframes: timeframes.data,
    }), [loadReferralReport, loadReferralTimeframes, referrals, timeframes]);
    return (jsx(ReferralReportContext.Provider, { value: value, children: children }));
};

const RuntimeConfigContext = createContext(null);
const RuntimeConfigProvider = ({ children, config }) => {
    return jsx(RuntimeConfigContext.Provider, { value: config, children: children });
};

const AFFISE_INIT_QUERIES = ["clickid", "click_id"];
const AffiseInitScript = () => {
    var _a;
    const searchParams = useSearchParams();
    const { set } = useContext(BrowserStorageContext);
    useEffect(() => {
        if (searchParams === null || searchParams === void 0 ? void 0 : searchParams.has(BrowserStorageIdsEnum.UTM_CAMPAIGN)) {
            set(BrowserStorageIdsEnum.UTM_CAMPAIGN, searchParams.get(BrowserStorageIdsEnum.UTM_CAMPAIGN) || "");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    for (const key of (_a = searchParams === null || searchParams === void 0 ? void 0 : searchParams.keys()) !== null && _a !== void 0 ? _a : []) {
        if (AFFISE_INIT_QUERIES.includes(key)) {
            return (jsx(Script, { src: "/assets/js/affise-init.js", id: "affise-init", "data-clickid": searchParams === null || searchParams === void 0 ? void 0 : searchParams.get(key), async: true }));
        }
    }
    return null;
};
const affiseTriggerRegistration = () => {
    const script = document.createElement("script");
    script.src = `/assets/js/affise-trigger-registration.js`;
    document.head.appendChild(script);
};

const AgentConfigContext = createContext({});
const AgentConfigProvider = ({ children }) => {
    const client = useContext(ClientBFFContext);
    const [agentConfig, setAgentConfig] = useState();
    const updateAgentConfig = useCallback((newData) => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield client.updateAgentConfig(newData);
        setAgentConfig(response);
    }), [client, setAgentConfig]);
    const loadAgentConfig = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield client.getAgentConfig();
        setAgentConfig(response);
    }), [client]);
    useEffect(() => {
        loadAgentConfig();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const value = useMemo(() => ({ agentConfig, updateAgentConfig }), [agentConfig, updateAgentConfig]);
    return jsx(AgentConfigContext.Provider, { value: value, children: children });
};

const useAgentPlayersList = (searchQuery) => {
    const client = useContext(ClientBFFContext);
    const { agentConfig, updateAgentConfig } = useContext(AgentConfigContext);
    const [pagination, setPagination] = useState(DEFAULT_PAGINATION);
    const [players, setPlayers] = useState([]);
    const [editCol, setEditCol] = useState(null);
    const [totalPages, setTotalPages] = useState(0);
    const playersInfo = useMemo(() => {
        var _a, _b, _c;
        const usersRateSport = (((_a = agentConfig === null || agentConfig === void 0 ? void 0 : agentConfig.Sport) === null || _a === void 0 ? void 0 : _a.users) || []).reduce((acc, user) => {
            acc[user.user_id] = user.rate || 0;
            return acc;
        }, {});
        const usersRateLiveCasino = (((_b = agentConfig === null || agentConfig === void 0 ? void 0 : agentConfig.LiveCasino) === null || _b === void 0 ? void 0 : _b.users) || []).reduce((acc, user) => {
            acc[user.user_id] = user.rate || 0;
            return acc;
        }, {});
        const usersRateCasino = (((_c = agentConfig === null || agentConfig === void 0 ? void 0 : agentConfig.Casino) === null || _c === void 0 ? void 0 : _c.users) || []).reduce((acc, user) => {
            acc[user.user_id] = user.rate || 0;
            return acc;
        }, {});
        return (players || []).map((player) => (Object.assign(Object.assign({}, player), { sportRate: usersRateSport[player.id] || 0, liveCasinoRate: usersRateLiveCasino[player.id] || 0, casinoRate: usersRateCasino[player.id] || 0 })));
    }, [agentConfig, players]);
    const updateSubuserRate = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const newData = Object.assign({}, agentConfig);
        let isFind = false;
        (_a = agentConfig[editCol.type].users) === null || _a === void 0 ? void 0 : _a.forEach((user) => {
            if (user.user_id === (editCol === null || editCol === void 0 ? void 0 : editCol.userId)) {
                user.rate = editCol.value;
                isFind = true;
            }
        });
        if (!isFind) {
            newData[editCol.type].users.push({
                user_id: editCol.userId,
                rate: editCol.value,
            });
        }
        yield updateAgentConfig(newData);
        setEditCol(null);
    }), [agentConfig, editCol, updateAgentConfig]);
    const getAgentRate = useCallback(({ type, userId, userRate }) => {
        var _a;
        const value = (editCol === null || editCol === void 0 ? void 0 : editCol.type) === type && userId === editCol.userId ? editCol.value : userRate;
        return parseFloat(((((_a = agentConfig === null || agentConfig === void 0 ? void 0 : agentConfig[type]) === null || _a === void 0 ? void 0 : _a.default_rate) || 0) - (value || 0)).toFixed(2));
    }, [agentConfig, editCol]);
    const loadPlayers = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        let filter = [];
        if (searchQuery) {
            filter = [
                {
                    kind: FilterKind.StringFilter,
                    field: "username",
                    value: searchQuery,
                    expression: StringFilterExpression.Match,
                },
                {
                    kind: FilterKind.StringFilter,
                    field: "last_name",
                    value: searchQuery,
                    expression: StringFilterExpression.Match,
                },
                {
                    kind: FilterKind.StringFilter,
                    field: "first_name",
                    value: searchQuery,
                    expression: StringFilterExpression.Match,
                },
            ];
            !Number.isNaN(Number(searchQuery)) &&
                filter.push({
                    kind: FilterKind.NumericFilter,
                    field: "id",
                    value: Number(searchQuery),
                    expression: ComparisonFilterExpression.Match,
                });
        }
        try {
            const response = yield client.queryReferredUser({
                page: pagination.page,
                items_per_page: pagination.items_per_page,
                order_by: [
                    {
                        field: "created_at",
                        order: Order.DESC,
                    },
                ],
                filter,
                filter_condition: FilterCondition.Or,
            });
            setPlayers(response.items);
            setTotalPages(response.total_pages);
        }
        catch (_a) {
            setPlayers([]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }), [pagination]);
    useEffect(() => {
        setPagination(Object.assign(Object.assign({}, pagination), { page: 1 }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchQuery]);
    useEffect(() => {
        loadPlayers();
    }, [loadPlayers]);
    return useMemo(() => ({
        updateSubuserRate,
        totalPages,
        playersInfo,
        getAgentRate,
        pagination,
        setPagination,
        editCol,
        setEditCol,
    }), [
        updateSubuserRate,
        totalPages,
        playersInfo,
        getAgentRate,
        pagination,
        setPagination,
        editCol,
        setEditCol,
    ]);
};

const useCreateSubuser = () => {
    const client = useContext(ClientBFFContext);
    const { agentConfig, updateAgentConfig } = useContext(AgentConfigContext);
    const [banks, setBanks] = useState([]);
    const createSubuser = useCallback((data) => __awaiter(void 0, void 0, void 0, function* () {
        const { sport_cashback, live_casino_cashback, slots_cashback } = data, rest = __rest(data, ["sport_cashback", "live_casino_cashback", "slots_cashback"]);
        const response = yield client.createReferredUser(rest);
        agentConfig &&
            (yield updateAgentConfig(Object.assign(Object.assign({}, agentConfig), { [BonusVertical.Sport]: Object.assign(Object.assign({}, agentConfig.Sport), { users: [
                        ...agentConfig.Sport.users,
                        { user_id: response.id, rate: sport_cashback },
                    ] }), [BonusVertical.Casino]: Object.assign(Object.assign({}, agentConfig.Casino), { users: [
                        ...agentConfig.Casino.users,
                        { user_id: response.id, rate: slots_cashback },
                    ] }), [BonusVertical.LiveCasino]: Object.assign(Object.assign({}, agentConfig.LiveCasino), { users: [
                        ...agentConfig.LiveCasino.users,
                        { user_id: response.id, rate: live_casino_cashback },
                    ] }) })));
    }), [client, agentConfig, updateAgentConfig]);
    useEffect(() => {
        function load() {
            return __awaiter(this, void 0, void 0, function* () {
                const response = yield client.banks();
                setBanks(response.items);
            });
        }
        load();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return useMemo(() => ({
        banks,
        createSubuser,
    }), [banks, createSubuser]);
};

const formatTransactionMethodId = (id) => id.replaceAll(".", "").toLowerCase();
const formatCasinoProviderName = (text) => {
    return text.replaceAll(" ", "-").toLowerCase();
};
const getFildNameWithCurrency = (fieldName, currency) => `${fieldName}_${currency.toLocaleLowerCase()}`;
const splitArrIntoChunks = (arr, chunkSize) => {
    const chunks = [];
    for (let i = 0; i < arr.length; i += chunkSize) {
        const chunk = arr.slice(i, i + chunkSize);
        chunks.push(chunk);
    }
    return chunks;
};
const isCasinoGameType = (val) => Object.values(CasinoGameTypeEnum).includes(val);
const getAgeOptions = () => {
    const result = [];
    const min = 18;
    const max = 80;
    Array.from({ length: max - min + 1 }, (_, i) => i + min).forEach((age) => {
        result.push({ value: age.toString(), label: age.toString() });
    });
    return result;
};
const getCountries = (supportedCountries) => {
    const result = [];
    for (let i = 0; i < supportedCountries.length; ++i) {
        const country = supportedCountries[i];
        result.push({
            value: country,
            label: AllCountries[country],
        });
    }
    return result;
};
const getCountryStates = (supportedCountrytates) => {
    const result = [];
    for (const countryState of supportedCountrytates) {
        result.push({
            value: countryState.name,
            label: countryState.name,
        });
    }
    return result;
};
const debounce = (func, delay, immediate = false) => {
    let timeoutId;
    return function executed(...args) {
        const callNow = immediate && !timeoutId;
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
        timeoutId = setTimeout(() => {
            timeoutId = null;
            if (!immediate)
                func.apply(this, args);
        }, delay);
        if (callNow)
            func.apply(this, args);
    };
};
function getRandomArbitrary(min, max) {
    return Math.floor(Math.random() * (max - min) + min);
}

function getCurrencyConfig(siteConfig, currency) {
    var _a;
    const config = siteConfig.payments.currency;
    return (_a = config[currency]) !== null && _a !== void 0 ? _a : {};
}
function round(value, digits = 2) {
    const roundTo = Math.pow(10, digits);
    return Math.floor(value * roundTo) / roundTo;
}
function numberWithCommas(value) {
    const parts = value.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
}
function formatCurrency(value, digits, withCommas = true) {
    const numValue = typeof value !== "number" ? parseFloat(value) : value;
    if (isNaN(numValue) === true) {
        return "0";
    }
    const roundValue = round(numValue, digits).toFixed(digits);
    return withCommas ? numberWithCommas(roundValue) : roundValue;
}

const getUtcDateFromString = (dateString) => {
    const date = new Date(dateString);
    return new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);
};

const filterIdsByTemplateId = (ids, templateId) => ids.filter((id) => id.includes(templateId.toString()));
const sortMarketGroups = (game) => {
    const groupIds = Object.keys(game.market_groups);
    [
        TemplateIdsMap.HANDICAP,
        TemplateIdsMap.HANDICAP_INCL_EXTRA_INNINGS,
        TemplateIdsMap.INNINGS_1TO5_HANDICAP,
        ...filterIdsByTemplateId(groupIds, TemplateIdsMap.INNINGNUMBER_INNING_HANDICAP),
        ...filterIdsByTemplateId(groupIds, TemplateIdsMap.INNINGS_FROMVALUE_TOVALUE_HANDICAP),
        ...filterIdsByTemplateId(groupIds, TemplateIdsMap.QUARTERNUMBER_QUARTER_HANDICAP),
        ...filterIdsByTemplateId(groupIds, TemplateIdsMap.PERIODNUMBER_PERIOD_HANDICAP),
    ].forEach((item) => {
        var _a;
        (_a = game.market_groups[item]) === null || _a === void 0 ? void 0 : _a.markets.sort((a, b) => sortByNumberBetweenBrackets(a, b));
    });
    [
        TemplateIdsMap.TOTAL,
        TemplateIdsMap.COMPETITOR1_TOTAL,
        TemplateIdsMap.COMPETITOR2_TOTAL,
        TemplateIdsMap.TOTAL_1ST_HALF,
        TemplateIdsMap.TOTAL_1ST_HALF_COMPETITOR1,
        TemplateIdsMap.TOTAL_1ST_HALF_COMPETITOR2,
        TemplateIdsMap.TOTAL_2ND_HALF,
        TemplateIdsMap.TOTAL_2ND_HALF_COMPETITOR1,
        TemplateIdsMap.TOTAL_2ND_HALF_COMPETITOR2,
        TemplateIdsMap.TOTAL_POINTS,
        TemplateIdsMap.TOTAL_INCL_EXTRA_INNINGS,
        TemplateIdsMap.INNINGS_1TO5_TOTAL,
        TemplateIdsMap.INNINGS_1TO5_COMPETITOR1_TOTAL,
        TemplateIdsMap.INNINGS_1TO5_COMPETITOR2_TOTAL,
        ...filterIdsByTemplateId(groupIds, TemplateIdsMap.INNINGNUMBER_INNING_TOTAL),
        ...filterIdsByTemplateId(groupIds, TemplateIdsMap.INNINGS_FROMVALUE_TOVALUE_TOTAL),
        ...filterIdsByTemplateId(groupIds, TemplateIdsMap.QUARTERNUMBER_QUARTER_TOTAL),
        ...filterIdsByTemplateId(groupIds, TemplateIdsMap.QUARTERNUMBER_QUARTER_COMPETITOR1_TOTAL),
        ...filterIdsByTemplateId(groupIds, TemplateIdsMap.QUARTERNUMBER_QUARTER_COMPETITOR2_TOTAL),
        ...filterIdsByTemplateId(groupIds, TemplateIdsMap.PERIODNUMBER_PERIOD_TOTAL),
        ...filterIdsByTemplateId(groupIds, TemplateIdsMap.INNINGS_FROMVALUE_TOVALUE_COMPETITOR1_TOTAL),
        ...filterIdsByTemplateId(groupIds, TemplateIdsMap.INNINGS_FROMVALUE_TOVALUE_COMPETITOR2_TOTAL),
    ].forEach((item) => {
        var _a;
        (_a = game.market_groups[item]) === null || _a === void 0 ? void 0 : _a.markets.sort((a, b) => sortByNumberAfterLastSpace(a, b));
    });
    return game;
};
const convertMarketsIntoMarketGroups = (game, marketGroupIds) => {
    var _a;
    (_a = game.markets) === null || _a === void 0 ? void 0 : _a.forEach((market) => {
        var _a, _b, _c, _d;
        if (marketGroupIds.includes(market.template_id)) {
            if (game.market_groups.hasOwnProperty(getMarketGroupId(market))) {
                game.market_groups[getMarketGroupId(market)].markets.push(market);
            }
            else {
                game.market_groups[getMarketGroupId(market)] = new MarketGroupData(market, getMarketGroupId(market), ((_a = game.home_team) === null || _a === void 0 ? void 0 : _a.name) || "", ((_b = game.away_team) === null || _b === void 0 ? void 0 : _b.name) || "");
            }
        }
        else {
            game.market_groups[market.id] = new MarketGroupData(market, market.id.toString(), ((_c = game.home_team) === null || _c === void 0 ? void 0 : _c.name) || "", ((_d = game.away_team) === null || _d === void 0 ? void 0 : _d.name) || "");
        }
    });
    return game;
};

function formatNumber(num, digits) {
    const lookup = [
        { value: 1, symbol: "" },
        { value: 1e3, symbol: "k" },
        { value: 1e6, symbol: "M" },
        { value: 1e9, symbol: "G" },
        { value: 1e12, symbol: "T" },
        { value: 1e15, symbol: "P" },
        { value: 1e18, symbol: "E" },
    ];
    const regexp = /\.0+$|(?<=\.[0-9]*[1-9])0+$/;
    const item = lookup.findLast((item) => num >= item.value);
    return item ? (num / item.value).toFixed(digits).replace(regexp, "").concat(item.symbol) : "0";
}

const convertGamesToSports = (games) => {
    const sportsData = [];
    for (let i = 0; i < games.length; ++i) {
        const game = games[i];
        const sportIndex = sportsData.findIndex((sport) => sport.id === game.sport_id);
        if (sportIndex === -1) {
            const sportData = {
                id: game.sport_id,
                name: game.sport_name,
                slug: game.sport_slug,
                games_count: 1,
                categories: [],
            };
            sportsData.push(sportData);
        }
        else {
            sportsData[sportIndex].games_count++;
        }
    }
    return sportsData.sort(sortSports);
};
const convertGamesToTournaments = (games) => {
    const tournaments = [];
    for (let i = 0; i < games.length; ++i) {
        const game = games[i];
        const tournamentIndex = tournaments.findIndex((tournament) => tournament.id === game.tournament_id);
        if (tournamentIndex === -1) {
            const tournament = {
                id: game.tournament_id,
                name: game.tournament_name,
                sport_id: game.sport_id,
                sport_slug: game.sport_slug,
                sport_name: game.sport_name,
                category_name: game.category_name,
                category_id: game.category_id,
                is_top: game.tournament_is_top,
                top_index: game.tournament_top_index,
                events: [game.id],
                games_count: 1,
            };
            tournaments.push(tournament);
        }
        else {
            tournaments[tournamentIndex].games_count++;
            tournaments[tournamentIndex].events.push(game.id);
        }
    }
    return tournaments;
};
const calculateRestOfDayInHoursRange = () => {
    const restOfDayInMS = endOfDay(new Date()).getTime() - new Date().getTime();
    const restOfDayInHours = Math.ceil(restOfDayInMS / HOUR_IN_MS$1);
    const ranges = Object.values(HoursRange).filter((value) => typeof value === "number");
    ranges.sort((a, b) => a - b);
    for (const range of ranges) {
        if (range >= restOfDayInHours) {
            return range;
        }
    }
    return HoursRange.TWELVE;
};
const moveMarketToFirstByIndex = (arr, index) => {
    if (index < 0 || index >= arr.length) {
        return arr;
    }
    const [elementToMove] = arr.splice(index, 1);
    return [elementToMove, ...arr];
};

const msToTime = (duration) => {
    const milliseconds = Math.floor((duration % 1000) / 100);
    const seconds = Math.floor((duration / 1000) % 60);
    const minutes = Math.floor((duration / (1000 * 60)) % 60);
    const hours = Math.floor((duration / (1000 * 60 * 60)) % 24);
    return {
        hours: hours < 10 ? "0" + hours : hours,
        minutes: minutes < 10 ? "0" + minutes : minutes,
        seconds: seconds < 10 ? "0" + seconds : seconds,
        milliseconds,
    };
};

function fetchLocalTranslations(request, localOrigin) {
    return __awaiter(this, void 0, void 0, function* () {
        const origin = localOrigin || window.location.origin;
        const params = new URLSearchParams({
            language: request.language,
            scopes: request.scopes.join(","),
        });
        const response = yield fetch(`${origin}/api/translations?` + params.toString(), {
            method: "GET",
        });
        if (!response.ok) {
            const filesList = request.scopes.map((s) => `translations/${s}.json`).join(",");
            throw new Error(`Failed to fetch local translations, make sure next files are valid: ${filesList}`);
        }
        return response.json();
    });
}
function getTranslations(config) {
    return __awaiter(this, void 0, void 0, function* () {
        const { client, request, includeLocalTranslations, localOrigin, deviceType } = config;
        const translations = deviceType === "mobile"
            ? yield client.getMobileTranslations(request)
            : yield client.getDesktopTranslations(request);
        if (!includeLocalTranslations) {
            return translations;
        }
        const localTranslations = yield fetchLocalTranslations(request, localOrigin);
        for (const scope in translations) {
            if (process.env.LOCAL_ONLY_TRANSLATIONS) {
                translations[scope] = Object.assign({}, localTranslations[scope]);
            }
            else {
                translations[scope] = Object.assign(Object.assign({}, localTranslations[scope]), translations[scope]);
            }
        }
        return translations;
    });
}
function getMobileTranslations(config) {
    return __awaiter(this, void 0, void 0, function* () {
        return getTranslations(Object.assign(Object.assign({}, config), { deviceType: "mobile" }));
    });
}
function getDesktopTranslations(config) {
    return __awaiter(this, void 0, void 0, function* () {
        return getTranslations(Object.assign(Object.assign({}, config), { deviceType: "desktop" }));
    });
}

const getReportSummuryData = ({ summary = [], isTurnoverStrategy, defaultCurrency, }) => {
    return summary.reduce((acc, value) => {
        const baseAmount = isTurnoverStrategy
            ? value[getFildNameWithCurrency("turnover", defaultCurrency)]
            : value[getFildNameWithCurrency("profit", defaultCurrency)];
        acc.baseAmount += Number(baseAmount || 0);
        acc.user_payment += Number(value[getFildNameWithCurrency("amount", defaultCurrency)] || 0);
        acc.agent_payment += Number(value[getFildNameWithCurrency("agent_amount", defaultCurrency)] || 0);
        return acc;
    }, { baseAmount: 0, user_payment: 0, agent_payment: 0 });
};

const CpfSignupContext = createContext({});
const CpfSignupProvider = ({ children }) => {
    const [newRegisterUser, setNewRegisterUser] = useState();
    const [step, setStep] = useState("first");
    const value = useMemo(() => ({
        setStep,
        step,
        newRegisterUser,
        setNewRegisterUser,
    }), [setStep, step, newRegisterUser, setNewRegisterUser]);
    return jsx(CpfSignupContext.Provider, { value: value, children: children });
};

const getStringWithMask = (string = "", numberOfLetters) => {
    let stringWithMask = "";
    if (string.length === numberOfLetters) {
        return string;
    }
    for (let i = 0; i < numberOfLetters; i++) {
        stringWithMask = stringWithMask + (string[i] || "_");
    }
    return stringWithMask;
};
const getFormattedCPF = (value) => {
    const blocks = value.match(/(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,2})/);
    return `${getStringWithMask(blocks === null || blocks === void 0 ? void 0 : blocks[1], 3)}.${getStringWithMask(blocks === null || blocks === void 0 ? void 0 : blocks[2], 3)}.${getStringWithMask(blocks === null || blocks === void 0 ? void 0 : blocks[3], 3)}-${getStringWithMask(blocks === null || blocks === void 0 ? void 0 : blocks[4], 2)}`;
};

const useFirstStepSignup = () => {
    const client = useContext(ClientBFFContext);
    const { setStep, newRegisterUser, setNewRegisterUser } = useContext(CpfSignupContext);
    const [cpf, setCpf] = useState((newRegisterUser === null || newRegisterUser === void 0 ? void 0 : newRegisterUser.cpf_number) || "");
    const [error, setError] = useState();
    const [errorApi, setErrorApi] = useState();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const onSubmit = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setNewRegisterUser((state) => (Object.assign(Object.assign({}, state), { cpf_number: cpf })));
            setIsSubmitting(true);
            const response = yield client.getExternalUserByCPFNumber(cpf);
            setNewRegisterUser((state) => (Object.assign(Object.assign({}, state), response)));
            setErrorApi(undefined);
            setStep("second");
        }
        catch (e) {
            throw e;
        }
        finally {
            setIsSubmitting(false);
        }
    }), [setNewRegisterUser, setStep, client, cpf]);
    return useMemo(() => ({
        onSubmit,
        error,
        errorApi,
        isSubmitting,
        cpf,
        setCpf,
        setError,
        setErrorApi,
    }), [onSubmit, error, errorApi, isSubmitting, cpf, setCpf, setError, setErrorApi]);
};

const useSecondStepSignup = () => {
    const client = useContext(ClientBFFContext);
    const { setStep, newRegisterUser, setNewRegisterUser } = useContext(CpfSignupContext);
    const registerCPFUser = useCallback((data) => __awaiter(void 0, void 0, void 0, function* () {
        let response = {};
        if (newRegisterUser === null || newRegisterUser === void 0 ? void 0 : newRegisterUser.id) {
            response = yield client.registerFromCPFNumber(Object.assign(Object.assign({}, data), { cpf_number: (newRegisterUser === null || newRegisterUser === void 0 ? void 0 : newRegisterUser.cpf_number) || "" }));
            setNewRegisterUser(Object.assign(Object.assign({}, newRegisterUser), { token: response.token }));
        }
        else {
            response = yield client.registerFromCPFUser(data);
            setNewRegisterUser(Object.assign(Object.assign({}, data), { token: response.token }));
        }
        setStep("complete");
    }), [setStep, client, newRegisterUser, setNewRegisterUser]);
    return useMemo(() => ({
        registerCPFUser,
    }), [registerCPFUser]);
};

const DefaultWalletDataContext = createContext(null);
function getLimits(siteConfig) {
    const config = siteConfig.payments.currency;
    return Object.keys(config).map((cryptoCurrency) => {
        return Object.assign(Object.assign({}, config[cryptoCurrency]), { currency: cryptoCurrency });
    });
}
function findWallet(wallets, currency) {
    return wallets.find((wallet) => wallet.currency === currency);
}
function calculateBalanceDetails(exchangeRates, balanceWallets, currency, fiatCurrency) {
    var _a, _b, _c, _d;
    const wallet = findWallet(balanceWallets, currency);
    const balance = parseFloat(wallet ? wallet.balance : "0");
    const fiatRate = ((_b = (_a = exchangeRates[currency]) === null || _a === void 0 ? void 0 : _a.find((r) => r.toCurrency === fiatCurrency)) === null || _b === void 0 ? void 0 : _b.rate) || "1";
    const usdRate = ((_d = (_c = exchangeRates[currency]) === null || _c === void 0 ? void 0 : _c.find((r) => r.toCurrency === Currency.USD)) === null || _d === void 0 ? void 0 : _d.rate) || "1";
    const fiatRateNumber = parseFloat(fiatRate);
    const usdRateNumber = parseFloat(usdRate);
    return {
        fiatRate: fiatRateNumber,
        usdRate: usdRateNumber,
        balance,
        fiatCurrency,
        fiatBalance: fiatRate ? fiatRateNumber * balance : null,
        walletId: wallet === null || wallet === void 0 ? void 0 : wallet.id,
        allWallets: balanceWallets,
    };
}
const FALLBACK_CRYPTO_CURRENCY = Currency.DOGE;
const FALLBACK_FIAT_CURRENCY = Currency.KRW;
const DefaultWalletDataProvider = ({ children, fiatCurrency = FALLBACK_FIAT_CURRENCY, }) => {
    const { siteConfigs, siteSupportedWallets, sitePaymentsConfig } = useContext(ConfigContext);
    const { userToken } = useContext(AuthContext);
    const { exchangeRates } = useContext(ExchangeRatesContext);
    const { currentCurrency } = useContext(UserAccountContext);
    const [activeTab, setTab] = useState("deposit");
    const [isDisabled, disableTabs] = useState(false);
    const [isBalanceHidden, hideBalance] = useState(false);
    const limits = useMemo(() => (siteConfigs ? getLimits(siteConfigs) : []), [siteConfigs]);
    const balanceWallets = useMemo(() => {
        return siteSupportedWallets.filter((wallet) => wallet.type === "Balance" && sitePaymentsConfig[wallet.currency].enabled);
    }, [sitePaymentsConfig, siteSupportedWallets]);
    const [currency, setCurrency] = useState(currentCurrency !== null && currentCurrency !== void 0 ? currentCurrency : FALLBACK_CRYPTO_CURRENCY);
    const [balanceDetails, setBalanceDetails] = useState();
    useEffect(() => {
        if (!exchangeRates) {
            return;
        }
        const details = calculateBalanceDetails(exchangeRates, balanceWallets, currency, fiatCurrency);
        setBalanceDetails(details);
    }, [balanceWallets, currency, exchangeRates, fiatCurrency]);
    const format = useCallback((value, currency, withCommas) => {
        const limit = limits.find((limit) => limit.currency === currency);
        const roundToDigits = (limit === null || limit === void 0 ? void 0 : limit.digits) || 0;
        return formatCurrency(value, roundToDigits, withCommas);
    }, [limits]);
    const roundToDigits = useCallback((value, currency) => {
        const limit = limits.find((limit) => limit.currency === currency);
        const roundToDigits = (limit === null || limit === void 0 ? void 0 : limit.digits) || 0;
        return round(value, roundToDigits);
    }, [limits]);
    const calculateMaxWithdrawal = useCallback((maxUsd) => {
        if (!balanceDetails) {
            return 0;
        }
        if (!maxUsd || !balanceDetails.usdRate) {
            return balanceDetails.balance;
        }
        const maxInUsdLimit = maxUsd / balanceDetails.usdRate;
        return Math.min(maxInUsdLimit, balanceDetails.balance);
    }, [balanceDetails]);
    const calculateMaxDeposit = useCallback((maxUsd) => {
        if (!balanceDetails) {
            return 0;
        }
        if (!maxUsd || !balanceDetails.usdRate) {
            return balanceDetails.balance;
        }
        return maxUsd / balanceDetails.usdRate;
    }, [balanceDetails]);
    const isBalancePositive = useCallback((currency) => {
        return !!(balanceDetails === null || balanceDetails === void 0 ? void 0 : balanceDetails.allWallets.some((wallet) => wallet.currency === currency && parseFloat(wallet.balance) > 0));
    }, [balanceDetails === null || balanceDetails === void 0 ? void 0 : balanceDetails.allWallets]);
    const updateBalance = useCallback((event, error) => __awaiter(void 0, void 0, void 0, function* () {
        if (error) {
            return;
        }
        setBalanceDetails((info) => {
            const isUpdatedCurrencyActive = event.currency === currency;
            const balance = isUpdatedCurrencyActive ? event.balance : info.balance;
            const fiatBalance = isUpdatedCurrencyActive && info.fiatRate
                ? info.fiatRate * parseFloat(balance.toString() || "0")
                : info.fiatBalance;
            return Object.assign(Object.assign({}, info), { balance,
                fiatBalance, allWallets: info.allWallets.map((wallet) => {
                    if (wallet.id !== event.id) {
                        return wallet;
                    }
                    return Object.assign(Object.assign({}, wallet), { balance: event.balance, updated_at: event.updated_at });
                }) });
        });
    }), [setBalanceDetails, currency]);
    const payload = useMemo(() => ({ token: userToken || "" }), [userToken]);
    useWebsocketUpdates("wallet", updateBalance, true, payload);
    const value = useMemo(() => ({
        activeTab,
        setTab,
        disableTabs,
        isDisabled,
        isBalanceHidden,
        hideBalance,
        limits,
        roundToDigits,
        formatCurrency: format,
        balanceDetails,
        calculateMaxWithdrawal,
        calculateMaxDeposit,
        isBalancePositive,
        currency,
        setCurrency,
        activeLimit: limits.find((limit) => limit.currency === currency),
    }), [
        activeTab,
        isDisabled,
        isBalanceHidden,
        limits,
        roundToDigits,
        format,
        balanceDetails,
        calculateMaxWithdrawal,
        calculateMaxDeposit,
        isBalancePositive,
        currency,
        setCurrency,
    ]);
    return (jsx(DefaultWalletDataContext.Provider, { value: value, children: children }));
};

const useLatestExchangeRate = () => {
    const { balanceDetails, currency } = useContext(DefaultWalletDataContext);
    const { exchangeRates } = useContext(ExchangeRatesContext);
    const rate = useMemo(() => {
        if (!exchangeRates) {
            return undefined;
        }
        const activeCurrencyToKrwExchangeRate = exchangeRates[currency || (balanceDetails === null || balanceDetails === void 0 ? void 0 : balanceDetails.fiatCurrency)].find((rate) => rate.toCurrency === (balanceDetails === null || balanceDetails === void 0 ? void 0 : balanceDetails.fiatCurrency));
        return activeCurrencyToKrwExchangeRate === null || activeCurrencyToKrwExchangeRate === void 0 ? void 0 : activeCurrencyToKrwExchangeRate.rate;
    }, [currency, exchangeRates, balanceDetails === null || balanceDetails === void 0 ? void 0 : balanceDetails.fiatCurrency]);
    return {
        exchangeRate: parseFloat(rate || "1"),
    };
};

const DEFAULT_MIN_DEPOSIT_LIMIT$2 = 0;
const AMOUNT_STEPS$1 = [10000, 30000, 50000, 100000, 200000, 300000, 500000, 1000000];
function queryPendingDeposits(client, currency) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield client.queryDeposits({
            page: 1,
            items_per_page: 1,
            filter: [
                {
                    kind: FilterKind.StringFilter,
                    field: "currency",
                    value: currency,
                    expression: StringFilterExpression.Equal,
                },
                {
                    kind: FilterKind.StringFilter,
                    field: "provider",
                    value: PaymentProvider.BankTransfer,
                    expression: StringFilterExpression.Equal,
                },
                {
                    kind: FilterKind.StringChoicesFilter,
                    field: "status",
                    value: [DepositStatus.Draft, DepositStatus.AddressApproved, DepositStatus.Pending],
                    expression: ChoicesFilterExpression.In,
                },
            ],
        });
        return {
            draft: response.items.filter((item) => item.status === DepositStatus.Draft),
            approved: response.items.filter((item) => item.status === DepositStatus.AddressApproved),
            pending: response.items.filter((item) => item.status === DepositStatus.Pending),
        };
    });
}
const useCoreDepositFormBank = () => {
    const client = useContext(ClientBFFContext);
    const { token } = useContext(WebsocketContext);
    const { roundToDigits, activeLimit, calculateMaxDeposit, currency } = useContext(DefaultWalletDataContext);
    const [viewState, setViewState] = useState("deposit");
    const [pendingDeposit, setPendingDeposit] = useState();
    const [isLoading, setIsLoading] = useState(true);
    const [serverErrors, setServerErrors] = useState([]);
    const formMethods = useForm({
        defaultValues: {
            depositAmount: "",
        },
        mode: "onChange",
        delayError: 0,
    });
    const getDraftDeposits = useCallback((currency) => __awaiter(void 0, void 0, void 0, function* () {
        setIsLoading(true);
        try {
            const { draft, approved, pending } = yield queryPendingDeposits(client, currency);
            if (pending.length) {
                setPendingDeposit(pending[0]);
                setViewState("submitted-auto");
            }
            else if (approved.length) {
                setPendingDeposit(approved[0]);
                setViewState("confirmation");
            }
            else if (draft.length) {
                setPendingDeposit(draft[0]);
                setViewState("pending");
            }
            else {
                setViewState("deposit");
            }
        }
        finally {
            setIsLoading(false);
        }
    }), [client]);
    const initiateBankDeposit = useCallback((amount) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        setIsLoading(true);
        setServerErrors([]);
        try {
            const response = yield client.initiateDeposit({
                provider: PaymentProvider.BankTransfer,
                currency,
                amount: amount.toString(),
                provider_data: null,
            });
            if (response.deposit) {
                setPendingDeposit(response.deposit);
                if (response.deposit.status === DepositStatus.Draft) {
                    setViewState("pending");
                }
                else if (response.deposit.status === DepositStatus.AddressApproved) {
                    setViewState("confirmation");
                }
                else if (response.deposit.status === DepositStatus.Pending) {
                    setViewState("submitted-manually");
                }
                else {
                    console.warn("Unhandled deposit status:");
                }
            }
        }
        catch (e) {
            const errorsLocation = (_b = (_a = e.response.data.details) === null || _a === void 0 ? void 0 : _a.amount) !== null && _b !== void 0 ? _b : e.response.data.details;
            // TODO: fixme
            const errorKeys = Object.keys(errorsLocation);
            // https://sentry.io/organizations/playmax-d4/issues/3803881325/?environment=dev&project=6362273&referrer=project-issue-stream
            const errors = errorKeys.map((key) => ({
                type: "server",
                message: errorsLocation[key],
            }));
            if (errors.length) {
                setServerErrors(errors);
            }
            else {
                // generic error
                setServerErrors([
                    {
                        type: "server",
                        message: e.response.data.message,
                    },
                ]);
            }
            return Promise.reject(e);
        }
        finally {
            setIsLoading(false);
        }
    }), [client, currency]);
    const rejectDeposit = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        setIsLoading(true);
        try {
            yield client.updateDeposit(pendingDeposit.id, {
                status: DepositStatus.Rejected,
            });
            yield getDraftDeposits(currency);
        }
        finally {
            setIsLoading(false);
        }
    }), [client, currency, getDraftDeposits, pendingDeposit]);
    const submitDeposit = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        setIsLoading(true);
        try {
            yield client.updateDeposit(pendingDeposit.id, {
                status: DepositStatus.Pending,
            });
            setViewState("submitted-manually");
        }
        finally {
            setIsLoading(false);
        }
    }), [client, pendingDeposit]);
    const updateDeposit = useCallback((deposit, error) => {
        if (error) {
            console.error(error);
            return;
        }
        if (deposit.currency !== currency) {
            return;
        }
        switch (deposit.status) {
            case DepositStatus.Draft:
                setPendingDeposit(deposit);
                setViewState("pending");
                return;
            case DepositStatus.AddressApproved:
                setViewState("confirmation");
                setPendingDeposit(deposit);
                return;
            case DepositStatus.Pending:
                setViewState("submitted-auto");
                setPendingDeposit(deposit);
                return;
            case DepositStatus.Approved:
                setViewState("success");
                setPendingDeposit(deposit);
                return;
            case DepositStatus.Rejected:
                setViewState("deposit");
                setPendingDeposit(undefined);
                return;
        }
    }, [setPendingDeposit, setViewState, currency]);
    const calculateLimits = useCallback(() => {
        var _a, _b;
        const min = ((_a = activeLimit === null || activeLimit === void 0 ? void 0 : activeLimit.deposit) === null || _a === void 0 ? void 0 : _a.min) || DEFAULT_MIN_DEPOSIT_LIMIT$2;
        const max_number = calculateMaxDeposit((_b = activeLimit === null || activeLimit === void 0 ? void 0 : activeLimit.deposit) === null || _b === void 0 ? void 0 : _b.max_usd);
        const max = roundToDigits(max_number, currency);
        return { min, max };
    }, [activeLimit, calculateMaxDeposit, roundToDigits, currency]);
    useEffect(() => {
        void getDraftDeposits(currency);
        return () => {
            setPendingDeposit(undefined);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currency]);
    useWebsocketUpdates("deposit", updateDeposit, true, { token });
    formMethods.watch();
    const { depositAmount } = formMethods.getValues();
    return useMemo(() => {
        const { min, max } = calculateLimits();
        return {
            min,
            max,
            viewState,
            currency,
            formMethods,
            amountSteps: AMOUNT_STEPS$1,
            depositAmount: depositAmount,
            pendingDeposit,
            rejectDeposit,
            submitDeposit,
            isLoading: isLoading,
            initiateBankDeposit,
            serverErrors,
        };
    }, [
        calculateLimits,
        currency,
        viewState,
        formMethods,
        depositAmount,
        pendingDeposit,
        rejectDeposit,
        submitDeposit,
        isLoading,
        initiateBankDeposit,
        serverErrors,
    ]);
};

const DEFAULT_MIN_DEPOSIT_LIMIT$1 = 0;
const TOOLTIP_HIDE_TIMEOUT$1 = 3000;
const useCoreDepositFormCrypto = () => {
    var _a;
    const client = useContext(ClientBFFContext);
    const { activeLimit, currency } = useContext(DefaultWalletDataContext);
    const [isLoading, setIsLoading] = useState(true);
    const [cryptoDetails, setCryptoDetails] = useState(null);
    const isMounted = useRef(false);
    const [isTooltipVisible, setTooltipVisible] = useState(false);
    useEffect(() => {
        // we initiate crypto deposits always on load
        function initiateCryptoDeposit() {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const deposit = yield client.initiateDeposit({
                        provider: PaymentProvider.CryptoAPI,
                        currency: currency,
                    });
                    const Qrious = yield import(/* webpackPrefetch: true */ './qrious-BF3rBjfr.js').then(function (n) { return n.q; }).then((module) => module.default);
                    const address = deposit.provider_data.address;
                    return {
                        address,
                        qrCode: new Qrious({ value: address }).toDataURL(),
                    };
                }
                catch (e) {
                    return null;
                }
            });
        }
        function load() {
            return __awaiter(this, void 0, void 0, function* () {
                setIsLoading(true);
                try {
                    const cryptoDetails = yield initiateCryptoDeposit();
                    setCryptoDetails(cryptoDetails);
                }
                finally {
                    setIsLoading(false);
                }
            });
        }
        void load();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currency]);
    const handleCopy = useCallback(() => {
        if (cryptoDetails === null || cryptoDetails === void 0 ? void 0 : cryptoDetails.address) {
            setTooltipVisible(true);
            void navigator.clipboard.writeText(cryptoDetails.address);
            setTimeout(() => {
                if (isMounted.current) {
                    setTooltipVisible(false);
                }
            }, TOOLTIP_HIDE_TIMEOUT$1);
        }
    }, [cryptoDetails === null || cryptoDetails === void 0 ? void 0 : cryptoDetails.address, isMounted]);
    useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    });
    const minDeposit = ((_a = activeLimit === null || activeLimit === void 0 ? void 0 : activeLimit.deposit) === null || _a === void 0 ? void 0 : _a.min) || DEFAULT_MIN_DEPOSIT_LIMIT$1;
    return useMemo(() => ({
        isLoading: isLoading,
        cryptoDetails,
        currency: currency,
        handleCopy,
        minDeposit,
        confirmation_count: activeLimit === null || activeLimit === void 0 ? void 0 : activeLimit.confirmation_count,
        qrCode: cryptoDetails === null || cryptoDetails === void 0 ? void 0 : cryptoDetails.qrCode,
        address: cryptoDetails === null || cryptoDetails === void 0 ? void 0 : cryptoDetails.address,
        isTooltipVisible,
        hasDestinationTag: currency === Currency.XRP,
    }), [
        isLoading,
        cryptoDetails,
        currency,
        handleCopy,
        minDeposit,
        activeLimit === null || activeLimit === void 0 ? void 0 : activeLimit.confirmation_count,
        isTooltipVisible,
    ]);
};

const CoreWithdrawalCommonContext = createContext(null);
function getPaymentAccount(client, currency) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const account = yield client.getUserPaymentAccount(currency);
            return account;
        }
        catch (e) {
            return null;
        }
    });
}
function getWithdrawalDestinationTag(client) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield client.getUserCryptoAddressTag();
            return response.tag;
        }
        catch (e) {
            return null;
        }
    });
}
const DEFAULT_MIN_DEPOSIT_LIMIT = 0;
const CoreWithdrawalCommonProvider = ({ children }) => {
    const client = useContext(ClientBFFContext);
    const { roundToDigits, activeLimit, calculateMaxWithdrawal, currency } = useContext(DefaultWalletDataContext);
    const [paymentAccount, setPaymentAccount] = useState(null);
    const [isLoading, setLoading] = useState(true);
    const [destinationTag, setDestinationTag] = useState(null);
    useEffect(() => {
        function load() {
            return __awaiter(this, void 0, void 0, function* () {
                setLoading(true);
                try {
                    const [paymentAccount, destinationTag] = yield Promise.all([
                        getPaymentAccount(client, currency),
                        currency === Currency.XRP ? getWithdrawalDestinationTag(client) : null,
                    ]);
                    setPaymentAccount(paymentAccount);
                    setDestinationTag(destinationTag);
                }
                finally {
                    setLoading(false);
                }
            });
        }
        void load();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currency]);
    const addUserPaymentAccount = useCallback((otpResponse, paymentAccountInfo) => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield client.addUserPaymentAccount({
            optResponse: otpResponse,
            userPaymentAccount: {
                currency: currency,
                provider: PaymentProvider.CryptoAPI,
                account: paymentAccountInfo,
            },
        });
        setPaymentAccount(response);
    }), [currency, client]);
    const saveDestinationTag = useCallback((tag) => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield client.updateUserCryptoAddressTag({
            tag,
        });
        setDestinationTag(response.tag);
    }), [client]);
    const createCryptoWithdrawal = useCallback((amount) => __awaiter(void 0, void 0, void 0, function* () {
        yield client.createWithdrawal({
            provider: PaymentProvider.CryptoAPI,
            currency: currency,
            amount: amount.toString(),
            account_id: paymentAccount.id,
        });
    }), [currency, client, paymentAccount]);
    // TODO: put to limits provider
    const calculateLimits = useCallback(() => {
        var _a, _b;
        const min = ((_a = activeLimit === null || activeLimit === void 0 ? void 0 : activeLimit.withdrawal) === null || _a === void 0 ? void 0 : _a.min) || DEFAULT_MIN_DEPOSIT_LIMIT;
        const max_number = calculateMaxWithdrawal((_b = activeLimit === null || activeLimit === void 0 ? void 0 : activeLimit.withdrawal) === null || _b === void 0 ? void 0 : _b.max_usd);
        const max = roundToDigits(max_number, currency);
        return { min, max };
    }, [activeLimit, calculateMaxWithdrawal, roundToDigits, currency]);
    const value = useMemo(() => {
        return {
            isLoading: isLoading,
            currency: currency,
            paymentAccount,
            destinationTag,
            addUserPaymentAccount,
            saveDestinationTag,
            createCryptoWithdrawal,
            calculateLimits,
            hasDestinationTag: currency === Currency.XRP,
            withdrawalAddress: (paymentAccount === null || paymentAccount === void 0 ? void 0 : paymentAccount.account.address) || null,
        };
    }, [
        isLoading,
        currency,
        paymentAccount,
        destinationTag,
        addUserPaymentAccount,
        saveDestinationTag,
        createCryptoWithdrawal,
        calculateLimits,
    ]);
    return (jsx(CoreWithdrawalCommonContext.Provider, { value: value, children: children }));
};

const useCoreWithdrawalCryptoForm = ({ t, verifyModalRef, }) => {
    const { currency, destinationTag, withdrawalAddress, addUserPaymentAccount, saveDestinationTag, hasDestinationTag, calculateLimits, isLoading, } = useContext(CoreWithdrawalCommonContext);
    const [isInEditMode, setIsInEditMode] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const formMethods = useForm({
        defaultValues: {
            withdrawalAmount: "",
            withdrawalAddress: withdrawalAddress || "",
            withdrawalDestinationTag: destinationTag || "",
        },
        mode: "onChange",
        delayError: 0,
    });
    useEffect(() => {
        setIsInEditMode(!withdrawalAddress);
        formMethods.setValue("withdrawalAddress", withdrawalAddress || "");
        void formMethods.trigger("withdrawalAddress", { shouldFocus: false });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formMethods.setValue, withdrawalAddress, setIsInEditMode]);
    useEffect(() => {
        formMethods.setValue("withdrawalDestinationTag", destinationTag || "");
        void formMethods.trigger("withdrawalDestinationTag", {
            shouldFocus: false,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [destinationTag]);
    formMethods.watch(["withdrawalAddress", "withdrawalDestinationTag"]);
    const { withdrawalAddress: formWithdrawalAddress, withdrawalDestinationTag: formWithdrawalDestinationTag, } = formMethods.getValues();
    const areRequisitesChanged = withdrawalAddress !== formWithdrawalAddress ||
        (hasDestinationTag ? destinationTag !== formWithdrawalDestinationTag : false);
    const saveAddressDisabled = !areRequisitesChanged || !formWithdrawalAddress;
    const { min, max } = calculateLimits();
    const handleEditClick = useCallback(() => {
        setIsInEditMode(true);
    }, [setIsInEditMode]);
    const handleCancel = useCallback(() => {
        formMethods.clearErrors(["withdrawalAddress", "withdrawalDestinationTag"]);
        formMethods.setValue("withdrawalAddress", withdrawalAddress || "");
        formMethods.setValue("withdrawalDestinationTag", destinationTag || "");
        setIsInEditMode(false);
    }, [formMethods, withdrawalAddress, destinationTag]);
    const handleSave = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        if (hasDestinationTag && destinationTag !== formWithdrawalDestinationTag) {
            setIsSaving(true);
            try {
                yield saveDestinationTag(formWithdrawalDestinationTag ? formWithdrawalDestinationTag : null);
                setIsSaving(false);
            }
            catch (e) {
                // server generic or fallback error
                formMethods.setError("withdrawalDestinationTag", {
                    type: "custom",
                    message: e.response.data.message ||
                        t("withdrawal_destination-tag_actions_save_error"),
                });
                setIsSaving(false);
                return;
            }
            finally {
                setIsInEditMode(false);
            }
        }
        if (formWithdrawalAddress !== withdrawalAddress) {
            !((_a = verifyModalRef.current) === null || _a === void 0 ? void 0 : _a.opened) && ((_b = verifyModalRef.current) === null || _b === void 0 ? void 0 : _b.open());
        }
    }), [
        hasDestinationTag,
        destinationTag,
        formWithdrawalDestinationTag,
        formWithdrawalAddress,
        withdrawalAddress,
        saveDestinationTag,
        formMethods,
        t,
        verifyModalRef,
    ]);
    const handleVerificationAddressSubmit = useCallback((config) => __awaiter(void 0, void 0, void 0, function* () {
        formMethods.clearErrors("withdrawalAddress");
        verifyModalRef.current.close();
        setIsSaving(true);
        try {
            yield addUserPaymentAccount({
                phone: {
                    code: config.phone.code,
                    id: config.phone.otp.id,
                },
                email: config.email && {
                    code: config.email.code,
                    id: config.email.otp.id,
                },
            }, { address: formWithdrawalAddress });
            setIsInEditMode(false);
        }
        catch (e) {
            // server generic or fallback error
            formMethods.setError("withdrawalAddress", {
                type: "custom",
                message: e.response.data.message || t("withdrawal_address_actions_save_error"),
            });
        }
        finally {
            setIsSaving(false);
        }
    }), [formMethods, verifyModalRef, addUserPaymentAccount, formWithdrawalAddress, t]);
    const withdrawalSubmitDisabled = Boolean(isInEditMode || isSaving || !formMethods.formState.isValid);
    return useMemo(() => ({
        min,
        max,
        isSaving,
        isLoading,
        isInEditMode,
        withdrawalSubmitDisabled,
        handleEditClick,
        handleSave,
        handleCancel,
        handleVerificationAddressSubmit,
        hasWithdrawalAddress: !!withdrawalAddress,
        hasDestinationTag,
        saveAddressDisabled,
        formMethods,
        currency,
    }), [
        min,
        max,
        isLoading,
        isSaving,
        isInEditMode,
        withdrawalSubmitDisabled,
        withdrawalAddress,
        hasDestinationTag,
        saveAddressDisabled,
        handleEditClick,
        handleSave,
        handleCancel,
        handleVerificationAddressSubmit,
        formMethods,
        currency,
    ]);
};

function getFee(client, cover_fee, currency) {
    return __awaiter(this, void 0, void 0, function* () {
        if (cover_fee) {
            return 0;
        }
        const response = yield client.getPotentialCryptoNetworkFee(currency);
        return parseFloat(response.fee);
    });
}
const useCoreWithdrawalCryptoConfirmation = (amount) => {
    const { currency, destinationTag, paymentAccount, createCryptoWithdrawal, isLoading: isDataLoading, } = useContext(CoreWithdrawalCommonContext);
    const clientBFFClient = useContext(ClientBFFContext);
    const { activeLimit } = useContext(DefaultWalletDataContext);
    const [isLoading, setIsLoading] = useState(true);
    const [fee, setFee] = useState(0);
    const [serverErrors, setServerErrors] = useState([]);
    useEffect(() => {
        function load() {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b;
                try {
                    const coverFee = (_b = (_a = activeLimit === null || activeLimit === void 0 ? void 0 : activeLimit.fee) === null || _a === void 0 ? void 0 : _a.cover_fee) !== null && _b !== void 0 ? _b : false;
                    const fee = yield getFee(clientBFFClient, coverFee, currency);
                    setFee(fee);
                }
                finally {
                    setIsLoading(false);
                }
            });
        }
        void load();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const createWithdrawal = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setIsLoading(true);
            setServerErrors([]);
            yield createCryptoWithdrawal(amount);
            setIsLoading(false);
        }
        catch (e) {
            const message = Array.isArray(e.response.data.details)
                ? // TODO: why details is Array in that case but not an object with "address" field?
                    e.response.data.details[0]
                : e.response.data.message;
            setServerErrors([
                {
                    type: "server",
                    message,
                },
            ]);
            setIsLoading(false);
            return Promise.reject(e);
        }
    }), [amount, createCryptoWithdrawal]);
    return useMemo(() => ({
        createWithdrawal,
        currency,
        isLoading: isLoading || isDataLoading,
        fee,
        destinationTag,
        paymentAccount,
        serverErrors,
    }), [
        isLoading,
        isDataLoading,
        createWithdrawal,
        currency,
        fee,
        destinationTag,
        paymentAccount,
        serverErrors,
    ]);
};

const useCoreWithdrawalBankConfirmation = ({ paymentAccountId, amount, t, }) => {
    const client = useContext(ClientBFFContext);
    const { currency } = useContext(DefaultWalletDataContext);
    const [serverErrors, setServerErrors] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const createBankWithdrawal = useCallback((amount) => __awaiter(void 0, void 0, void 0, function* () {
        yield client.createWithdrawal({
            provider: PaymentProvider.BankTransfer,
            currency: currency,
            amount: amount.toString(),
            account_id: paymentAccountId,
        });
    }), [currency, client, paymentAccountId]);
    const createWithdrawal = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setIsLoading(true);
            setServerErrors([]);
            yield createBankWithdrawal(amount);
            setIsLoading(false);
        }
        catch (e) {
            const message = e.response.data.message || t("withdrawal_bank_confirmation_withdrawal_error");
            setServerErrors([
                {
                    type: "server",
                    message,
                },
            ]);
            setIsLoading(false);
            return Promise.reject(e);
        }
    }), [amount, createBankWithdrawal, t]);
    return useMemo(() => ({
        createWithdrawal,
        serverErrors,
        isLoading: isLoading,
        currency,
    }), [createWithdrawal, serverErrors, isLoading, currency]);
};

const AMOUNT_STEPS = [30000, 50000, 100000, 500000];
function getUserPaymentAccount(client, currency) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            return yield client.getUserPaymentAccount(currency);
        }
        catch (e) {
            return undefined;
        }
    });
}
const DEFAULT_MIN_WITHDRAWAL_LIMIT = 0;
function queryPendingWithdrawals(client, currency) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield client.queryWithdrawals({
            page: 1,
            items_per_page: 1,
            filter: [
                {
                    kind: FilterKind.StringFilter,
                    field: "currency",
                    value: currency,
                    expression: StringFilterExpression.Equal,
                },
                {
                    kind: FilterKind.StringFilter,
                    field: "provider",
                    value: PaymentProvider.BankTransfer,
                    expression: StringFilterExpression.Equal,
                },
                {
                    kind: FilterKind.StringChoicesFilter,
                    field: "status",
                    value: [WithdrawalStatus.Draft, WithdrawalStatus.Approved],
                    expression: ChoicesFilterExpression.In,
                },
            ],
        });
        return response.items;
    });
}
const useCoreWithdrawalFormBank = () => {
    const client = useContext(ClientBFFContext);
    const { token } = useContext(WebsocketContext);
    const { roundToDigits, activeLimit, calculateMaxWithdrawal, currency } = useContext(DefaultWalletDataContext);
    const [viewState, setViewState] = useState("withdrawal");
    const [bankTransferAccount, setBankTransferAccount] = useState();
    const [paymentAccountId, setPaymentAccountId] = useState();
    const [pendingWithdrawal, setPendingWithdrawal] = useState();
    const [isInEditMode, setIsInEditMode] = useState(true);
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        function load() {
            return __awaiter(this, void 0, void 0, function* () {
                setIsLoading(true);
                try {
                    const [response] = yield Promise.all([
                        getUserPaymentAccount(client, currency),
                        getDraftWithdrawals(currency),
                    ]);
                    setBankTransferAccount(response === null || response === void 0 ? void 0 : response.account);
                    setPaymentAccountId(response === null || response === void 0 ? void 0 : response.id);
                }
                finally {
                    setIsLoading(false);
                }
            });
        }
        void load();
        return () => {
            setPendingWithdrawal(undefined);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currency]);
    const getDraftWithdrawals = useCallback((currency) => __awaiter(void 0, void 0, void 0, function* () {
        const withdrawals = yield queryPendingWithdrawals(client, currency);
        if (withdrawals.length) {
            setPendingWithdrawal(withdrawals[0]);
            setViewState("pending");
        }
        else {
            setViewState("withdrawal");
        }
    }), [client]);
    const updateWithdrawal = useCallback((withdrawal, error) => {
        if (error) {
            console.error(error);
            return;
        }
        if (withdrawal.currency !== currency) {
            return;
        }
        switch (withdrawal.status) {
            case WithdrawalStatus.Draft:
            case WithdrawalStatus.Approved:
                setViewState("pending");
                setPendingWithdrawal(withdrawal);
                return;
            case WithdrawalStatus.Rejected:
                setViewState("withdrawal");
                setPendingWithdrawal(undefined);
                return;
            case WithdrawalStatus.Completed:
                setViewState("success");
                setPendingWithdrawal(undefined);
                return;
        }
    }, [currency]);
    const calculateLimits = useCallback(() => {
        var _a, _b;
        const min = ((_a = activeLimit === null || activeLimit === void 0 ? void 0 : activeLimit.withdrawal) === null || _a === void 0 ? void 0 : _a.min) || DEFAULT_MIN_WITHDRAWAL_LIMIT;
        const max_number = calculateMaxWithdrawal((_b = activeLimit === null || activeLimit === void 0 ? void 0 : activeLimit.withdrawal) === null || _b === void 0 ? void 0 : _b.max_usd);
        const max = roundToDigits(max_number, currency);
        return { min, max };
    }, [activeLimit, calculateMaxWithdrawal, roundToDigits, currency]);
    const { min: minAmount, max: maxAmount } = calculateLimits();
    const formMethods = useForm({
        defaultValues: {
            withdrawalAmount: "",
            bankName: (bankTransferAccount === null || bankTransferAccount === void 0 ? void 0 : bankTransferAccount.bank_name) || "",
            holder: (bankTransferAccount === null || bankTransferAccount === void 0 ? void 0 : bankTransferAccount.holder) || "",
            accountNumber: (bankTransferAccount === null || bankTransferAccount === void 0 ? void 0 : bankTransferAccount.account_number) || "",
        },
        mode: "onChange",
        delayError: 0,
    });
    useEffect(() => {
        setIsInEditMode(!bankTransferAccount);
        formMethods.setValue("bankName", (bankTransferAccount === null || bankTransferAccount === void 0 ? void 0 : bankTransferAccount.bank_name) || "");
        formMethods.setValue("holder", (bankTransferAccount === null || bankTransferAccount === void 0 ? void 0 : bankTransferAccount.holder) || "");
        formMethods.setValue("accountNumber", (bankTransferAccount === null || bankTransferAccount === void 0 ? void 0 : bankTransferAccount.account_number) || "");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formMethods.setValue, bankTransferAccount, setIsInEditMode]);
    useWebsocketUpdates("withdrawal", updateWithdrawal, true, { token });
    formMethods.watch("withdrawalAmount");
    const { withdrawalAmount } = formMethods.getValues();
    const submitDisabled = Boolean(isInEditMode || isLoading || !bankTransferAccount || !formMethods.formState.isValid);
    return useMemo(() => ({
        withdrawalAmount: withdrawalAmount,
        minAmount,
        maxAmount,
        submitDisabled,
        isLoading,
        isInEditMode,
        viewState,
        amountSteps: AMOUNT_STEPS,
        currency,
        formMethods,
        setViewState,
        setIsInEditMode,
        setIsLoading,
        setBankTransferAccount,
        setPaymentAccountId,
        bankTransferAccount,
        paymentAccountId,
        pendingWithdrawal,
    }), [
        withdrawalAmount,
        minAmount,
        maxAmount,
        submitDisabled,
        isLoading,
        isInEditMode,
        viewState,
        currency,
        formMethods,
        setViewState,
        setIsInEditMode,
        setIsLoading,
        setBankTransferAccount,
        setPaymentAccountId,
        bankTransferAccount,
        paymentAccountId,
        pendingWithdrawal,
    ]);
};

const useCoreWithdrawalBankDetails = ({ formMethods, bankTransferAccount, setIsLoading, onBankAccountUpdated, setIsInEditMode, t, }) => {
    const client = useContext(ClientBFFContext);
    const { currency } = useContext(DefaultWalletDataContext);
    const [banks, setBanks] = useState([]);
    useEffect(() => {
        function load() {
            return __awaiter(this, void 0, void 0, function* () {
                const response = yield client.banks();
                setBanks(response.items);
            });
        }
        void load();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { watch, setValue, getValues } = formMethods;
    watch();
    const addUserPaymentAccount = useCallback((otpResponse, paymentAccountInfo) => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield client.addUserPaymentAccount({
            optResponse: otpResponse,
            userPaymentAccount: {
                currency: currency,
                provider: PaymentProvider.BankTransfer,
                account: paymentAccountInfo,
            },
        });
        onBankAccountUpdated(response);
    }), [currency, client, onBankAccountUpdated]);
    const handleCancel = useCallback(() => {
        setValue("bankName", (bankTransferAccount === null || bankTransferAccount === void 0 ? void 0 : bankTransferAccount.bank_name) || "");
        setValue("holder", (bankTransferAccount === null || bankTransferAccount === void 0 ? void 0 : bankTransferAccount.holder) || "");
        setValue("accountNumber", (bankTransferAccount === null || bankTransferAccount === void 0 ? void 0 : bankTransferAccount.account_number) || "");
        setIsInEditMode(false);
    }, [
        setValue,
        bankTransferAccount === null || bankTransferAccount === void 0 ? void 0 : bankTransferAccount.bank_name,
        bankTransferAccount === null || bankTransferAccount === void 0 ? void 0 : bankTransferAccount.holder,
        bankTransferAccount === null || bankTransferAccount === void 0 ? void 0 : bankTransferAccount.account_number,
        setIsInEditMode,
    ]);
    const { bankName, holder, accountNumber } = getValues();
    const isValueModified = useMemo(() => {
        return (bankName !== (bankTransferAccount === null || bankTransferAccount === void 0 ? void 0 : bankTransferAccount.bank_name) ||
            holder !== (bankTransferAccount === null || bankTransferAccount === void 0 ? void 0 : bankTransferAccount.holder) ||
            accountNumber !== (bankTransferAccount === null || bankTransferAccount === void 0 ? void 0 : bankTransferAccount.account_number));
    }, [
        bankName,
        holder,
        accountNumber,
        bankTransferAccount === null || bankTransferAccount === void 0 ? void 0 : bankTransferAccount.bank_name,
        bankTransferAccount === null || bankTransferAccount === void 0 ? void 0 : bankTransferAccount.holder,
        bankTransferAccount === null || bankTransferAccount === void 0 ? void 0 : bankTransferAccount.account_number,
    ]);
    const areValuesSet = bankName && holder && accountNumber;
    const canSaveRequisites = isValueModified && areValuesSet;
    const handleVerificationAddressSubmit = useCallback((config) => __awaiter(void 0, void 0, void 0, function* () {
        formMethods.clearErrors("common");
        setIsLoading(true);
        try {
            yield addUserPaymentAccount({
                phone: {
                    code: config.phone.code,
                    id: config.phone.otp.id,
                },
                email: config.email && {
                    code: config.email.code,
                    id: config.email.otp.id,
                },
            }, {
                bank_name: bankName,
                holder,
                account_number: accountNumber,
            });
            setIsInEditMode(false);
        }
        catch (e) {
            formMethods.setError("common", {
                type: "custom",
                message: e.response.data.message || t("withdrawal_bank_actions_save_error"),
            });
        }
        finally {
            setIsLoading(false);
        }
    }), [
        formMethods,
        setIsLoading,
        addUserPaymentAccount,
        bankName,
        holder,
        accountNumber,
        setIsInEditMode,
        t,
    ]);
    return useMemo(() => ({
        formMethods: formMethods,
        banks,
        bankTransferAccount,
        canSaveRequisites,
        handleVerificationAddressSubmit,
        handleCancel,
    }), [
        formMethods,
        banks,
        bankTransferAccount,
        canSaveRequisites,
        handleVerificationAddressSubmit,
        handleCancel,
    ]);
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var lib = {};

(function (exports) {
	exports.__esModule = true;
	var react_1 = require$$0;
	function useDigitInput(_a) {
	    var acceptedCharacters = _a.acceptedCharacters, length = _a.length, value = _a.value, onChange = _a.onChange;
	    var val = padValue(value, length);
	    var inputs = react_1.useRef(Array.from({ length: length }));
	    var inputRefSetters = react_1.useRef(Array.from({ length: length }));
	    var props = [];
	    var _loop_1 = function (i) {
	        var ref = (inputRefSetters.current[i] =
	            inputRefSetters.current[i] ||
	                (function (input) {
	                    inputs.current[i] = input || undefined;
	                }));
	        var digitValue = val[i] === ' ' ? '' : val[i];
	        props.push({
	            ref: ref,
	            value: digitValue,
	            onClick: function (_a) {
	                var currentTarget = _a.currentTarget;
	                window.requestAnimationFrame(function () {
	                    currentTarget.setSelectionRange(0, 1);
	                });
	            },
	            onFocus: function (_a) {
	                var currentTarget = _a.currentTarget;
	                currentTarget.setSelectionRange(0, 1);
	            },
	            onKeyDown: function (e) {
	                switch (e.key) {
	                    case 'Backspace':
	                        e.preventDefault();
	                        if (!digitValue) {
	                            if (i > 0) {
	                                // this digit is empty, so backspace removes the previous digit
	                                // and focuses it
	                                onChange(val.substring(0, i - 1) + ' ' + val.substring(i));
	                                var previousInput = inputs.current[i - 1];
	                                if (previousInput) {
	                                    previousInput.focus();
	                                }
	                            }
	                        }
	                        else {
	                            // this digit is not empty, so backspace removes that digit
	                            onChange(val.substring(0, i) + ' ' + val.substring(i + 1));
	                        }
	                        break;
	                    case 'ArrowUp':
	                    case 'ArrowLeft':
	                        e.preventDefault();
	                        if (i > 0) {
	                            var previousInput_1 = inputs.current[i - 1];
	                            if (previousInput_1) {
	                                previousInput_1.focus();
	                                window.requestAnimationFrame(function () {
	                                    previousInput_1.setSelectionRange(0, 1);
	                                });
	                            }
	                        }
	                        break;
	                    case 'ArrowDown':
	                    case 'ArrowRight':
	                        e.preventDefault();
	                        if (i + 1 < length) {
	                            var nextInput_1 = inputs.current[i + 1];
	                            if (nextInput_1) {
	                                nextInput_1.focus();
	                                window.requestAnimationFrame(function () {
	                                    nextInput_1.setSelectionRange(0, 1);
	                                });
	                            }
	                        }
	                        break;
	                    default:
	                        if (e.key.length === 1 && !(e.metaKey || e.altKey || e.ctrlKey)) {
	                            e.preventDefault();
	                            if (acceptedCharacters.test(e.key)) {
	                                onChange(val.substring(0, i) + e.key + val.substring(i + 1));
	                                if (i + 1 < length) {
	                                    var nextInput_2 = inputs.current[i + 1];
	                                    if (nextInput_2) {
	                                        nextInput_2.focus();
	                                        window.requestAnimationFrame(function () {
	                                            nextInput_2.setSelectionRange(0, 1);
	                                        });
	                                    }
	                                }
	                                else {
	                                    var currentTarget_1 = e.currentTarget;
	                                    window.requestAnimationFrame(function () {
	                                        currentTarget_1.setSelectionRange(0, 1);
	                                    });
	                                }
	                            }
	                        }
	                }
	            },
	            onChange: function (e) {
	                var v = e.target.value
	                    .split('')
	                    .filter(function (c) { return acceptedCharacters.test(c); })
	                    .join('');
	                onChange((val.substring(0, i) + v + val.substring(i + v.length)).substr(0, length));
	                if (i < length - 1) {
	                    var nextInput_3 = inputs.current[i + v.length < length ? i + v.length : length - 1];
	                    if (nextInput_3) {
	                        nextInput_3.focus();
	                        window.requestAnimationFrame(function () {
	                            nextInput_3.setSelectionRange(0, 1);
	                        });
	                    }
	                }
	            }
	        });
	    };
	    for (var i = 0; i < length; i++) {
	        _loop_1(i);
	    }
	    return props;
	}
	exports["default"] = useDigitInput;
	function padValue(value, length) {
	    while (value.length < length) {
	        value += ' ';
	    }
	    return value.substr(0, length);
	}
	
} (lib));

var useDigitInput = /*@__PURE__*/getDefaultExportFromCjs(lib);

const INPUT_NAMES = {
    PHONE: "phoneVerification",
    EMAIL: "emailVerification",
};
const RESEND_DELAY = 180 * 1000;
const RESEND_TICK_INTERVAL = 1000;
const NUMBER_PATTERN = /^[0-9]$/;
const CODE_LENGTH = 6;
const useCoreVerify = ({ onSubmit, isDigitInput }) => {
    const clientBFFClient = useContext(ClientBFFContext);
    const { userData } = useContext(UserAccountContext);
    const { siteConfigs } = useContext(ConfigContext);
    const [phoneOtp, setPhoneOtp] = useState();
    const [emailOtp, setEmailOtp] = useState();
    const [canResendPhoneCode, setCanResendPhoneCode] = useState(true);
    const [canResendEmailCode, setCanResendEmailCode] = useState(true);
    const [phoneCode, setPhoneCode] = useState("");
    const [emailCode, setEmailCode] = useState("");
    const isPhoneInputDisabled = !phoneOtp;
    const isEmailInputDisabled = !emailOtp;
    const isEmailVerificationRequired = siteConfigs.users.registration.require_email_verification;
    const phoneDigits = useDigitInput({
        acceptedCharacters: NUMBER_PATTERN,
        length: CODE_LENGTH,
        value: phoneCode,
        onChange: setPhoneCode,
    });
    const emailDigits = useDigitInput({
        acceptedCharacters: NUMBER_PATTERN,
        length: CODE_LENGTH,
        value: emailCode,
        onChange: setEmailCode,
    });
    const isValidValue = useCallback((values) => {
        return values.replace(/ /g, "").length === CODE_LENGTH;
    }, []);
    const isValidEmailCode = isEmailVerificationRequired ? isValidValue(emailCode) : true;
    const canSubmit = isValidValue(phoneCode) && isValidEmailCode;
    const handleSubmit = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        const value = {
            email: isEmailVerificationRequired
                ? {
                    otp: emailOtp,
                    code: emailCode,
                }
                : undefined,
            phone: {
                otp: phoneOtp,
                code: phoneCode,
            },
        };
        yield onSubmit(value);
    }), [isEmailVerificationRequired, emailOtp, emailCode, phoneOtp, phoneCode, onSubmit]);
    const focusOnElement = useCallback((name) => {
        const el = isDigitInput
            ? document.querySelector(`[name="${name}-0"]`)
            : document.querySelector(`[name="${name}"]`);
        if (el) {
            el.focus();
        }
    }, [isDigitInput]);
    const verifyPhone = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        const otp = yield clientBFFClient.initiatePhoneVerification();
        setPhoneOtp(otp);
        setCanResendPhoneCode(false);
        focusOnElement(INPUT_NAMES.PHONE);
    }), [clientBFFClient, focusOnElement]);
    const verifyEmail = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        const otp = yield clientBFFClient.initiateEmailVerification();
        setEmailOtp(otp);
        setCanResendEmailCode(false);
        focusOnElement(INPUT_NAMES.EMAIL);
    }), [clientBFFClient, focusOnElement]);
    return useMemo(() => ({
        phone: (userData === null || userData === void 0 ? void 0 : userData.phone) || "",
        email: (userData === null || userData === void 0 ? void 0 : userData.email) || "",
        showPhoneSubmitCountdown: !!phoneOtp,
        showEmailSubmitCountdown: !!emailOtp,
        phoneCode,
        emailCode,
        verifyPhone,
        verifyEmail,
        phoneDigits,
        emailDigits,
        resendDelay: RESEND_DELAY,
        resendTickInterval: RESEND_TICK_INTERVAL,
        phoneInputName: INPUT_NAMES.PHONE,
        emailInputName: INPUT_NAMES.EMAIL,
        isPhoneInputDisabled,
        isEmailInputDisabled,
        canResendPhoneCode,
        canResendEmailCode,
        setPhoneCode,
        setEmailCode,
        setCanResendPhoneCode,
        setCanResendEmailCode,
        handleSubmit,
        canSubmit,
        isEmailVerificationRequired,
    }), [
        userData === null || userData === void 0 ? void 0 : userData.phone,
        userData === null || userData === void 0 ? void 0 : userData.email,
        phoneOtp,
        emailOtp,
        phoneCode,
        emailCode,
        verifyPhone,
        verifyEmail,
        phoneDigits,
        emailDigits,
        isPhoneInputDisabled,
        isEmailInputDisabled,
        canResendPhoneCode,
        canResendEmailCode,
        handleSubmit,
        canSubmit,
        isEmailVerificationRequired,
    ]);
};

const PixWidgetDataContext = createContext(null);
const PixWalletDataProvider = ({ children }) => {
    const [depositStep, setDepositStep] = useState("first");
    const [depositData, setDepositData] = useState(null);
    const [withdrawalStep, setWithdrawalStep] = useState("first");
    const [withdrawalData, setWithdrawalData] = useState(null);
    const value = useMemo(() => ({
        setDepositStep,
        depositStep,
        depositData,
        setDepositData,
        withdrawalStep,
        setWithdrawalStep,
        withdrawalData,
        setWithdrawalData,
    }), [
        setDepositStep,
        depositStep,
        depositData,
        setDepositData,
        withdrawalStep,
        setWithdrawalStep,
        withdrawalData,
        setWithdrawalData,
    ]);
    return jsx(PixWidgetDataContext.Provider, { value: value, children: children });
};

const useFirstStepDeposit = ({ siteConfigs, rates, depositRemainderResponse, }) => {
    var _a, _b, _c, _d;
    const { t } = useTranslation(TranslationScopes.PixWallet);
    const client = useContext(ClientBFFContext);
    const { setDepositStep, setDepositData } = useContext(PixWidgetDataContext);
    const [value, setValue] = useState("");
    const [error, setError] = useState("");
    const [errorApi, setErrorApi] = useState("");
    const [exceededLimit, setExceededLimit] = useState("");
    const [loading, setLoading] = useState(false);
    const brlRate = (_b = (_a = rates === null || rates === void 0 ? void 0 : rates[Currency.BRL]) === null || _a === void 0 ? void 0 : _a.find((r) => r.toCurrency === "USD")) === null || _b === void 0 ? void 0 : _b.rate;
    const currencyConfig = getCurrencyConfig(siteConfigs, Currency.BRL);
    const { min, max_usd } = currencyConfig.deposit || {};
    const max = brlRate && max_usd ? max_usd / Number(brlRate) : 0;
    const roundedMax = round(max, currencyConfig.digits);
    const userPeriodLimits = (_c = depositRemainderResponse === null || depositRemainderResponse === void 0 ? void 0 : depositRemainderResponse.max_period_limits) === null || _c === void 0 ? void 0 : _c[0];
    const userDepositLimit = userPeriodLimits
        ? round(Number(userPeriodLimits.amount) - Number(userPeriodLimits.actual_sum) || 0, currencyConfig.digits)
        : undefined;
    const maxLimit = useMemo(() => {
        if (typeof userDepositLimit !== "number")
            return roundedMax;
        return roundedMax > userDepositLimit ? userDepositLimit : roundedMax;
    }, [roundedMax, userDepositLimit]);
    const isResponsibleLimit = useMemo(() => {
        if (typeof userDepositLimit !== "number")
            return false;
        return userDepositLimit < roundedMax;
    }, [roundedMax, userDepositLimit]);
    const depositProviders = useMemo(() => {
        var _a;
        const providersData = ((_a = siteConfigs.payments.pix) === null || _a === void 0 ? void 0 : _a.deposit) || {};
        return Object.keys(providersData)
            .map((provider) => (Object.assign({ provider }, providersData[provider])))
            .filter((p) => p.enabled)
            .sort((a, b) => a.order - b.order);
    }, [siteConfigs]);
    const [selectedProvider, setSelectedProvider] = useState((_d = depositProviders[0]) === null || _d === void 0 ? void 0 : _d.provider);
    useEffect(() => {
        setErrorApi("");
    }, [value, selectedProvider]);
    useEffect(() => {
        var _a;
        setSelectedProvider((_a = depositProviders[0]) === null || _a === void 0 ? void 0 : _a.provider);
    }, [depositProviders]);
    useEffect(() => {
        const numberValue = Number(value || 0);
        if (!value) {
            setError("");
            return;
        }
        if (numberValue < (min !== null && min !== void 0 ? min : 0) || numberValue > maxLimit) {
            setError(t("min_max_validation", { min, max: maxLimit }));
        }
        else {
            setError("");
        }
    }, [value, min, maxLimit, t]);
    const clickDeposit = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d;
        setErrorApi("");
        setExceededLimit("");
        try {
            setLoading(true);
            const response = yield client.initiateDeposit({
                provider: PaymentProvider.PixAPI,
                currency: Currency.BRL,
                amount: value,
                provider_data: {
                    pix_api_provider: selectedProvider,
                },
            });
            let base64QrCode = (_a = response.deposit) === null || _a === void 0 ? void 0 : _a.meta.qr_code;
            if (selectedProvider === PixApiProvider.Pagfast) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const sourceQrCode = yield fetch(response.deposit.meta.qr_code_location);
                const qrCodeText = yield sourceQrCode.text();
                base64QrCode = `data:image/png;base64,${qrCodeText}`;
            }
            setDepositData(Object.assign(Object.assign({}, response), { base64QrCode }));
            setDepositStep("second");
        }
        catch (e) {
            const errors = (_c = (_b = e.response.data) === null || _b === void 0 ? void 0 : _b.details) !== null && _c !== void 0 ? _c : {};
            if (errors.max_24h_count_deposit_error) {
                setExceededLimit(errors.max_24h_count_deposit_error);
                return;
            }
            if (errors.error_message) {
                setErrorApi(errors.error_message);
                return;
            }
            setErrorApi(((_d = e.response.data) === null || _d === void 0 ? void 0 : _d.message) || e.message);
        }
        finally {
            setLoading(false);
        }
    }), [value, client, setDepositData, setDepositStep, selectedProvider]);
    return useMemo(() => ({
        clickDeposit,
        value,
        error,
        loading,
        min,
        maxLimit,
        currencyConfig,
        setValue,
        errorApi,
        exceededLimit,
        depositProviders,
        selectedProvider,
        isResponsibleLimit,
        setSelectedProvider,
    }), [
        clickDeposit,
        value,
        error,
        loading,
        setValue,
        min,
        maxLimit,
        currencyConfig,
        errorApi,
        exceededLimit,
        depositProviders,
        selectedProvider,
        isResponsibleLimit,
        setSelectedProvider,
    ]);
};

const TOOLTIP_HIDE_TIMEOUT = 3000;
const useSecondStepDeposit = () => {
    const { depositData, setDepositStep, setDepositData } = useContext(PixWidgetDataContext);
    const [isTooltipVisible, setTooltipVisible] = useState(false);
    const depositAddress = useMemo(() => {
        var _a, _b;
        const providerData = depositData === null || depositData === void 0 ? void 0 : depositData.provider_data;
        return providerData.pix_api_provider === PixApiProvider.Paybrokers ||
            providerData.pix_api_provider === PixApiProvider.WyraPay
            ? (_a = depositData === null || depositData === void 0 ? void 0 : depositData.deposit) === null || _a === void 0 ? void 0 : _a.meta.qr_code_location
            : (_b = depositData === null || depositData === void 0 ? void 0 : depositData.deposit) === null || _b === void 0 ? void 0 : _b.meta.qr_code;
    }, [depositData]);
    const handleCopy = useCallback(() => {
        setTooltipVisible(true);
        void navigator.clipboard.writeText(depositAddress || "");
        setTimeout(() => {
            setTooltipVisible(false);
        }, TOOLTIP_HIDE_TIMEOUT);
    }, [depositAddress]);
    const onSocketUpdate = useCallback((deposit, error) => {
        var _a;
        if (error) {
            console.error(error);
            return;
        }
        if (deposit.id !== ((_a = depositData === null || depositData === void 0 ? void 0 : depositData.deposit) === null || _a === void 0 ? void 0 : _a.id)) {
            return;
        }
        if (deposit.status === DepositStatus.Approved ||
            deposit.status === DepositStatus.Rejected) {
            setDepositStep("complete");
            setDepositData(Object.assign(Object.assign({}, depositData), { deposit: Object.assign(Object.assign({}, depositData === null || depositData === void 0 ? void 0 : depositData.deposit), deposit) }));
        }
    }, [depositData, setDepositStep, setDepositData]);
    return useMemo(() => ({
        isTooltipVisible,
        depositAddress,
        handleCopy,
        onSocketUpdate,
    }), [isTooltipVisible, depositAddress, handleCopy, onSocketUpdate]);
};

const useFirstStepWithdrawal = ({ siteConfigs, rates, balance, }) => {
    var _a, _b, _c;
    const { t } = useTranslation(TranslationScopes.PixWallet);
    const client = useContext(ClientBFFContext);
    const { setWithdrawalStep, setWithdrawalData } = useContext(PixWidgetDataContext);
    const [errorApi, setErrorApi] = useState("");
    const [exceededLimit, setExceededLimit] = useState("");
    const [amount, setAmount] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [recipientData, setRecipientData] = useState({
        type: PixAddressType.CPF,
        value: "",
        error: "",
    });
    const brlRate = (_b = (_a = rates === null || rates === void 0 ? void 0 : rates[Currency.BRL]) === null || _a === void 0 ? void 0 : _a.find((r) => r.toCurrency === "USD")) === null || _b === void 0 ? void 0 : _b.rate;
    const currencyConfig = getCurrencyConfig(siteConfigs, Currency.BRL);
    const { min, max_usd } = currencyConfig.withdrawal || {};
    const max = brlRate && max_usd ? max_usd / Number(brlRate) : 0;
    const roundedMax = round(max, currencyConfig.digits);
    const maxWithdrawal = Math.min(Number(balance), roundedMax);
    const withdrawalProviders = useMemo(() => {
        var _a;
        const providersData = ((_a = siteConfigs.payments.pix) === null || _a === void 0 ? void 0 : _a.withdrawal) || {};
        return Object.keys(providersData)
            .map((provider) => (Object.assign({ provider }, providersData[provider])))
            .filter((p) => p.enabled)
            .sort((a, b) => a.order - b.order);
    }, [siteConfigs]);
    const [selectedProvider, setSelectedProvider] = useState((_c = withdrawalProviders[0]) === null || _c === void 0 ? void 0 : _c.provider);
    useEffect(() => {
        setErrorApi("");
    }, [recipientData.value, amount, selectedProvider]);
    useEffect(() => {
        var _a;
        setSelectedProvider((_a = withdrawalProviders[0]) === null || _a === void 0 ? void 0 : _a.provider);
    }, [withdrawalProviders]);
    useEffect(() => {
        const numberValue = Number(amount || 0);
        if (!amount) {
            setError("");
            return;
        }
        if (numberValue < (min !== null && min !== void 0 ? min : 0) || numberValue > maxWithdrawal) {
            setError(t("min_max_validation", { min, max: maxWithdrawal }));
        }
        else {
            setError("");
        }
    }, [amount, min, maxWithdrawal, t]);
    const clickWithdrawal = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d;
        setErrorApi("");
        setExceededLimit("");
        try {
            setLoading(true);
            const response = yield client.createWithdrawal(Object.assign({ provider: PaymentProvider.PixAPI, currency: Currency.BRL, amount, provider_data: {
                    pix_api_provider: selectedProvider,
                } }, (recipientData.type !== PixAddressType.CPF && {
                provider_data: {
                    recipient_address: {
                        type: recipientData.type,
                        value: recipientData.value,
                    },
                },
            })));
            setWithdrawalData(response);
            setWithdrawalStep("complete");
        }
        catch (e) {
            const errors = (_b = (_a = e.response.data) === null || _a === void 0 ? void 0 : _a.details) !== null && _b !== void 0 ? _b : {};
            if (errors.max_24h_count_withdrawal_error) {
                setExceededLimit(errors.max_24h_count_withdrawal_error);
                return;
            }
            if (((_c = e.response.data) === null || _c === void 0 ? void 0 : _c.error) === "wallet_transient_exception") {
                setErrorApi(t("error_wallet_transient_exception"));
                return;
            }
            if (errors.error_message) {
                setErrorApi(errors.error_message);
                return;
            }
            setErrorApi(((_d = e.response.data) === null || _d === void 0 ? void 0 : _d.message) || e.message);
        }
        finally {
            setLoading(false);
        }
    }), [amount, client, recipientData, setWithdrawalData, setWithdrawalStep, t, selectedProvider]);
    return useMemo(() => ({
        clickWithdrawal,
        amount,
        error,
        loading,
        min,
        setAmount,
        recipientData,
        setRecipientData,
        errorApi,
        exceededLimit,
        withdrawalProviders,
        selectedProvider,
        setSelectedProvider,
    }), [
        clickWithdrawal,
        amount,
        error,
        loading,
        setAmount,
        min,
        recipientData,
        setRecipientData,
        errorApi,
        exceededLimit,
        withdrawalProviders,
        selectedProvider,
        setSelectedProvider,
    ]);
};

const useSecondStepWithdrawal = () => {
    const { withdrawalData, setWithdrawalData } = useContext(PixWidgetDataContext);
    const onSocketUpdate = useCallback((withdrawal, error) => {
        if (error) {
            console.error(error);
            return;
        }
        if (withdrawal.id !== (withdrawalData === null || withdrawalData === void 0 ? void 0 : withdrawalData.id)) {
            return;
        }
        setWithdrawalData(Object.assign(Object.assign({}, withdrawalData), withdrawal));
    }, [withdrawalData, setWithdrawalData]);
    return useMemo(() => ({
        onSocketUpdate,
    }), [onSocketUpdate]);
};

const useDepositWithdrawalCountLimits = () => {
    const client = useContext(ClientBFFContext);
    const depositCountInterval = useRef(undefined);
    const withdrawalCountInterval = useRef(undefined);
    const [nextUpdateDepositCount, setNextUpdateDepositCount] = useState(0);
    const [nextUpdateWithdrawalCount, setNextUpdateWithdrawalCount] = useState(0);
    const [depositRemainderResponse, setDepositRemainderResponse] = useState();
    const [withdrawalRemainderResponse, setWithdrawalRemainderResponse] = useState();
    const loadDepositCountLimits = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield client.get24HoursDepositRemainder();
        setNextUpdateDepositCount(Number(response.next_update_count || 0));
        setDepositRemainderResponse(response);
        if (Number(response.remaining_count) <= 0 && response.next_update_count) {
            let current = Date.now();
            const interval = setInterval(() => {
                const currentDif = Date.now() - current;
                current = Date.now();
                setNextUpdateDepositCount((count) => count - currentDif);
            }, 1000);
            depositCountInterval.current = interval;
        }
    }), [client]);
    const loadWithdrawalCountLimits = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield client.get24HoursWithdrawalRemainder();
        setNextUpdateWithdrawalCount(Number(response.next_update_count || 0));
        setWithdrawalRemainderResponse(response);
        if (Number(response.remaining_count) <= 0 && response.next_update_count) {
            let current = Date.now();
            const interval = setInterval(() => {
                const currentDif = Date.now() - current;
                current = Date.now();
                setNextUpdateWithdrawalCount((count) => count - currentDif);
            }, 1000);
            withdrawalCountInterval.current = interval;
        }
    }), [client]);
    useEffect(() => {
        loadDepositCountLimits();
        loadWithdrawalCountLimits();
        return () => {
            depositCountInterval.current && clearInterval(depositCountInterval.current);
            withdrawalCountInterval.current && clearInterval(withdrawalCountInterval.current);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return useMemo(() => ({
        nextUpdateDepositCount,
        nextUpdateWithdrawalCount,
        depositRemainderResponse,
        withdrawalRemainderResponse,
    }), [
        nextUpdateDepositCount,
        nextUpdateWithdrawalCount,
        depositRemainderResponse,
        withdrawalRemainderResponse,
    ]);
};

const TolaWalletDataContext = createContext(null);
const TolaWalletDataProvider = ({ children }) => {
    const [depositStep, setDepositStep] = useState("first");
    const [depositData, setDepositData] = useState(null);
    const [withdrawalStep, setWithdrawalStep] = useState("first");
    const [withdrawalData, setWithdrawalData] = useState(null);
    const value = useMemo(() => ({
        setDepositStep,
        depositStep,
        depositData,
        setDepositData,
        withdrawalStep,
        setWithdrawalStep,
        withdrawalData,
        setWithdrawalData,
    }), [
        setDepositStep,
        depositStep,
        depositData,
        setDepositData,
        withdrawalStep,
        setWithdrawalStep,
        withdrawalData,
        setWithdrawalData,
    ]);
    return (jsx(TolaWalletDataContext.Provider, { value: value, children: children }));
};

const useFirstStepDepositTola = ({ depositRemainderResponse, mnoChannel, }) => {
    var _a, _b, _c;
    const { t } = useTranslation(TranslationScopes.TolaWallet);
    const client = useContext(ClientBFFContext);
    const { siteConfigs, siteDefaultCurrency } = useContext(ConfigContext);
    const { exchangeRates: rates } = useContext(ExchangeRatesContext);
    const currencyConfig = getCurrencyConfig(siteConfigs, siteDefaultCurrency);
    const { min, max_usd } = currencyConfig.deposit || {};
    const { setDepositStep, setDepositData } = useContext(TolaWalletDataContext);
    const [value, setValue] = useState(min ? `${min}` : "");
    const [error, setError] = useState("");
    const [errorApi, setErrorApi] = useState("");
    const [exceededLimit, setExceededLimit] = useState("");
    const [loading, setLoading] = useState(false);
    const currentCurrencyRate = (_b = (_a = rates === null || rates === void 0 ? void 0 : rates[siteDefaultCurrency]) === null || _a === void 0 ? void 0 : _a.find((r) => r.toCurrency === "USD")) === null || _b === void 0 ? void 0 : _b.rate;
    const max = currentCurrencyRate && max_usd ? max_usd / Number(currentCurrencyRate) : 0;
    const roundedMax = round(max, currencyConfig.digits);
    const userPeriodLimits = (_c = depositRemainderResponse === null || depositRemainderResponse === void 0 ? void 0 : depositRemainderResponse.max_period_limits) === null || _c === void 0 ? void 0 : _c[0];
    const userDepositLimit = userPeriodLimits
        ? round(Number(userPeriodLimits.amount) - Number(userPeriodLimits.actual_sum), currencyConfig.digits)
        : undefined;
    const maxLimit = useMemo(() => {
        if (typeof userDepositLimit !== "number")
            return roundedMax;
        return roundedMax > userDepositLimit ? userDepositLimit : roundedMax;
    }, [roundedMax, userDepositLimit]);
    const isResponsibleLimit = useMemo(() => {
        if (typeof userDepositLimit !== "number")
            return false;
        return userDepositLimit < roundedMax;
    }, [roundedMax, userDepositLimit]);
    const depositProviders = useMemo(() => {
        var _a;
        const providersData = ((_a = siteConfigs.payments.pix) === null || _a === void 0 ? void 0 : _a.deposit) || {};
        return Object.keys(providersData)
            .map((provider) => (Object.assign({ provider }, providersData[provider])))
            .filter((p) => p.enabled)
            .sort((a, b) => a.order - b.order);
    }, [siteConfigs]);
    const [selectedOperator, setSelectedOperator] = useState(mnoChannel);
    useEffect(() => {
        setErrorApi("");
    }, [value, selectedOperator]);
    useEffect(() => {
        const numberValue = Number(value || 0);
        if (!value) {
            setError("");
            return;
        }
        if (numberValue < (min !== null && min !== void 0 ? min : 0) || numberValue > maxLimit) {
            setError(t("min_max_validation", { min, max: maxLimit }));
        }
        else {
            setError("");
        }
    }, [value, min, maxLimit, t]);
    const clickDeposit = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d;
        if (!selectedOperator)
            return;
        setErrorApi("");
        setExceededLimit("");
        try {
            setLoading(true);
            const response = yield client.initiateDeposit({
                provider: PaymentProvider.TolaAPI,
                currency: siteDefaultCurrency,
                amount: value,
                provider_data: {
                    channel: selectedOperator,
                },
            });
            setDepositData((_a = response.deposit) !== null && _a !== void 0 ? _a : null);
            setDepositStep("complete");
        }
        catch (e) {
            const errors = (_c = (_b = e.response.data) === null || _b === void 0 ? void 0 : _b.details) !== null && _c !== void 0 ? _c : {};
            if (errors.max_24h_count_deposit_error) {
                setExceededLimit(errors.max_24h_count_deposit_error);
                return;
            }
            if (errors.error_message) {
                setErrorApi(errors.error_message);
                return;
            }
            setErrorApi(((_d = e.response.data) === null || _d === void 0 ? void 0 : _d.message) || e.message);
        }
        finally {
            setLoading(false);
        }
    }), [selectedOperator, client, siteDefaultCurrency, value, setDepositData, setDepositStep]);
    return useMemo(() => ({
        clickDeposit,
        value,
        error,
        loading,
        min,
        maxLimit,
        currencyConfig,
        setValue,
        errorApi,
        exceededLimit,
        depositProviders,
        selectedOperator,
        isResponsibleLimit,
        setSelectedOperator,
    }), [
        clickDeposit,
        value,
        error,
        loading,
        setValue,
        min,
        maxLimit,
        currencyConfig,
        errorApi,
        exceededLimit,
        depositProviders,
        selectedOperator,
        isResponsibleLimit,
        setSelectedOperator,
    ]);
};

const useFirstStepDepositTolaV2 = ({ depositRemainderResponse, mnoChannel, }) => {
    var _a, _b, _c;
    const { t } = useTranslation(TranslationScopes.TolaWallet);
    const client = useContext(ClientBFFContext);
    const { siteConfigs, siteDefaultCurrency } = useContext(ConfigContextV2);
    const { exchangeRates: rates } = useContext(ExchangeRatesContextV2);
    const currencyConfig = getCurrencyConfig(siteConfigs, siteDefaultCurrency);
    const { min, max_usd } = currencyConfig.deposit || {};
    const { setDepositStep, setDepositData } = useContext(TolaWalletDataContext);
    const [value, setValue] = useState(min ? `${min}` : "");
    const [error, setError] = useState("");
    const [errorApi, setErrorApi] = useState("");
    const [exceededLimit, setExceededLimit] = useState("");
    const [loading, setLoading] = useState(false);
    const currentCurrencyRate = (_b = (_a = rates === null || rates === void 0 ? void 0 : rates[siteDefaultCurrency]) === null || _a === void 0 ? void 0 : _a.find((r) => r.toCurrency === "USD")) === null || _b === void 0 ? void 0 : _b.rate;
    const max = currentCurrencyRate && max_usd ? max_usd / Number(currentCurrencyRate) : 0;
    const roundedMax = round(max, currencyConfig.digits);
    const userPeriodLimits = (_c = depositRemainderResponse === null || depositRemainderResponse === void 0 ? void 0 : depositRemainderResponse.max_period_limits) === null || _c === void 0 ? void 0 : _c[0];
    const userDepositLimit = userPeriodLimits
        ? round(Number(userPeriodLimits.amount) - Number(userPeriodLimits.actual_sum), currencyConfig.digits)
        : undefined;
    const maxLimit = useMemo(() => {
        if (typeof userDepositLimit !== "number")
            return roundedMax;
        return roundedMax > userDepositLimit ? userDepositLimit : roundedMax;
    }, [roundedMax, userDepositLimit]);
    const isResponsibleLimit = useMemo(() => {
        if (typeof userDepositLimit !== "number")
            return false;
        return userDepositLimit < roundedMax;
    }, [roundedMax, userDepositLimit]);
    const depositProviders = useMemo(() => {
        var _a;
        const providersData = ((_a = siteConfigs.payments.pix) === null || _a === void 0 ? void 0 : _a.deposit) || {};
        return Object.keys(providersData)
            .map((provider) => (Object.assign({ provider }, providersData[provider])))
            .filter((p) => p.enabled)
            .sort((a, b) => a.order - b.order);
    }, [siteConfigs]);
    const [selectedOperator, setSelectedOperator] = useState(mnoChannel);
    useEffect(() => {
        setErrorApi("");
    }, [value, selectedOperator]);
    useEffect(() => {
        const numberValue = Number(value || 0);
        if (!value) {
            setError("");
            return;
        }
        if (numberValue < (min !== null && min !== void 0 ? min : 0) || numberValue > maxLimit) {
            setError(t("min_max_validation", { min, max: maxLimit }));
        }
        else {
            setError("");
        }
    }, [value, min, maxLimit, t]);
    const clickDeposit = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d;
        if (!selectedOperator)
            return;
        setErrorApi("");
        setExceededLimit("");
        try {
            setLoading(true);
            const response = yield client.initiateDeposit({
                provider: PaymentProvider.TolaAPI,
                currency: siteDefaultCurrency,
                amount: value,
                provider_data: {
                    channel: selectedOperator,
                },
            });
            setDepositData((_a = response.deposit) !== null && _a !== void 0 ? _a : null);
            setDepositStep("complete");
        }
        catch (e) {
            const errors = (_c = (_b = e.response.data) === null || _b === void 0 ? void 0 : _b.details) !== null && _c !== void 0 ? _c : {};
            if (errors.max_24h_count_deposit_error) {
                setExceededLimit(errors.max_24h_count_deposit_error);
                return;
            }
            if (errors.error_message) {
                setErrorApi(errors.error_message);
                return;
            }
            setErrorApi(((_d = e.response.data) === null || _d === void 0 ? void 0 : _d.message) || e.message);
        }
        finally {
            setLoading(false);
        }
    }), [selectedOperator, client, siteDefaultCurrency, value, setDepositData, setDepositStep]);
    return useMemo(() => ({
        clickDeposit,
        value,
        error,
        loading,
        min,
        maxLimit,
        currencyConfig,
        setValue,
        errorApi,
        exceededLimit,
        depositProviders,
        selectedOperator,
        isResponsibleLimit,
        setSelectedOperator,
    }), [
        clickDeposit,
        value,
        error,
        loading,
        setValue,
        min,
        maxLimit,
        currencyConfig,
        errorApi,
        exceededLimit,
        depositProviders,
        selectedOperator,
        isResponsibleLimit,
        setSelectedOperator,
    ]);
};

const useFirstStepWithdrawalTola = ({ balance, mnoChannel, }) => {
    var _a, _b;
    const { t } = useTranslation(TranslationScopes.TolaWallet);
    const client = useContext(ClientBFFContext);
    const { setWithdrawalStep, setWithdrawalData } = useContext(TolaWalletDataContext);
    const { siteConfigs, siteDefaultCurrency } = useContext(ConfigContext);
    const { exchangeRates: rates } = useContext(ExchangeRatesContext);
    const currencyConfig = getCurrencyConfig(siteConfigs, siteDefaultCurrency);
    const { min, max_usd } = currencyConfig.withdrawal || {};
    const [errorApi, setErrorApi] = useState("");
    const [exceededLimit, setExceededLimit] = useState("");
    const [amount, setAmount] = useState(min ? `${min}` : "");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [recipientData, setRecipientData] = useState({
        type: PixAddressType.CPF,
        value: "",
        error: "",
    });
    const currentCurrencyRate = (_b = (_a = rates === null || rates === void 0 ? void 0 : rates[siteDefaultCurrency]) === null || _a === void 0 ? void 0 : _a.find((r) => r.toCurrency === "USD")) === null || _b === void 0 ? void 0 : _b.rate;
    const max = currentCurrencyRate && max_usd ? max_usd / Number(currentCurrencyRate) : 0;
    const roundedMax = round(max, currencyConfig.digits);
    const maxWithdrawal = Math.min(Number(balance), roundedMax);
    const withdrawalProviders = useMemo(() => {
        var _a;
        const providersData = ((_a = siteConfigs.payments.pix) === null || _a === void 0 ? void 0 : _a.withdrawal) || {};
        return Object.keys(providersData)
            .map((provider) => (Object.assign({ provider }, providersData[provider])))
            .filter((p) => p.enabled)
            .sort((a, b) => a.order - b.order);
    }, [siteConfigs]);
    const [selectedOperator, setSelectedOperator] = useState(mnoChannel);
    useEffect(() => {
        setErrorApi("");
    }, [amount, selectedOperator]);
    useEffect(() => {
        const numberValue = Number(amount || 0);
        if (!amount) {
            setError("");
            return;
        }
        if (numberValue < (min !== null && min !== void 0 ? min : 0) || numberValue > maxWithdrawal) {
            setError(t("min_max_validation", { min, max: maxWithdrawal }));
        }
        else {
            setError("");
        }
    }, [amount, min, maxWithdrawal, t]);
    const clickWithdrawal = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d;
        if (!selectedOperator)
            return;
        setErrorApi("");
        setExceededLimit("");
        try {
            setLoading(true);
            const response = yield client.createWithdrawal({
                provider: PaymentProvider.TolaAPI,
                currency: siteDefaultCurrency,
                amount,
                provider_data: {
                    channel: selectedOperator,
                },
            });
            setWithdrawalData(response);
            setWithdrawalStep("complete");
        }
        catch (e) {
            const errors = (_b = (_a = e.response.data) === null || _a === void 0 ? void 0 : _a.details) !== null && _b !== void 0 ? _b : {};
            if (errors.max_24h_count_withdrawal_error) {
                setExceededLimit(errors.max_24h_count_withdrawal_error);
                return;
            }
            if (((_c = e.response.data) === null || _c === void 0 ? void 0 : _c.error) === "wallet_transient_exception") {
                setErrorApi(t("error_wallet_transient_exception"));
                return;
            }
            if (errors.error_message) {
                setErrorApi(errors.error_message);
                return;
            }
            setErrorApi(((_d = e.response.data) === null || _d === void 0 ? void 0 : _d.message) || e.message);
        }
        finally {
            setLoading(false);
        }
    }), [
        amount,
        client,
        selectedOperator,
        setWithdrawalData,
        setWithdrawalStep,
        siteDefaultCurrency,
        t,
    ]);
    return useMemo(() => ({
        clickWithdrawal,
        amount,
        error,
        loading,
        min,
        setAmount,
        recipientData,
        setRecipientData,
        errorApi,
        exceededLimit,
        withdrawalProviders,
        selectedOperator,
        setSelectedOperator,
    }), [
        clickWithdrawal,
        amount,
        error,
        loading,
        setAmount,
        min,
        recipientData,
        setRecipientData,
        errorApi,
        exceededLimit,
        withdrawalProviders,
        selectedOperator,
        setSelectedOperator,
    ]);
};

const useFirstStepWithdrawalTolaV2 = ({ balance, mnoChannel, }) => {
    var _a, _b;
    const { t } = useTranslation(TranslationScopes.TolaWallet);
    const client = useContext(ClientBFFContext);
    const { setWithdrawalStep, setWithdrawalData } = useContext(TolaWalletDataContext);
    const { siteConfigs, siteDefaultCurrency } = useContext(ConfigContextV2);
    const { exchangeRates: rates } = useContext(ExchangeRatesContextV2);
    const currencyConfig = getCurrencyConfig(siteConfigs, siteDefaultCurrency);
    const { min, max_usd } = currencyConfig.withdrawal || {};
    const [errorApi, setErrorApi] = useState("");
    const [exceededLimit, setExceededLimit] = useState("");
    const [amount, setAmount] = useState(min ? `${min}` : "");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [recipientData, setRecipientData] = useState({
        type: PixAddressType.CPF,
        value: "",
        error: "",
    });
    const currentCurrencyRate = (_b = (_a = rates === null || rates === void 0 ? void 0 : rates[siteDefaultCurrency]) === null || _a === void 0 ? void 0 : _a.find((r) => r.toCurrency === "USD")) === null || _b === void 0 ? void 0 : _b.rate;
    const max = currentCurrencyRate && max_usd ? max_usd / Number(currentCurrencyRate) : 0;
    const roundedMax = round(max, currencyConfig.digits);
    const maxWithdrawal = Math.min(Number(balance), roundedMax);
    const withdrawalProviders = useMemo(() => {
        var _a;
        const providersData = ((_a = siteConfigs.payments.pix) === null || _a === void 0 ? void 0 : _a.withdrawal) || {};
        return Object.keys(providersData)
            .map((provider) => (Object.assign({ provider }, providersData[provider])))
            .filter((p) => p.enabled)
            .sort((a, b) => a.order - b.order);
    }, [siteConfigs]);
    const [selectedOperator, setSelectedOperator] = useState(mnoChannel);
    useEffect(() => {
        setErrorApi("");
    }, [amount, selectedOperator]);
    useEffect(() => {
        const numberValue = Number(amount || 0);
        if (!amount) {
            setError("");
            return;
        }
        if (numberValue < (min !== null && min !== void 0 ? min : 0) || numberValue > maxWithdrawal) {
            setError(t("min_max_validation", { min, max: maxWithdrawal }));
        }
        else {
            setError("");
        }
    }, [amount, min, maxWithdrawal, t]);
    const clickWithdrawal = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d;
        if (!selectedOperator)
            return;
        setErrorApi("");
        setExceededLimit("");
        try {
            setLoading(true);
            const response = yield client.createWithdrawal({
                provider: PaymentProvider.TolaAPI,
                currency: siteDefaultCurrency,
                amount,
                provider_data: {
                    channel: selectedOperator,
                },
            });
            setWithdrawalData(response);
            setWithdrawalStep("complete");
        }
        catch (e) {
            const errors = (_b = (_a = e.response.data) === null || _a === void 0 ? void 0 : _a.details) !== null && _b !== void 0 ? _b : {};
            if (errors.max_24h_count_withdrawal_error) {
                setExceededLimit(errors.max_24h_count_withdrawal_error);
                return;
            }
            if (((_c = e.response.data) === null || _c === void 0 ? void 0 : _c.error) === "wallet_transient_exception") {
                setErrorApi(t("error_wallet_transient_exception"));
                return;
            }
            if (errors.error_message) {
                setErrorApi(errors.error_message);
                return;
            }
            setErrorApi(((_d = e.response.data) === null || _d === void 0 ? void 0 : _d.message) || e.message);
        }
        finally {
            setLoading(false);
        }
    }), [
        amount,
        client,
        selectedOperator,
        setWithdrawalData,
        setWithdrawalStep,
        siteDefaultCurrency,
        t,
    ]);
    return useMemo(() => ({
        clickWithdrawal,
        amount,
        error,
        loading,
        min,
        setAmount,
        recipientData,
        setRecipientData,
        errorApi,
        exceededLimit,
        withdrawalProviders,
        selectedOperator,
        setSelectedOperator,
    }), [
        clickWithdrawal,
        amount,
        error,
        loading,
        setAmount,
        min,
        recipientData,
        setRecipientData,
        errorApi,
        exceededLimit,
        withdrawalProviders,
        selectedOperator,
        setSelectedOperator,
    ]);
};

const MultiWidgetDataContext = createContext(null);
const MultiWalletDataProvider = ({ children }) => {
    const [depositStep, setDepositStep] = useState("first");
    const [withdrawStep, setWithdrawStep] = useState("first");
    // const [activeProvider, setActiveProvider] = useState("")
    const [explorerLink, setExplorerLink] = useState("");
    const value = useMemo(() => ({
        depositStep,
        setDepositStep,
        withdrawStep,
        setWithdrawStep,
        explorerLink,
        setExplorerLink,
    }), [depositStep, explorerLink, withdrawStep]);
    return (jsx(MultiWidgetDataContext.Provider, { value: value, children: children }));
};

const useSecondStepDepositMulti = ({}) => {
    const client = useContext(ClientBFFContext);
    const { setExplorerLink } = useContext(MultiWidgetDataContext);
    const [amount, setAmount] = useState("");
    const [cardNumber, setCardNumber] = useState("");
    const [error] = useState("");
    const [loading, setLoading] = useState(false);
    const clickDeposit = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c;
        try {
            setLoading(true);
            const response = yield client.initiateDeposit({
                provider: PaymentProvider.GumBallPay,
                currency: Currency.EUR,
                amount,
                provider_data: {
                    card_number: cardNumber.replaceAll(" ", ""),
                },
            });
            const explorerLink = (_a = response.deposit) === null || _a === void 0 ? void 0 : _a.meta.explorer_link;
            setExplorerLink(explorerLink || "");
        }
        catch (e) {
            const errors = (_c = (_b = e.response.data) === null || _b === void 0 ? void 0 : _b.details) !== null && _c !== void 0 ? _c : {};
            /* if (errors.max_24h_count_deposit_error) {
                        setExceededLimit(errors.max_24h_count_deposit_error);
                        return;
                    }
                    if (errors.error_message) {
                        setErrorApi(errors.error_message);
                        return;
                    } */
            // setErrorApi(e.response.data?.message || e.message);
            console.log(errors);
        }
        finally {
            setLoading(false);
        }
    }), [client, amount, cardNumber, setExplorerLink]);
    return useMemo(() => ({
        amount,
        setAmount,
        clickDeposit,
        error,
        loading,
        cardNumber,
        setCardNumber,
    }), [amount, cardNumber, clickDeposit, error, loading]);
};

const useSecondStepWithdrawMulti = () => {
    const client = useContext(ClientBFFContext);
    const [amount, setAmount] = useState("");
    const [cardNumber, setCardNumber] = useState("");
    const [error] = useState("");
    const [loading, setLoading] = useState(false);
    const clickWithdraw = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        try {
            setLoading(true);
            yield client.createWithdrawal({
                provider: PaymentProvider.GumBallPay,
                currency: Currency.EUR,
                amount,
                provider_data: {
                    card_number: cardNumber.replaceAll(" ", ""),
                },
            });
        }
        catch (e) {
            const errors = (_b = (_a = e.response.data) === null || _a === void 0 ? void 0 : _a.details) !== null && _b !== void 0 ? _b : {};
            setLoading(false);
            console.log(errors);
        }
    }), [client, amount, cardNumber]);
    return useMemo(() => ({
        amount,
        setAmount,
        clickWithdraw,
        error,
        loading,
        cardNumber,
        setCardNumber,
    }), [amount, cardNumber, clickWithdraw, error, loading]);
};

const useResponsibleGaming = () => {
    const client = useContext(ClientBFFContext);
    const router = useRouter();
    const [paymentsPeriodConfig, setPaymentsPeriodConfig] = useState();
    const [loadingPeriodConfig, setLoadingPeriodConfig] = useState(true);
    const loadPaymentsPeriodConfig = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const res = yield client.getPaymentsPeriodConfig();
            setPaymentsPeriodConfig(res);
        }
        finally {
            setLoadingPeriodConfig(false);
        }
    }), [client]);
    const updateSelfExclusion = useCallback((data) => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield client.updateProfile({
            blocked_till: data.period,
            verify_password: data.password,
        });
        if (response.status === UserStatus.Blocked) {
            yield router.replace("/");
        }
        return response;
    }), [client, router]);
    const updateDepositLimits = useCallback((data) => __awaiter(void 0, void 0, void 0, function* () {
        const res = yield client.updatePaymentsPeriodConfig({
            verify_password: data.password,
            max_period_amounts: [
                {
                    amount: Number(data.amount),
                    period: Number(data.period),
                    start_from: new Date().toISOString(),
                },
            ],
        });
        setPaymentsPeriodConfig(res);
    }), [client]);
    useEffect(() => {
        loadPaymentsPeriodConfig();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return useMemo(() => ({
        paymentsPeriodConfig,
        updateSelfExclusion,
        updateDepositLimits,
        loadingPeriodConfig,
    }), [paymentsPeriodConfig, updateSelfExclusion, updateDepositLimits, loadingPeriodConfig]);
};

const useResponsibleGamingV2 = () => {
    const client = useContext(ClientBFFContext);
    const router = useRouter$1();
    const [paymentsPeriodConfig, setPaymentsPeriodConfig] = useState();
    const [loadingPeriodConfig, setLoadingPeriodConfig] = useState(true);
    const loadPaymentsPeriodConfig = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const res = yield client.getPaymentsPeriodConfig();
            setPaymentsPeriodConfig(res);
        }
        finally {
            setLoadingPeriodConfig(false);
        }
    }), [client]);
    const updateSelfExclusion = useCallback((data) => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield client.updateProfile({
            blocked_till: data.period,
            verify_password: data.password,
        });
        if (response.status === UserStatus.Blocked) {
            router.replace("/");
        }
        return response;
    }), [client, router]);
    const updateDepositLimits = useCallback((data) => __awaiter(void 0, void 0, void 0, function* () {
        const res = yield client.updatePaymentsPeriodConfig({
            verify_password: data.password,
            max_period_amounts: [
                {
                    amount: Number(data.amount),
                    period: Number(data.period),
                    start_from: new Date().toISOString(),
                },
            ],
        });
        setPaymentsPeriodConfig(res);
    }), [client]);
    useEffect(() => {
        loadPaymentsPeriodConfig();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return useMemo(() => ({
        paymentsPeriodConfig,
        updateSelfExclusion,
        updateDepositLimits,
        loadingPeriodConfig,
    }), [paymentsPeriodConfig, updateSelfExclusion, updateDepositLimits, loadingPeriodConfig]);
};

function getFormattedDepositLimitPeriod(period) {
    switch (period) {
        case DepositLimitPeriodInterval.DAY: {
            return "daily";
        }
        case DepositLimitPeriodInterval.WEEK: {
            return "weekly";
        }
        case DepositLimitPeriodInterval.MONTH: {
            return "monthly";
        }
    }
    return "no-restriction";
}

const userInfoValidationSchema = object().shape({
    username: string()
        .when("$configObj", ([config], schema) => {
        if (config === null || config === void 0 ? void 0 : config.username.required) {
            return schema.required(config.t("validation_err_required"));
        }
        return schema.notRequired().transform((value) => (!!value ? value : null));
    })
        .when("$configObj", ([config], schema) => {
        return schema
            .min(config.username.min_length, config.t("validation_err_minMaxLength", {
            min_length: config.username.min_length,
            max_length: config.username.max_length,
        }))
            .max(config.username.max_length, config.t("validation_err_minMaxLength", {
            min_length: config.username.min_length,
            max_length: config.username.max_length,
        }));
    })
        .when("$configObj", ([config], schema) => {
        return schema.matches(/^(?![0-9]*$)/, config.t("validation_err_notOnlyNum"));
    })
        .when("$configObj", ([config], schema) => {
        return schema.matches(LETTERS_OR_DIGITS, config.t("validation_err_letersOrDigits"));
    }),
    phone: string()
        .trim()
        .when("$configObj", ([config], schema) => {
        if (config.phone.required) {
            return schema.required(config.t("validation_err_required"));
        }
        return schema.notRequired().transform((value) => (!!value ? value : null));
    }),
    email: string()
        .when("$configObj", ([config], schema) => {
        if (config.email.required) {
            return schema.required(config.t("validation_err_required"));
        }
        return schema.notRequired().transform((value) => (!!value ? value : null));
    })
        .when("$configObj", ([config], schema) => {
        return schema.matches(EMAIL_REGEX, config.t("validation_err_notValid"));
    })
        .when("$configObj", ([config], schema) => {
        if (Boolean(config.email.max_length)) {
            return schema.max(config.email.max_length, config.t("validation_err_maxLength", {
                max_length: config.email.max_length,
            }));
        }
        return schema;
    }),
    first_name: string()
        .when("$configObj", ([config], schema) => {
        if (Boolean(config.first_name.max_length)) {
            return schema.max(config.first_name.max_length, config.t("validation_err_maxLength", {
                max_length: config.first_name.max_length,
            }));
        }
        return schema;
    })
        .when("$configObj", ([config], schema) => {
        if (config.first_name.required) {
            return schema.required(config.t("validation_err_required"));
        }
        return schema.notRequired().transform((value) => (!!value ? value : null));
    }),
    last_name: string()
        .when("$configObj", ([config], schema) => {
        if (config.last_name.required) {
            return schema.required(config.t("validation_err_required"));
        }
        return schema.notRequired().transform((value) => (!!value ? value : null));
    })
        .when("$configObj", ([config], schema) => {
        if (Boolean(config.last_name.max_length)) {
            return schema.max(config.last_name.max_length, config.t("validation_err_maxLength", {
                max_length: config.last_name.max_length,
            }));
        }
        return schema;
    }),
    birth_date: string().when("$configObj", ([config], schema) => {
        if (config.birth_date.required) {
            return schema.required(config.t("validation_err_required"));
        }
        return schema.notRequired().transform((value) => (!!value ? value : null));
    }),
    referral: string()
        .when("$configObj", ([config], schema) => {
        if (config.referral.required) {
            return schema.required(config.t("validation_err_required"));
        }
        return schema.notRequired().transform((value) => (!!value ? value : null));
    })
        .when("$configObj", ([config], schema) => {
        return schema.matches(LETTERS_OR_DIGITS, {
            excludeEmptyString: true,
            message: config.t("validation_err_letersOrDigits"),
        });
    })
        .when("$configObj", ([config], schema) => {
        if (config.referral.min_length && config.referral.max_length) {
            return schema
                .min(config.referral.min_length, config.t("validation_err_minMaxLength", {
                min_length: config.referral.min_length,
                max_length: config.referral.max_length,
            }))
                .max(config.referral.max_length, config.t("validation_err_minMaxLength", {
                min_length: config.referral.min_length,
                max_length: config.referral.max_length,
            }));
        }
        return schema;
    }),
    country: string().when("$configObj", ([config], schema) => {
        if (config.country.required) {
            return schema.required(config.t("validation_err_required"));
        }
        return schema.notRequired().transform((value) => (!!value ? value : null));
    }),
    state: string().when("$configObj", ([config], schema) => {
        if (config.state.required) {
            return schema.required(config.t("validation_err_required"));
        }
        return schema.notRequired().transform((value) => (!!value ? value : null));
    }),
    gender: string().when("$configObj", ([config], schema) => {
        if (config.gender.required) {
            return schema.required(config.t("validation_err_required"));
        }
        return schema.notRequired().transform((value) => (!!value ? value : null));
    }),
    city: string().when("$configObj", ([config], schema) => {
        if (config.city.required) {
            return schema.required(config.t("validation_err_required"));
        }
        return schema.notRequired().transform((value) => (!!value ? value : null));
    }),
    address: string().when("$configObj", ([config], schema) => {
        if (config.address.required) {
            return schema.required(config.t("validation_err_required"));
        }
        return schema.notRequired().transform((value) => (!!value ? value : null));
    }),
    zip_code: string().when("$configObj", ([config], schema) => {
        if (config.zip_code.required) {
            return schema.required(config.t("validation_err_required"));
        }
        return schema.notRequired().transform((value) => (!!value ? value : null));
    }),
});

const becomeReferralValidationSchema = userInfoValidationSchema.pick(["referral"]).shape({
    acceptTerms: bool().required().oneOf([true]),
});

const PASSWORD_RULE = string()
    .when("$configObj", ([config], schema) => {
    if (config) {
        return schema
            .min(config.password.min_length, config.t("validation_err_minMaxLength", {
            min_length: config.password.min_length,
            max_length: config.password.max_length,
        }))
            .max(config.password.max_length, config.t("validation_err_minMaxLength", {
            min_length: config.password.min_length,
            max_length: config.password.max_length,
        }));
    }
    return schema;
})
    .when("$configObj", ([config], schema) => {
    if (config) {
        if (config.password.has_digit) {
            return schema.matches(DIGIT_REGEX, config.t("validation_err_digits"));
        }
        return schema.matches(NO_DIGIT_REGEX, "Digits are not allowed");
    }
    return schema;
})
    .when("$configObj", ([config], schema) => {
    if (config) {
        if (config.password.has_letter) {
            return schema.matches(LETTERS_REGEX, config.t("validation_err_letters"));
        }
        return schema.matches(NO_LETTERS_REGEX, "Letters are not allowed");
    }
    return schema;
})
    .when("$configObj", ([config], schema) => {
    if (config && config.password && config.password.required) {
        return schema.required(config.t("validation_err_required"));
    }
    return schema.notRequired().transform((value) => (!!value ? value : null));
});
const signupValidationSchema = userInfoValidationSchema
    .pick([
    "username",
    "phone",
    "email",
    "first_name",
    "last_name",
    "birth_date",
    "country",
    "city",
    "state",
    "address",
    "zip_code",
    "gender",
])
    .shape({
    referral: string()
        .when("$configObj", ([config], schema) => {
        if (config.referral.required) {
            if (config.referral.default) {
                return schema
                    .required(config.t("validation_err_required"))
                    .nullable()
                    .transform((value) => (!!value ? value : null));
            }
            return schema.required(config.t("validation_err_required"));
        }
        return schema.notRequired().transform((value) => (!!value ? value : null));
    })
        .when("$configObj", ([config], schema) => {
        return schema.matches(LETTERS_OR_DIGITS, {
            excludeEmptyString: true,
            message: config.t("validation_err_letersOrDigits"),
        });
    })
        .when("$configObj", ([config], schema) => {
        if (config.referral.min_length && config.referral.max_length) {
            return schema
                .min(config.referral.min_length, config.t("validation_err_minMaxLength", {
                min_length: config.referral.min_length,
                max_length: config.referral.max_length,
            }))
                .max(config.referral.max_length, config.t("validation_err_minMaxLength", {
                min_length: config.referral.min_length,
                max_length: config.referral.max_length,
            }));
        }
        return schema;
    }),
    password: PASSWORD_RULE,
    currency: string().when("$configObj", ([config], schema) => {
        if (config.currency.required) {
            return schema.required(config.t("validation_err_required"));
        }
        return schema.notRequired().transform((value) => (!!value ? value : null));
    }),
    language: string().when("$configObj", ([config], schema) => {
        if (config.language.required) {
            return schema.required(config.t("validation_err_required"));
        }
        return schema.notRequired().transform((value) => (!!value ? value : null));
    }),
    acceptTerms: bool().required().oneOf([true]),
});
const cpfSignupValidationSchema = signupValidationSchema
    .omit(["city", "state", "address", "zip_code"])
    .shape({
    cpf_number: string()
        .when("$configObj", ([config], schema) => {
        if (config.cpf_number.required) {
            return schema.required(config.t("validation_err_required"));
        }
        return schema;
    })
        .when("$configObj", ([config], schema) => {
        return schema.min(11, config.t("validation_err_minLength", {
            min_length: 11,
        }));
    }),
    referral: string()
        .when("$configObj", ([config], schema) => {
        if (config.referral.required) {
            return schema.required(config.t("validation_err_required"));
        }
        return schema.notRequired().transform((value) => (!!value ? value : null));
    })
        .when("$configObj", ([config], schema) => {
        return schema
            .transform((value) => value === null || value === void 0 ? void 0 : value.toLowerCase())
            .matches(LETTERS_OR_DIGITS, {
            excludeEmptyString: true,
            message: config.t("validation_err_letersOrDigits"),
        });
    })
        .when("$configObj", ([config], schema) => {
        if (config.referral.min_length && config.referral.max_length) {
            return schema
                .min(config.referral.min_length, config.t("validation_err_minMaxLength", {
                min_length: config.referral.min_length,
                max_length: config.referral.max_length,
            }))
                .max(config.referral.max_length, config.t("validation_err_minMaxLength", {
                min_length: config.referral.min_length,
                max_length: config.referral.max_length,
            }));
        }
        return schema;
    }),
    full_name: string()
        .trim()
        .when("$configObj", ([config], schema) => {
        if (Boolean(config.full_name.max_length)) {
            return schema.max(config.full_name.max_length, config.t("validation_err_maxLength", {
                max_length: config.full_name.max_length,
            }));
        }
        return schema;
    })
        .when("$configObj", ([config], schema) => {
        return schema.matches(WHITESPACE_REGEX, {
            excludeEmptyString: true,
            message: config.t("validation_err_fullNameSpaceBetween"),
        });
    })
        .when("$configObj", ([config], schema) => {
        if (config.full_name.required) {
            return schema.required(config.t("validation_err_required"));
        }
        return schema.notRequired().transform((value) => (!!value ? value : null));
    }),
});
const cpfSignupValidationSchemaBrazilian = cpfSignupValidationSchema.shape({
    username: string()
        .when("$configObj", ([config], schema) => {
        return schema
            .min(config.username.min_length, config.t("validation_err_minMaxLength", {
            min_length: config.username.min_length,
            max_length: config.username.max_length,
        }))
            .max(config.username.max_length, config.t("validation_err_minMaxLength", {
            min_length: config.username.min_length,
            max_length: config.username.max_length,
        }));
    })
        .when("$configObj", ([config], schema) => {
        return schema.matches(/^(?![0-9]*$)/, config.t("validation_err_notOnlyNum"));
    })
        .when("$configObj", ([config], schema) => {
        return schema.matches(LETTERS_OR_DIGITS_BRAZILIAN_REGEX, config.t("validation_err_letersOrDigits"));
    })
        .when("$configObj", ([config], schema) => {
        if (config === null || config === void 0 ? void 0 : config.username.required) {
            return schema.required(config.t("validation_err_required"));
        }
        return schema.notRequired().transform((value) => (!!value ? value : null));
    }),
});
const afroSignupValidationSchema = signupValidationSchema.shape({
    age: string().when("$configObj", ([config], schema) => {
        if (config.age.required) {
            return schema.required(config.t("validation_err_required"));
        }
        return schema;
    }),
    password_confirm: string()
        .when("$configObj", ([config], schema) => {
        return schema.required(config.t("validation_err_required"));
    })
        .oneOf([ref("password"), ""], "Passwords must match"),
});

const changePasswordValidationSchema = signupValidationSchema.pick(["password"]).shape({
    new_password: PASSWORD_RULE,
    password_confirm: string().oneOf([ref("new_password")], "Passwords must match"),
});

const createSubagentValidationSchema = signupValidationSchema
    .pick(["username", "phone", "email", "first_name", "last_name", "password"])
    .shape({
    account_holder: string().when("$configObj", ([config], schema) => {
        if (config.account_holder.required) {
            return schema.required(config.t("validation_err_required"));
        }
        return schema.notRequired().transform((value) => (!!value ? value : null));
    }),
    bank_name: string().when("$configObj", ([config], schema) => {
        if (config.bank_name.required) {
            return schema.required(config.t("validation_err_required"));
        }
        return schema.notRequired().transform((value) => (!!value ? value : null));
    }),
    account_number: string().when("$configObj", ([config], schema) => {
        if (config.account_number.required) {
            return schema.required(config.t("validation_err_required"));
        }
        return schema.notRequired().transform((value) => (!!value ? value : null));
    }),
    sport_cashback: number()
        .when("$configObj", ([config], schema) => schema.typeError(config.t("validation_err_required")))
        .when("$configObj", ([config], schema) => schema.min(0, config.t("validation_err_minValue", {
        value: 0,
    })))
        .when("$configObj", ([config], schema) => schema.max(config.sport_cashback.max, config.t("validation_err_maxValue", {
        value: config.sport_cashback.max,
    }))),
    live_casino_cashback: number()
        .when("$configObj", ([config], schema) => schema.typeError(config.t("validation_err_required")))
        .when("$configObj", ([config], schema) => schema.min(0, config.t("validation_err_minValue", {
        value: 0,
    })))
        .when("$configObj", ([config], schema) => schema.max(config.live_casino_cashback.max, config.t("validation_err_maxValue", {
        value: config.live_casino_cashback.max,
    }))),
    slots_cashback: number()
        .when("$configObj", ([config], schema) => schema.typeError(config.t("validation_err_required")))
        .when("$configObj", ([config], schema) => schema.min(0, config.t("validation_err_minValue", {
        value: 0,
    })))
        .when("$configObj", ([config], schema) => schema.max(config.slots_cashback.max, config.t("validation_err_maxValue", {
        value: config.slots_cashback.max,
    }))),
    agent_code: string(),
});

const depositLimitsValidationSchema = object().shape({
    period: string().when("$configObj", ([config], schema) => {
        return schema.required(config.t("validation_err_required"));
    }),
    password: PASSWORD_RULE,
    amount: number().when("$configObj", ([config], schema) => {
        return schema
            .positive(config.t("validation_err_positive"))
            .typeError(config.t("validation_err_notValid"))
            .required(config.t("validation_err_required"));
    }),
});

const loginFormSchema = object().shape({
    login_type: string()
        .oneOf(["email", "phone"])
        .defined()
        .when("$configObj", ([config], schema) => {
        if (config && config.enableSwitch) {
            return schema.required();
        }
        return schema.notRequired();
    }),
    password: PASSWORD_RULE,
    email: string().when("login_type", ([login_type], schema, options) => {
        if (login_type === "email") {
            return schema.required(options.context.configObj.t("validation_err_required"));
        }
        return schema;
    }),
    phone: string()
        .trim()
        .when("login_type", ([login_type], schema, options) => {
        if (login_type === "phone") {
            return schema.required(options.context.configObj.t("validation_err_required"));
        }
        return schema;
    }),
});

const selfExclusionValidationSchema = object().shape({
    period: string().when("$configObj", ([config], schema) => {
        return schema.required(config.t("validation_err_required"));
    }),
    password: PASSWORD_RULE,
});

const userDocumentValidationSchema = object({
    passport_doc_number: string().required(),
    license_doc_number: string().required(),
});

const userPreferencesValidationSchema = object({
    language: string().required(),
});

export { formatCasinoProviderName as $, AffiseInitScript as A, useCoreVerify as B, CpfSignupContext as C, DefaultWalletDataContext as D, useFirstStepDeposit as E, useSecondStepDeposit as F, PixWalletDataProvider as G, useFirstStepWithdrawal as H, useSecondStepWithdrawal as I, useDepositWithdrawalCountLimits as J, TolaWalletDataContext as K, TolaWalletDataProvider as L, useFirstStepDepositTola as M, useFirstStepDepositTolaV2 as N, useFirstStepWithdrawalTola as O, PixWidgetDataContext as P, useFirstStepWithdrawalTolaV2 as Q, MultiWidgetDataContext as R, SmarticoScript as S, TOOLTIP_HIDE_TIMEOUT as T, MultiWalletDataProvider as U, useSecondStepDepositMulti as V, useSecondStepWithdrawMulti as W, useResponsibleGaming as X, useResponsibleGamingV2 as Y, getFormattedDepositLimitPeriod as Z, formatTransactionMethodId as _, affiseTriggerRegistration as a, useSignupConfig as a$, getFildNameWithCurrency as a0, splitArrIntoChunks as a1, isCasinoGameType as a2, getAgeOptions as a3, getCountries as a4, getCountryStates as a5, debounce as a6, getRandomArbitrary as a7, getCurrencyConfig as a8, round as a9, CasinoScopesMap as aA, useCasinoGames as aB, useClickOutside as aC, useCollapseHeight as aD, useCollapseMargin as aE, useCountryStates as aF, useDidUpdateEffect as aG, useDocumentVisible as aH, useWebsocketUpdates as aI, useFindReferral as aJ, GtagEvents as aK, useGtag as aL, useHost as aM, useHostV2 as aN, useLayoutProfileConfig as aO, useLayoutCasinoConfig as aP, useLazyLoad as aQ, useMainMarketOdds as aR, useOneStepCpfSignup as aS, usePersonalDetailsVerificationConfig as aT, usePoliciesPagesConfig as aU, usePrematchUpcomingWidgetConfig as aV, usePrematchTopWidgetConfig as aW, useUpcomingLiveWidgetConfig as aX, usePrevious as aY, useProfileDetailsConfig as aZ, useRuntimeConfig as a_, numberWithCommas as aa, formatCurrency as ab, getUtcDateFromString as ac, sortMarketGroups as ad, convertMarketsIntoMarketGroups as ae, formatNumber as af, convertGamesToSports as ag, convertGamesToTournaments as ah, calculateRestOfDayInHoursRange as ai, moveMarketToFirstByIndex as aj, msToTime as ak, fetchLocalTranslations as al, getTranslations as am, getMobileTranslations as an, getDesktopTranslations as ao, useAccountConfig as ap, useAccountConfigV2 as aq, ErrorColors as ar, BetSlipErrorKeys as as, ErrorKeys as at, ERROR_CODES as au, NEED_TO_REMOVE_ERROR_CODES as av, OUTCOME_CHANGED_ERROR_CODES as aw, useBetValidation as ax, useBonusPagesConfig as ay, CasinoScopeEnum as az, useCreateSubuser as b, MultiBetBonusProviderV2 as b$, useSignupConfigV2 as b0, useSiteConfig as b1, formatSearchParamsToString as b2, useSearchParamsQuery as b3, useSportsbookConfig as b4, usePathnameWithLocal as b5, useVerificationMethods as b6, IOSAuthorizationMiddleware as b7, AffiliateTrackerContext as b8, AffiliateTrackerProvider as b9, ConfigProvider as bA, prepareConfigsV2 as bB, ConfigContextV2 as bC, ConfigProviderV2 as bD, CrmContext as bE, CrmProvider as bF, CrmContextV2 as bG, CrmProviderV2 as bH, UserAccountContext as bI, UserAccountProvider as bJ, UserAccountContextV2 as bK, UserAccountProviderV2 as bL, VerificationDocumentsContext as bM, VerificationDocumentsProvider as bN, AuthContext as bO, AuthProvider as bP, ExchangeRatesContext as bQ, ExchangeRatesProvider as bR, ExchangeRatesContextV2 as bS, ExchangeRatesProviderV2 as bT, ModalsContext as bU, ModalsProvider as bV, ModalsContextV2 as bW, ModalsProviderV2 as bX, MultiBetBonusContext as bY, MultiBetBonusProvider as bZ, MultiBetBonusContextV2 as b_, BrowserStorageIdsEnum as ba, BrowserStorageContext as bb, BrowserStorageProvider as bc, FavoriteEventsContext as bd, FavoriteEventsProvider as be, ClientBFFContext as bf, ClientProvider as bg, BannersContext as bh, BannersProvider as bi, PopupBannersContext as bj, PopupBannersProvider as bk, SiteNotificationsContext as bl, SiteNotificationsProvider as bm, WebsocketContext as bn, WebsocketProvider as bo, I18nextProvider as bp, CasinoFavoritesContext as bq, CasinoFavoritesProvider as br, ChatContext as bs, ChatProvider as bt, ChatServiceContext as bu, ChatServiceProvider as bv, LocaleContext as bw, LocaleProvider as bx, prepareConfigs as by, ConfigContext as bz, commonjsGlobal as c, FeedContext as c0, FeedProvider as c1, ReferralReportContext as c2, ReferralReportProvider as c3, BetSlipContext as c4, BetSlipProvider as c5, BetSlipContextV2 as c6, BetSlipProviderV2 as c7, RuntimeConfigContext as c8, RuntimeConfigProvider as c9, DEFAULT_PAGINATION as ca, becomeReferralValidationSchema as cb, changePasswordValidationSchema as cc, createSubagentValidationSchema as cd, depositLimitsValidationSchema as ce, loginFormSchema as cf, selfExclusionValidationSchema as cg, PASSWORD_RULE as ch, signupValidationSchema as ci, cpfSignupValidationSchema as cj, cpfSignupValidationSchemaBrazilian as ck, afroSignupValidationSchema as cl, userDocumentValidationSchema as cm, userInfoValidationSchema as cn, userPreferencesValidationSchema as co, AgentConfigContext as d, AgentConfigProvider as e, getReportSummuryData as f, getDefaultExportFromCjs as g, CpfSignupProvider as h, getStringWithMask as i, getFormattedCPF as j, useFirstStepSignup as k, useSecondStepSignup as l, SmarticoScriptV2 as m, getLimits as n, DefaultWalletDataProvider as o, useLatestExchangeRate as p, useCoreDepositFormBank as q, useCoreDepositFormCrypto as r, useCoreWithdrawalCryptoForm as s, useCoreWithdrawalCryptoConfirmation as t, useAgentPlayersList as u, CoreWithdrawalCommonContext as v, CoreWithdrawalCommonProvider as w, useCoreWithdrawalBankConfirmation as x, useCoreWithdrawalFormBank as y, useCoreWithdrawalBankDetails as z };
//# sourceMappingURL=index-DnC1WZne.js.map
